// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const SYS: IClientSubSystemModel = {
  Code: 'SYS',
  DisplayLabel: 'Systemadministration',
  BusinessModels: {
    SYSAdressanvandning: {
      CollectionName: 'SYSAdressanvandning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Adressanvandning',
        Abstract: false,
        SOLabel: 'Adressanvändning',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSAdressanvandnings primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSAdressanvandnings versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSAdressanvandnings fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Behandling',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANDAMAL: {
          AttributeName: 'ANDAMAL',
          DisplayLabel: 'Ändamål',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REF_FRAN_TABELL: {
          AttributeName: 'REF_FRAN_TABELL',
          DisplayLabel: 'Refereras från tabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SUBSYSTEMCODE: {
          AttributeName: 'SUBSYSTEMCODE',
          DisplayLabel: 'Delprogram',
          Hint: 'Anläggningsredovisning/BJ/Bokning/Diarium/Ekonomi/Grav/Kremationsjournal/Kundreskontra/Leverantörsreskontra/Musik/Order/Fakturering/Systemadministration/Tidredovisning',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREDOVISNING', 'Anläggningsredovisning'], ['BOKNING', 'Bokning'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['KUNDRESKONTRA', 'Kundreskontra'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['MUSIK', 'Musik'], ['ORDER_FAKTURERING', 'Order/Fakturering'], ['SYSTEMADMINISTRATION', 'Systemadministration'], ['TIDREDOVISNING', 'Tidredovisning']]),
          EnumSortValues: new Map([['ANLAGGNINGSREDOVISNING', 'AR'], ['BOKNING', 'BO'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['KREMATIONSJOURNAL', 'KJ'], ['KUNDRESKONTRA', 'KR'], ['LEVERANTORSRESKONTRA', 'LR'], ['MUSIK', 'MU'], ['ORDER_FAKTURERING', 'OF'], ['SYSTEMADMINISTRATION', 'SYS'], ['TIDREDOVISNING', 'TI']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREDOVISNING=Anläggningsredovisning;BOKNING=Bokning;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;KREMATIONSJOURNAL=Kremationsjournal;KUNDRESKONTRA=Kundreskontra;LEVERANTORSRESKONTRA=Leverantörsreskontra;MUSIK=Musik;ORDER_FAKTURERING=Order/Fakturering;SYSTEMADMINISTRATION=Systemadministration;TIDREDOVISNING=Tidredovisning"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        LAGRINGSDIFFERENS_VARDE: {
          AttributeName: 'LAGRINGSDIFFERENS_VARDE',
          DisplayLabel: 'Utökad lagringstid',
          Hint: 'Lagringstid sparas som månad men visas som år och månad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="å=12;m=1";DefaultGroup="m";GroupTexts="å=å;år=å;m=m;mån=m;månad=m;månader=m"',
          FormatterDisplayParams: 'Groups="år=12;månader/månad=1";GroupNameSep=" "',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        RENSNINGSTYP: {
          AttributeName: 'RENSNINGSTYP',
          DisplayLabel: 'Typ av rensning',
          Hint: 'Avidentifiera/Förstöra',
          DataType: 'Enum',
          EnumValues: new Map([['AVIDENTIFIERA', 'Avidentifiera'], ['FORSTORA', 'Förstöra']]),
          EnumSortValues: new Map([['AVIDENTIFIERA', 'A'], ['FORSTORA', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVIDENTIFIERA=Avidentifiera;FORSTORA=Förstöra"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        UPPDATERINGSTYP: {
          AttributeName: 'UPPDATERINGSTYP',
          DisplayLabel: 'Ska uppdatering ske',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LAGLIG_GRUND: {
          AttributeName: 'LAGLIG_GRUND',
          DisplayLabel: 'ANVÄNDS INTE  Laglig grund',
          Hint: 'Samtycke/Intresseavvägning/Avtal/Rättslig förpliktelse',
          DataType: 'Enum',
          EnumValues: new Map([['SAMTYCKE', 'Samtycke'], ['INTRESSEAVVAGNING', 'Intresseavvägning'], ['AVTAL', 'Avtal'], ['RATTSLIG_FORPLIKTELSE', 'Rättslig förpliktelse']]),
          EnumSortValues: new Map([['SAMTYCKE', 'S'], ['INTRESSEAVVAGNING', 'I'], ['AVTAL', 'A'], ['RATTSLIG_FORPLIKTELSE', 'R']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SAMTYCKE=Samtycke;INTRESSEAVVAGNING=Intresseavvägning;AVTAL=Avtal;RATTSLIG_FORPLIKTELSE=Rättslig förpliktelse"',
        },
        LAGLIG_GRUND_MOTIVERING: {
          AttributeName: 'LAGLIG_GRUND_MOTIVERING',
          DisplayLabel: 'ANVÄNDS INTE  Motivering av laglig grund',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RefDateFieldLabel: {
          AttributeName: 'RefDateFieldLabel',
          DisplayLabel: 'Referensdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TimeToKeep: {
          AttributeName: 'TimeToKeep',
          DisplayLabel: 'Tid för lagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'ANVÄNDS INTE  Status',
          Hint: 'Under utredning/Ej godkänd/Godkänd/Redigeras',
          DataType: 'Enum',
          EnumValues: new Map([['UNDER_UTREDNING', 'Under utredning'], ['EJ_GODKAND', 'Ej godkänd'], ['GODKAND', 'Godkänd'], ['REDIGERAS', 'Redigeras']]),
          EnumSortValues: new Map([['UNDER_UTREDNING', 'I'], ['EJ_GODKAND', 'E'], ['GODKAND', 'G'], ['REDIGERAS', 'R']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UNDER_UTREDNING=Under utredning;EJ_GODKAND=Ej godkänd;GODKAND=Godkänd;REDIGERAS=Redigeras"',
        },
        LAGRINGSDIFFERENS_VARDE_STD: {
          AttributeName: 'LAGRINGSDIFFERENS_VARDE_STD',
          DisplayLabel: 'ANVÄNDS INTE Std, utökad lagringstid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="å=12;m=1";DefaultGroup="å";GroupTexts="å=å;år=å;m=m;mån=m;månad=m;månader=m"',
          FormatterDisplayParams: 'Groups="år=12;månader/månad=1"',
        },
        LAGLIG_GRUND_STD: {
          AttributeName: 'LAGLIG_GRUND_STD',
          DisplayLabel: 'ANVÄNDS INTE  Std, lagring grund',
          Hint: 'Samtycke/Intresseavvägning/Avtal/Rättslig förpliktelse',
          DataType: 'Enum',
          EnumValues: new Map([['SAMTYCKE', 'Samtycke'], ['INTRESSEAVVAGNING', 'Intresseavvägning'], ['AVTAL', 'Avtal'], ['RATTSLIG_FORPLIKTELSE', 'Rättslig förpliktelse']]),
          EnumSortValues: new Map([['SAMTYCKE', 'S'], ['INTRESSEAVVAGNING', 'I'], ['AVTAL', 'A'], ['RATTSLIG_FORPLIKTELSE', 'R']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SAMTYCKE=Samtycke;INTRESSEAVVAGNING=Intresseavvägning;AVTAL=Avtal;RATTSLIG_FORPLIKTELSE=Rättslig förpliktelse"',
        },
        LAGLIG_GRUND_MOTIVERING_STD: {
          AttributeName: 'LAGLIG_GRUND_MOTIVERING_STD',
          DisplayLabel: 'SANVÄNDS INTE td, lagring grund motivering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'ANVÄNDS INTE Status, datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        STATUS_USER_ID: {
          AttributeName: 'STATUS_USER_ID',
          DisplayLabel: 'ANVÄNDS INTE Status, user id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Relevant: {
          AttributeName: 'Relevant',
          DisplayLabel: 'ANVÄNDS INTE Relevant',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        MINSTA_LAGRING_TEXT: {
          AttributeName: 'MINSTA_LAGRING_TEXT',
          DisplayLabel: 'Minsta lagringstid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERSKAT_ID: {
          AttributeName: 'PERSKAT_ID',
          DisplayLabel: 'Personkategori, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LAGRINGSTYP: {
          AttributeName: 'LAGRINGSTYP',
          DisplayLabel: 'Lagringstyp',
          Hint: 'Standard/Utökad lagringstid/Ej vald',
          DataType: 'Enum',
          EnumValues: new Map([['STANDARD', 'Standard'], ['UTOKAD_LAGRINGSTID', 'Utökad lagringstid'], ['EJ_VALD', 'Ej vald']]),
          EnumSortValues: new Map([['STANDARD', 'S'], ['UTOKAD_LAGRINGSTID', 'U'], ['EJ_VALD', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STANDARD=Standard;UTOKAD_LAGRINGSTID=Utökad lagringstid;EJ_VALD=Ej vald"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        RegelTyp: {
          AttributeName: 'RegelTyp',
          DisplayLabel: 'Typ av regel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        GALLRINGSTYP: {
          AttributeName: 'GALLRINGSTYP',
          DisplayLabel: 'Gallringstyp',
          Hint: 'Gallras ej/Användarstyrd/Programstyrd/Odefinierad',
          DataType: 'Enum',
          EnumValues: new Map([['GALLRAS_EJ', 'Gallras ej'], ['ANVANDARSTYRD', 'Användarstyrd'], ['PROGRAMSTYRD', 'Programstyrd'], ['ODEFINIERAD', 'Odefinierad']]),
          EnumSortValues: new Map([['GALLRAS_EJ', 'E'], ['ANVANDARSTYRD', 'A'], ['PROGRAMSTYRD', 'P'], ['ODEFINIERAD', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GALLRAS_EJ=Gallras ej;ANVANDARSTYRD=Användarstyrd;PROGRAMSTYRD=Programstyrd;ODEFINIERAD=Odefinierad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GallrasAutomatiskt: {
          AttributeName: 'GallrasAutomatiskt',
          DisplayLabel: 'Gallras automatiskt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UTOKAD_LAGRING_MOTIVERING: {
          AttributeName: 'UTOKAD_LAGRING_MOTIVERING',
          DisplayLabel: 'Motivering, utökad lagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GallrasAutomatiskt2: {
          AttributeName: 'GallrasAutomatiskt2',
          DisplayLabel: 'Gallras automatiskt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        UTOKAD_LAGRING_TILLATEN: {
          AttributeName: 'UTOKAD_LAGRING_TILLATEN',
          DisplayLabel: 'Utökad lagring tillåten',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'ANVÄNDS INTE  Användare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Personkategori: {
          AssociationName: 'Personkategori',
          DisplayLabel: 'Personkategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSPersonkategori',
          AssociatedComponentName: 'Personkategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        kategorier: {
          AssociationName: 'kategorier',
          DisplayLabel: 'ANVÄNDS INTE kategorier',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSAdressanvandningKategori',
          AssociatedComponentName: 'AdressanvandningKategori',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        rutiner: {
          AssociationName: 'rutiner',
          DisplayLabel: 'rutiner',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdressanvandningrutin',
          AssociatedComponentName: 'Adressanvandningrutin',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Gallringslogg: {
          AssociationName: 'Gallringslogg',
          DisplayLabel: 'Gallringslogg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdranvGallrLogg',
          AssociatedComponentName: 'AdranvGallrLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSAdressanvandningKategori: {
      CollectionName: 'SYSAdressanvandningKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdressanvandningKategori',
        Abstract: false,
        SOLabel: 'Adressanvändning kategori',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSAdressanvandningKategoris primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSAdressanvandningKategoris versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSAdressanvandningKategoris fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDNING_ID: {
          AttributeName: 'ANVANDNING_ID',
          DisplayLabel: 'Användning ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Kategori',
          Hint: 'Namn/Adress/Kontaktuppgifter/Persnr/Tillhörighet',
          DataType: 'Enum',
          EnumValues: new Map([['NAMN', 'Namn'], ['ADRESS', 'Adress'], ['KONTAKTUPPGIFTER', 'Kontaktuppgifter'], ['PERSNR', 'Persnr'], ['TILLHORIGHET', 'Tillhörighet']]),
          EnumSortValues: new Map([['NAMN', 'N'], ['ADRESS', 'A'], ['KONTAKTUPPGIFTER', 'K'], ['PERSNR', 'P'], ['TILLHORIGHET', 'T']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NAMN=Namn;ADRESS=Adress;KONTAKTUPPGIFTER=Kontaktuppgifter;PERSNR=Persnr;TILLHORIGHET=Tillhörighet"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSAdressanvandningrutin: {
      CollectionName: 'SYSAdressanvandningrutin',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Adressanvandningrutin',
        Abstract: false,
        SOLabel: 'Adressanvändning rutin',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSAdressanvandningrutins primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSAdressanvandningrutins versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSAdressanvandningrutins fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDNING_ID: {
          AttributeName: 'ANVANDNING_ID',
          DisplayLabel: 'Användning ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ROUTINE_ID: {
          AttributeName: 'ROUTINE_ID',
          DisplayLabel: 'Rutin id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        routinename: {
          AttributeName: 'routinename',
          DisplayLabel: 'Rutinnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSAccesstoken: {
      CollectionName: 'SYSAccesstoken',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Accesstoken',
        Abstract: false,
        SOLabel: 'Access token',
        SOGLabel: 'Access token',
        SBLabel: 'Access token',
        SBGLabel: 'Access token',
        POLabel: 'Access token',
        POGLabel: 'Access token',
        PBLabel: 'Access token',
        PBGLabel: 'Access token',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Access token primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Access token versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Access token id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Access token fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TOKEN: {
          AttributeName: 'TOKEN',
          DisplayLabel: 'TOKEN',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        APP_ID: {
          AttributeName: 'APP_ID',
          DisplayLabel: 'APP_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'USER_ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GILTIG_TOM: {
          AttributeName: 'GILTIG_TOM',
          DisplayLabel: 'GILTIG_TOM',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        anvandare: {
          AssociationName: 'anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSAdminDatabase: {
      CollectionName: 'SYSAdminDatabase',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdminDatabase',
        Abstract: false,
        SOLabel: 'Databas',
        SOGLabel: 'Databas',
        SBLabel: 'Databasen',
        SBGLabel: 'Databasens',
        POLabel: 'Databaser',
        POGLabel: 'Databasers',
        PBLabel: 'Databaserna',
        PBGLabel: 'Databasernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Databasens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Databasens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Databasens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Databasens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Databasnamn i Aveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        CUSTNO: {
          AttributeName: 'CUSTNO',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SERVER_NAME: {
          AttributeName: 'SERVER_NAME',
          DisplayLabel: 'Servernamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 300,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DB_NAME: {
          AttributeName: 'DB_NAME',
          DisplayLabel: 'Databasnamn på servern',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 130,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        SERVER_GROUP: {
          AttributeName: 'SERVER_GROUP',
          DisplayLabel: 'Serveranvändargrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RELEASE_VERSION: {
          AttributeName: 'RELEASE_VERSION',
          DisplayLabel: 'Releaseversion',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Databastyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORGNR: {
          AttributeName: 'ORGNR',
          DisplayLabel: 'Organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 500,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SUBSYSTEMS: {
          AttributeName: 'SUBSYSTEMS',
          DisplayLabel: 'Delprogram',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KORT_IP: {
          AttributeName: 'KORT_IP',
          DisplayLabel: 'IP-nummer till kort/tagg-terminaler',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KORT_KRAV: {
          AttributeName: 'KORT_KRAV',
          DisplayLabel: 'Kort krävs på terminalerna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Groups: {
          AssociationName: 'Groups',
          DisplayLabel: 'Grupper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdminDatabaseGroup',
          AssociatedComponentName: 'AdminDatabaseGroup',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSAdminDatabaseGroup: {
      CollectionName: 'SYSAdminDatabaseGroup',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdminDatabaseGroup',
        Abstract: false,
        SOLabel: 'Databasgrupp',
        SOGLabel: 'Databasgrupps',
        SBLabel: 'Databasgruppen',
        SBGLabel: 'Databasgruppens',
        POLabel: 'Databasgrupper',
        POGLabel: 'Databasgruppers',
        PBLabel: 'Databasgrupperna',
        PBGLabel: 'Databasgruppernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Databasgruppens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Databasgruppens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Databasgruppens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Databasgruppens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Group: {
          AssociationName: 'Group',
          DisplayLabel: 'Grupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdminGroup',
          AssociatedComponentName: 'AdminGroup',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSAdminGroup: {
      CollectionName: 'SYSAdminGroup',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdminGroup',
        Abstract: false,
        SOLabel: 'Grupp',
        SOGLabel: 'Grupps',
        SBLabel: 'Gruppen',
        SBGLabel: 'Gruppens',
        POLabel: 'Grupper',
        POGLabel: 'Gruppers',
        PBLabel: 'Grupperna',
        PBGLabel: 'Gruppernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gruppens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gruppens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gruppens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gruppens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn/Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning/Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MEMBERS: {
          AttributeName: 'MEMBERS',
          DisplayLabel: 'Medlemmar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
      },
      Associations: {
      },
    },
    SYSAdminSetting: {
      CollectionName: 'SYSAdminSetting',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdminSetting',
        Abstract: false,
        SOLabel: 'Inställning',
        SOGLabel: 'Inställnings',
        SBLabel: 'Inställningen',
        SBGLabel: 'Inställningens',
        POLabel: 'Inställninger',
        POGLabel: 'Inställningers',
        PBLabel: 'Inställningerna',
        PBGLabel: 'Inställningernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inställningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inställningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Inställningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inställningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        VALUE: {
          AttributeName: 'VALUE',
          DisplayLabel: 'Värde',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 500,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    SYSAdminLicence: {
      CollectionName: 'SYSAdminLicence',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdminLicence',
        Abstract: false,
        SOLabel: 'Licens',
        SOGLabel: 'Licens',
        SBLabel: 'Licensen',
        SBGLabel: 'Licensens',
        POLabel: 'Licenser',
        POGLabel: 'Licensers',
        PBLabel: 'Licenserna',
        PBGLabel: 'Licensernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Licensens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Licensens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Licensens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Licensens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Licensnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Licensinnehavare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        LICENCE_KEY: {
          AttributeName: 'LICENCE_KEY',
          DisplayLabel: 'Licensnyckel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
      },
      Associations: {
        Groups: {
          AssociationName: 'Groups',
          DisplayLabel: 'Grupper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdminLicenceGroup',
          AssociatedComponentName: 'AdminLicenceGroup',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSAdminLicenceGroup: {
      CollectionName: 'SYSAdminLicenceGroup',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdminLicenceGroup',
        Abstract: false,
        SOLabel: 'Licensgrupp',
        SOGLabel: 'Licensgrupps',
        SBLabel: 'Licensgruppen',
        SBGLabel: 'Licensgruppens',
        POLabel: 'Licensgrupper',
        POGLabel: 'Licensgruppers',
        PBLabel: 'Licensgrupperna',
        PBGLabel: 'Licensgruppernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Licensgruppens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Licensgruppens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Licensgruppens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Licensgruppens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Group: {
          AssociationName: 'Group',
          DisplayLabel: 'Grupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdminGroup',
          AssociatedComponentName: 'AdminGroup',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSAdminUtbInstallation: {
      CollectionName: 'SYSAdminUtbInstallation',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdminUtbInstallation',
        Abstract: false,
        SOLabel: 'Utbildningsinstallation',
        SOGLabel: 'Utbildningsinstallations',
        SBLabel: 'Utbildningsinstallationen',
        SBGLabel: 'Utbildningsinstallationens',
        POLabel: 'Utbildningsinstallationer',
        POGLabel: 'Utbildningsinstallationers',
        PBLabel: 'Utbildningsinstallationerna',
        PBGLabel: 'Utbildningsinstallationernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utbildningsinstallationens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utbildningsinstallationens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utbildningsinstallationens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utbildningsinstallationens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERVER_NAME: {
          AttributeName: 'SERVER_NAME',
          DisplayLabel: 'Servernamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 300,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DB_NAME: {
          AttributeName: 'DB_NAME',
          DisplayLabel: 'Malldatabas',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 130,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DB_BACKUP_FILE: {
          AttributeName: 'DB_BACKUP_FILE',
          DisplayLabel: 'Mallbackupfil',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DB_DIR: {
          AttributeName: 'DB_DIR',
          DisplayLabel: 'Malldatabasmapp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        WEBAVENY_URL: {
          AttributeName: 'WEBAVENY_URL',
          DisplayLabel: 'WebAveny URL',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NYA_AVENY_URL: {
          AttributeName: 'NYA_AVENY_URL',
          DisplayLabel: 'Nya Aveny URL',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CUSTNO: {
          AttributeName: 'CUSTNO',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GAS: {
          AttributeName: 'GAS',
          DisplayLabel: 'GAS',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ROLE_BASED: {
          AttributeName: 'ROLE_BASED',
          DisplayLabel: 'Rollbaserad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MAX_AGE_DAYS: {
          AttributeName: 'MAX_AGE_DAYS',
          DisplayLabel: 'Antal dagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
      },
    },
    SYSAIAttachment: {
      CollectionName: 'SYSAIAttachment',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AIAttachment',
        Abstract: false,
        SOLabel: 'AI Attachment',
        SOGLabel: 'AI Attachment',
        SBLabel: 'AI Attachment',
        SBGLabel: 'AI Attachment',
        POLabel: 'AI Attachment',
        POGLabel: 'AI Attachment',
        PBLabel: 'AI Attachment',
        PBGLabel: 'AI Attachment',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'AI Attachment primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'AI Attachment versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'AI Attachment id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MEDDELANDE_ID: {
          AttributeName: 'MEDDELANDE_ID',
          DisplayLabel: 'Meddelande',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEXT_DATA: {
          AttributeName: 'TEXT_DATA',
          DisplayLabel: 'TEXT_DATA',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'BESKRIVNING',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'TYP',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Meddelande: {
          AssociationName: 'Meddelande',
          DisplayLabel: 'Meddelande',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAIMeddelande',
          AssociatedComponentName: 'AIMeddelande',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSAIChat: {
      CollectionName: 'SYSAIChat',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'AIChat',
        Abstract: false,
        SOLabel: 'AI Chatt',
        SOGLabel: 'AI Chatts',
        SBLabel: 'AI Chatten',
        SBGLabel: 'AI Chattens',
        POLabel: 'AI Chattar',
        POGLabel: 'AI Chattars',
        PBLabel: 'AI Chattarna',
        PBGLabel: 'AI Chattarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'AI Chattens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'AI Chattens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'AI Chattens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKAPAD_AV: {
          AttributeName: 'SKAPAD_AV',
          DisplayLabel: 'Skapad av',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKAPAD_TID: {
          AttributeName: 'SKAPAD_TID',
          DisplayLabel: 'Skapad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MODEL: {
          AttributeName: 'MODEL',
          DisplayLabel: 'Model',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SAMMANFATTNING: {
          AttributeName: 'SAMMANFATTNING',
          DisplayLabel: 'Sammanfattning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENDPOINT_KEY: {
          AttributeName: 'ENDPOINT_KEY',
          DisplayLabel: 'Endpoint',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INPUT_TOKEN_USAGE: {
          AttributeName: 'INPUT_TOKEN_USAGE',
          DisplayLabel: 'Input token usage',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        OUTPUT_TOKEN_USAGE: {
          AttributeName: 'OUTPUT_TOKEN_USAGE',
          DisplayLabel: 'Output token usage',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Meddelanden: {
          AssociationName: 'Meddelanden',
          DisplayLabel: 'Meddelanden',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAIMeddelande',
          AssociatedComponentName: 'AIMeddelande',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUser: {
      CollectionName: 'SYSUser',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '7001'], ['AllowEdit', '15006']]),
      RootType: {
        TypeValue: 'User',
        Abstract: false,
        SOLabel: 'Användare',
        SOGLabel: 'Användare',
        SBLabel: 'Användaren',
        SBGLabel: 'Användaren',
        POLabel: 'Användare',
        POGLabel: 'Användare',
        PBLabel: 'Användarna',
        PBGLabel: 'Användarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Användaren primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Användaren versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Användaren id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Användaren fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGNATURE: {
          AttributeName: 'SIGNATURE',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        FIRSTNAME: {
          AttributeName: 'FIRSTNAME',
          DisplayLabel: 'Förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        LASTNAME: {
          AttributeName: 'LASTNAME',
          DisplayLabel: 'Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        PWD: {
          AttributeName: 'PWD',
          DisplayLabel: 'Lösenord',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PHONE: {
          AttributeName: 'PHONE',
          DisplayLabel: 'Telefonnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        LOCATION: {
          AttributeName: 'LOCATION',
          DisplayLabel: 'Lokal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övrigt',
        },
        EMAIL: {
          AttributeName: 'EMAIL',
          DisplayLabel: 'E-postadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        SYSADM: {
          AttributeName: 'SYSADM',
          DisplayLabel: 'Systemadministratör',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        DB_SIGNATURE: {
          AttributeName: 'DB_SIGNATURE',
          DisplayLabel: 'Signatur i databasen',
          Hint: 'Ex Aveny_Sysadm',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 80,
          AttributeGroup: 'Övrigt',
          Properties: new Map([['NO_CONDITION', 'Y;ffIgnoreChanges=Y']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOBEGR_ENL_STALLE: {
          AttributeName: 'KONTOBEGR_ENL_STALLE',
          DisplayLabel: 'Kodbegr enl arbetsställe',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        ARBETSSTALLE_ID: {
          AttributeName: 'ARBETSSTALLE_ID',
          DisplayLabel: 'Arbetsställe, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Name: {
          AttributeName: 'Name',
          DisplayLabel: 'Namn',
          Hint: 'Förnamn Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        NameSign: {
          AttributeName: 'NameSign',
          DisplayLabel: 'Namn och signatur',
          Hint: 'Förnamn Efternamn (Signatur)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        sqlLNameFNameSign: {
          AttributeName: 'sqlLNameFNameSign',
          DisplayLabel: 'sqlLNameFNameSign',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Behorighetsbegransning: {
          AttributeName: 'Behorighetsbegransning',
          DisplayLabel: 'Kodbegränsning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'Int', defaultValue: ''}},
        },
        LNamFNameEMail: {
          AttributeName: 'LNamFNameEMail',
          DisplayLabel: 'LNamFNameEMail',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Arbetsstallet: {
          AttributeName: 'Arbetsstallet',
          DisplayLabel: 'Arbetsställe',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Fullname: {
          AttributeName: 'Fullname',
          DisplayLabel: 'Fullname',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontobegrID: {
          AttributeName: 'KontobegrID',
          DisplayLabel: 'KontobegrId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'Int', defaultValue: ''}},
        },
        KontobegrStalleId: {
          AttributeName: 'KontobegrStalleId',
          DisplayLabel: 'KontobegrStalleId',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'KPLAN_ID': {type: 'Int', defaultValue: ''}},
        },
        SERVER: {
          AttributeName: 'SERVER',
          DisplayLabel: 'SMTP-server för mailutskick',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Övrigt',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        SMTP_USER: {
          AttributeName: 'SMTP_USER',
          DisplayLabel: 'Smtp användare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        SMTP_PASS: {
          AttributeName: 'SMTP_PASS',
          DisplayLabel: 'Smtp lösen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USEAUTH: {
          AttributeName: 'USEAUTH',
          DisplayLabel: 'Kräver inloggning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELAR_ARBPLATS_MED: {
          AttributeName: 'DELAR_ARBPLATS_MED',
          DisplayLabel: 'Delar arbetsplats med, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DelarPlatsMed: {
          AttributeName: 'DelarPlatsMed',
          DisplayLabel: 'Delar arbetsplats med',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RESBEH_VIEW_ID: {
          AttributeName: 'RESBEH_VIEW_ID',
          DisplayLabel: 'Urval för resursbehörighet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Adress',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PWD_METHOD: {
          AttributeName: 'PWD_METHOD',
          DisplayLabel: 'Lösenordshashmetod',
          Hint: 'Metod för att skapa sqllösenord. Förut 0, nu 1 (blandat siffror, bokstäver)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PWD_SET_DATE: {
          AttributeName: 'PWD_SET_DATE',
          DisplayLabel: 'Lösenordsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        PWD_FORCE_CHANGE: {
          AttributeName: 'PWD_FORCE_CHANGE',
          DisplayLabel: 'Kräv lösenordsbyte',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifNone',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        PWD_CONSTRLEVEL_CHECK: {
          AttributeName: 'PWD_CONSTRLEVEL_CHECK',
          DisplayLabel: 'Kontrollera mot lösenordsregler',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        LNameFname: {
          AttributeName: 'LNameFname',
          DisplayLabel: 'LNameFname',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATISTIKRAPPORTERING: {
          AttributeName: 'STATISTIKRAPPORTERING',
          DisplayLabel: 'Statistikrapportering, aktuell resurs',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FNameFirstLName: {
          AttributeName: 'FNameFirstLName',
          DisplayLabel: 'Förnamn och initial',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALLANVANDARE: {
          AttributeName: 'MALLANVANDARE',
          DisplayLabel: 'Mallanvändare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ResBehIsA10: {
          AttributeName: 'ResBehIsA10',
          DisplayLabel: 'Har ett Aveny10-urval på resursbehörigheten',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RESBEH_SEL_ID: {
          AttributeName: 'RESBEH_SEL_ID',
          DisplayLabel: 'Resursbehörighet Aveny10-format',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontobegrName: {
          AttributeName: 'KontobegrName',
          DisplayLabel: 'Kodbegränsning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeParams: {'KPLAN_ID': {type: 'String', defaultValue: ''}},
        },
        KontobegransningBeskrivning: {
          AttributeName: 'KontobegransningBeskrivning',
          DisplayLabel: 'Kodbegränsning, beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Roller: {
          AttributeName: 'Roller',
          DisplayLabel: 'Roller',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MALLANV_STYRN_INST_1: {
          AttributeName: 'MALLANV_STYRN_INST_1',
          DisplayLabel: 'Behörig till bokföringsgrupper',
          Hint: 'Ej behörig/Behörig till alla typer/Behörig till angivna typer/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_TYPER', 'Behörig till alla typer'], ['BEHORIG_TILL_ANGIVNA_TYPER', 'Behörig till angivna typer'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_TYPER', 'A'], ['BEHORIG_TILL_ANGIVNA_TYPER', 'T'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_TYPER=Behörig till alla typer;BEHORIG_TILL_ANGIVNA_TYPER=Behörig till angivna typer;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_2: {
          AttributeName: 'MALLANV_STYRN_INST_2',
          DisplayLabel: 'Behörig till faktureringsgrupper',
          Hint: 'Ej behörig/Behörig till alla typer/Behörig till angivna typer/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_TYPER', 'Behörig till alla typer'], ['BEHORIG_TILL_ANGIVNA_TYPER', 'Behörig till angivna typer'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_TYPER', 'A'], ['BEHORIG_TILL_ANGIVNA_TYPER', 'T'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_TYPER=Behörig till alla typer;BEHORIG_TILL_ANGIVNA_TYPER=Behörig till angivna typer;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_3: {
          AttributeName: 'MALLANV_STYRN_INST_3',
          DisplayLabel: 'Behörig till bokningsgrupper',
          Hint: 'Ej behörig/Behörig till alla bokningsgrupper/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_BOKNINGSGRUPPER', 'Behörig till alla bokningsgrupper'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_BOKNINGSGRUPPER', 'A'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_BOKNINGSGRUPPER=Behörig till alla bokningsgrupper;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_4: {
          AttributeName: 'MALLANV_STYRN_INST_4',
          DisplayLabel: 'Behörig till diariegrupper',
          Hint: 'Ej behörig/Behörig till alla diariegrupper/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_DIARIEGRUPPER', 'Behörig till alla diariegrupper'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_DIARIEGRUPPER', 'A'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_DIARIEGRUPPER=Behörig till alla diariegrupper;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_5: {
          AttributeName: 'MALLANV_STYRN_INST_5',
          DisplayLabel: 'Behörig till anläggningsgrupper',
          Hint: 'Ej behörig/Behörig till alla anläggninggrupper/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_ANLAGGNINGGRUPPER', 'Behörig till alla anläggninggrupper'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_ANLAGGNINGGRUPPER', 'A'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_ANLAGGNINGGRUPPER=Behörig till alla anläggninggrupper;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_6: {
          AttributeName: 'MALLANV_STYRN_INST_6',
          DisplayLabel: 'Behörig till tidredovisningsgrupper',
          Hint: 'Ej behörig/Behörig till alla tidredovisningsgrupper/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_TIDREDOVISNINGSGRUPPER', 'Behörig till alla tidredovisningsgrupper'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_TIDREDOVISNINGSGRUPPER', 'A'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_TIDREDOVISNINGSGRUPPER=Behörig till alla tidredovisningsgrupper;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_7: {
          AttributeName: 'MALLANV_STYRN_INST_7',
          DisplayLabel: 'Behörig till gåvogrupper',
          Hint: 'Ej behörig/Behörig till alla gåvogrupper/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_GAVOGRUPPER', 'Behörig till alla gåvogrupper'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_GAVOGRUPPER', 'A'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_GAVOGRUPPER=Behörig till alla gåvogrupper;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_8: {
          AttributeName: 'MALLANV_STYRN_INST_8',
          DisplayLabel: 'Behörig till budgetgrupper',
          Hint: 'Ej behörig/Behörig till alla budgetgrupper/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_BUDGETGRUPPER', 'Behörig till alla budgetgrupper'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_BUDGETGRUPPER', 'A'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_BUDGETGRUPPER=Behörig till alla budgetgrupper;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALLANV_STYRN_INST_9: {
          AttributeName: 'MALLANV_STYRN_INST_9',
          DisplayLabel: 'Behörig till bisättningslokaler',
          Hint: 'Ej behörig/Behörig till alla bisättningslokaler/Behörighet anges per användare',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['BEHORIG_TILL_ALLA_BISATTNINGSLOKALER', 'Behörig till alla bisättningslokaler'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'Behörighet anges per användare']]),
          EnumSortValues: new Map([['EJ_BEHORIG', 'E'], ['BEHORIG_TILL_ALLA_BISATTNINGSLOKALER', 'A'], ['BEHORIGHET_ANGES_PER_ANVANDARE', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;BEHORIG_TILL_ALLA_BISATTNINGSLOKALER=Behörig till alla bisättningslokaler;BEHORIGHET_ANGES_PER_ANVANDARE=Behörighet anges per användare"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Individuella_grupper_1: {
          AttributeName: 'Individuella_grupper_1',
          DisplayLabel: 'Välj bokföringsgrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_2: {
          AttributeName: 'Individuella_grupper_2',
          DisplayLabel: 'Välj faktureringsgrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_3: {
          AttributeName: 'Individuella_grupper_3',
          DisplayLabel: 'Välj bokningsgrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_4: {
          AttributeName: 'Individuella_grupper_4',
          DisplayLabel: 'Välj diariegrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_5: {
          AttributeName: 'Individuella_grupper_5',
          DisplayLabel: 'Välj anläggningsgrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_6: {
          AttributeName: 'Individuella_grupper_6',
          DisplayLabel: 'Välj tidredovisningsgrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_7: {
          AttributeName: 'Individuella_grupper_7',
          DisplayLabel: 'Välj gåvogrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_8: {
          AttributeName: 'Individuella_grupper_8',
          DisplayLabel: 'Välj budgetgrupper individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        Individuella_grupper_9: {
          AttributeName: 'Individuella_grupper_9',
          DisplayLabel: 'Välj bisättningslokaler individuellt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'GAS',
        },
        MAPP_GBS_SIGN: {
          AttributeName: 'MAPP_GBS_SIGN',
          DisplayLabel: 'Mappas mot GBS-signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'GAS',
        },
        GBSRoller: {
          AttributeName: 'GBSRoller',
          DisplayLabel: 'GBS-roller',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'GAS',
        },
        PREV_AVENY_SIGN: {
          AttributeName: 'PREV_AVENY_SIGN',
          DisplayLabel: 'Tidigare Aveny-signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'GAS',
        },
        GBSRoll: {
          AttributeName: 'GBSRoll',
          DisplayLabel: 'GBS-roll',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesInternFilter', 'N;'], ['ConditionShowValuesFilter', 'ISNULL({MALLANVANDARE, \'N\'} = \'N\';']]),
        },
        ForeslagenGBSBeh: {
          AttributeName: 'ForeslagenGBSBeh',
          DisplayLabel: 'Föreslagen lokal GBS-beh',
          Hint: 'ANvänds av GAS-IN',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'GAS',
        },
        SenastAktiv: {
          AttributeName: 'SenastAktiv',
          DisplayLabel: 'Senast aktiv',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        RESTJA_VIEW_ID: {
          AttributeName: 'RESTJA_VIEW_ID',
          DisplayLabel: 'Resursbehörighet tjänstgöring',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRAVNINGSBESTALLNINGAR: {
          AttributeName: 'BEGRAVNINGSBESTALLNINGAR',
          DisplayLabel: 'Begravningsbeställningar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TRANSPORTOR: {
          AttributeName: 'TRANSPORTOR',
          DisplayLabel: 'Webaveny transportör',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UTB_RUBRIK: {
          AttributeName: 'UTB_RUBRIK',
          DisplayLabel: 'Utbildning, rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTB_BESKRIVNING: {
          AttributeName: 'UTB_BESKRIVNING',
          DisplayLabel: 'Utbildning, beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTB_RUBRIK_GAS: {
          AttributeName: 'UTB_RUBRIK_GAS',
          DisplayLabel: 'GAS - Utbildning, rubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTB_BESKRIVNING_GAS: {
          AttributeName: 'UTB_BESKRIVNING_GAS',
          DisplayLabel: 'GAS - Utbildning, beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KORT_NR: {
          AttributeName: 'KORT_NR',
          DisplayLabel: 'Kortnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AntalAnkRegFakt: {
          AttributeName: 'AntalAnkRegFakt',
          DisplayLabel: 'Antal ankomstregistrerade fakturor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        BO_BOKNBEST_BEH: {
          AttributeName: 'BO_BOKNBEST_BEH',
          DisplayLabel: 'Bokningsbeställningsbehörigheter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SignName: {
          AttributeName: 'SignName',
          DisplayLabel: 'Signatur och namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WEBBO_INFO: {
          AttributeName: 'WEBBO_INFO',
          DisplayLabel: 'Web boknings info',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        IsAttestant: {
          AttributeName: 'IsAttestant',
          DisplayLabel: 'Är attestant',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        HarKodbehorighetAnalys: {
          AttributeName: 'HarKodbehorighetAnalys',
          DisplayLabel: 'Har kodbehörighet för analys',
          Hint: 'Uppgiften gäller enbart för senaste kodplanen - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        farAttestera: {
          AttributeName: 'farAttestera',
          DisplayLabel: 'Får attestera (i Nya Aveny)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        isAktivAttestant: {
          AttributeName: 'isAktivAttestant',
          DisplayLabel: 'Är aktiv attestant',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        saknarKodbehorighetBeslutsattest: {
          AttributeName: 'saknarKodbehorighetBeslutsattest',
          DisplayLabel: 'Saknar kodbehörighet för beslutsattest',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        HarInternGBSRoll: {
          AttributeName: 'HarInternGBSRoll',
          DisplayLabel: 'Har intern roll i GBS',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WEBBO_ANDRA_AKT: {
          AttributeName: 'WEBBO_ANDRA_AKT',
          DisplayLabel: 'Ändra Aktivitet i WebAveny',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        saknarKodbehorighetMottagnattest: {
          AttributeName: 'saknarKodbehorighetMottagnattest',
          DisplayLabel: 'Saknar kodbehörighet för mottagningsattest',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        SortBorttagenDatum: {
          AttributeName: 'SortBorttagenDatum',
          DisplayLabel: 'SortBorttagenDatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLARE_BOKFORDER: {
          AttributeName: 'BESTALLARE_BOKFORDER',
          DisplayLabel: 'Beställare bokföringsorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        harKodbehorighetBokforder: {
          AttributeName: 'harKodbehorighetBokforder',
          DisplayLabel: 'Har kodbehörighet för bokföringsorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        BESTALLARE_UTANORDNING: {
          AttributeName: 'BESTALLARE_UTANORDNING',
          DisplayLabel: 'Beställare utanordning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        harKodbehorighetUtanordning: {
          AttributeName: 'harKodbehorighetUtanordning',
          DisplayLabel: 'Har kodbehörighet för utanordning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        ID_TYPE: {
          AttributeName: 'ID_TYPE',
          DisplayLabel: 'Id typ',
          Hint: 'AvenyID/Lokalt konto/GIP-konto',
          DataType: 'Enum',
          EnumValues: new Map([['AVENYID', 'AvenyID'], ['LOKALT_KONTO', 'Lokalt konto'], ['GIP_KONTO', 'GIP-konto']]),
          EnumSortValues: new Map([['AVENYID', 'A'], ['LOKALT_KONTO', 'L'], ['GIP_KONTO', 'G']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVENYID=AvenyID;LOKALT_KONTO=Lokalt konto;GIP_KONTO=GIP-konto"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        AVENYID: {
          AttributeName: 'AVENYID',
          DisplayLabel: 'AvenyID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOKAL_SIGNATURE: {
          AttributeName: 'LOKAL_SIGNATURE',
          DisplayLabel: 'Tidigare lokal signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GBS_SIGNATURE: {
          AttributeName: 'GBS_SIGNATURE',
          DisplayLabel: 'Tidigare GBS-signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTIFIERA_LEVERANTORSATTEST: {
          AttributeName: 'NOTIFIERA_LEVERANTORSATTEST',
          DisplayLabel: 'Notifiera om leverantörsattest',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Arbetsstalle: {
          AssociationName: 'Arbetsstalle',
          DisplayLabel: 'Arbetsställe',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSArbetsstalle',
          AssociatedComponentName: 'Arbetsstalle',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        DelarPlatsMed: {
          AssociationName: 'DelarPlatsMed',
          DisplayLabel: 'Delar arbetsplats med',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        OrgPers: {
          AssociationName: 'OrgPers',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Installningar: {
          AssociationName: 'Installningar',
          DisplayLabel: 'Inställningar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSTEDSYSAnvandarInstallningar',
          AssociatedComponentName: 'PersonligInstallning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Roller: {
          AssociationName: 'Roller',
          DisplayLabel: 'Roller',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAnvandarRoll',
          AssociatedComponentName: 'AnvandarRoll',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Ekonomirapporter: {
          AssociationName: 'Ekonomirapporter',
          DisplayLabel: 'Ekonomirapporter',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKTEDEKUtdeladRapportAnv',
          AssociatedComponentName: 'UtdeladRapportAnv',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontobehorighet: {
          AssociationName: 'Kontobehorighet',
          DisplayLabel: 'Kodbegränsning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAnvKontourval',
          AssociatedComponentName: 'AnvKontourval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Delsystemansvar: {
          AssociationName: 'Delsystemansvar',
          DisplayLabel: 'Delprogramansvar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSDelsystemansvar',
          AssociatedComponentName: 'Delsystemansvar',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandarlicens: {
          AssociationName: 'Anvandarlicens',
          DisplayLabel: 'Användarlicens',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUserLicense',
          AssociatedComponentName: 'UserLicense',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bevakning: {
          AssociationName: 'Bevakning',
          DisplayLabel: 'Bevakning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBevakning',
          AssociatedComponentName: 'Bevakningsgrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Losenordshistorik: {
          AssociationName: 'Losenordshistorik',
          DisplayLabel: 'Lösenordshistorik',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLosenordshistorik',
          AssociatedComponentName: 'LosenordsHistorik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LRAttestant',
          AssociatedComponentName: 'Attestant',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Mallusers: {
          AssociationName: 'Mallusers',
          DisplayLabel: 'GBS-roller',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUserMalluser',
          AssociatedComponentName: 'UserMalluser',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontobegransningar: {
          AssociationName: 'Kontobegransningar',
          DisplayLabel: 'Kodbehörigheter',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKAnvKontobegr',
          AssociatedComponentName: 'AnvKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Grupptyper: {
          AssociationName: 'Grupptyper',
          DisplayLabel: 'Grupptyper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMalluserGrupptyp',
          AssociatedComponentName: 'MalluserGrupptyp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AnvViewRapport: {
          AssociationName: 'AnvViewRapport',
          DisplayLabel: 'Användarens rapporter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAnvRapport',
          AssociatedComponentName: 'AnvRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Inventeringsansvariga: {
          AssociationName: 'Inventeringsansvariga',
          DisplayLabel: 'Inventeringsansvariga',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARInvAnsvariga',
          AssociatedComponentName: 'InvAnsvariga',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Franvaro: {
          AssociationName: 'Franvaro',
          DisplayLabel: 'Frånvaro',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSFranvaro',
          AssociatedComponentName: 'Franvaro',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUserMalluser: {
      CollectionName: 'SYSUserMalluser',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UserMalluser',
        Abstract: false,
        SOLabel: 'Användarens GAS-roll',
        SOGLabel: 'Användarens GAS-roll',
        SBLabel: 'Användarens GAS-roll',
        SBGLabel: 'Användarens GAS-roll',
        POLabel: 'Användarens GAS-roller',
        POGLabel: 'Användarens GAS-roller',
        PBLabel: 'Användarens GAS-roller',
        PBGLabel: 'Användarens GAS-roller',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Användarens GAS-roll primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Användarens GAS-roll versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Användarens GAS-roll fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'User, ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MALL_USER_ID: {
          AttributeName: 'MALL_USER_ID',
          DisplayLabel: 'Mallanvändare, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GBSRoll: {
          AttributeName: 'GBSRoll',
          DisplayLabel: 'GBS-roll',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesFilter', 'ISNULL({Malluser.MALLANVANDARE, \'N\'}) = \'Y\' and ISNULL({Malluser.BORTTAGEN, \'N\'}) = \'N\';']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Malluser: {
          AssociationName: 'Malluser',
          DisplayLabel: 'GAS-roll',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'Anvandarlicens;'], ['CustomExtended', 'ISNULL({Alias.USER_ID},0) = ISNULL({FromAlias.MALL_USER_ID},0) and ISNULL({Alias.MALLANVANDARE},\'N\') = \'Y\' and ISNULL({Alias.BORTTAGEN},\'N\') = \'N\';']]),
          Required: true,
        },
        User: {
          AssociationName: 'User',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSAnvandarRoll: {
      CollectionName: 'SYSAnvandarRoll',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AnvandarRoll',
        Abstract: false,
        SOLabel: 'Användarens roll',
        SOGLabel: 'Användarens roll',
        SBLabel: 'Användarens roll',
        SBGLabel: 'Användarens roll',
        POLabel: 'Användarens roller',
        POGLabel: 'Användarens roller',
        PBLabel: 'Användarens roller',
        PBGLabel: 'Användarens roller',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Användarens roll primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Användarens roll versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Användarens roll id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Användarens roll fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Roll: {
          AssociationName: 'Roll',
          DisplayLabel: 'Roll',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRoll',
          AssociatedComponentName: 'Roll',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSUserLicense: {
      CollectionName: 'SYSUserLicense',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UserLicense',
        Abstract: false,
        SOLabel: 'Användarlicens',
        SOGLabel: 'Användarlicens',
        SBLabel: 'Användarlicensen',
        SBGLabel: 'Användarlicensen',
        POLabel: 'Användarlicenser',
        POGLabel: 'Användarlicenser',
        PBLabel: 'Användarlicenserna',
        PBGLabel: 'Användarlicenserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Användarlicensen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Användarlicensen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Användarlicensen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Användarlicensen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEM_CODE: {
          AttributeName: 'SUBSYSTEM_CODE',
          DisplayLabel: 'Licens',
          Hint: 'Anläggningsredovisning/Bisättningsjournal/Bokning/Diarium/Ekonomi, Leverantörsreskontra/Grav/Kremationsjournal/Musik/Order/Fakturering, Kundreskontra/Tidredovisning/WebBokning/WebEkonomi/WebLeverantörsreskontra/WebTidredovisning/WebBisättningsjournal/WebGrav/Web Order/Fakturering/Web Diarium/Web Anläggningsredovisning',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREDOVISNING', 'Anläggningsredovisning'], ['BISATTNINGSJOURNAL', 'Bisättningsjournal'], ['BOKNING', 'Bokning'], ['DIARIUM', 'Diarium'], ['EKONOMI__LEVERANTORSRESKONTRA', 'Ekonomi, Leverantörsreskontra'], ['GRAV', 'Grav'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['MUSIK', 'Musik'], ['ORDER_FAKTURERING__KUNDRESKONTRA', 'Order/Fakturering, Kundreskontra'], ['TIDREDOVISNING', 'Tidredovisning'], ['WEBBOKNING', 'WebBokning'], ['WEBEKONOMI', 'WebEkonomi'], ['WEBLEVERANTORSRESKONTRA', 'WebLeverantörsreskontra'], ['WEBTIDREDOVISNING', 'WebTidredovisning'], ['WEBBISATTNINGSJOURNAL', 'WebBisättningsjournal'], ['WEBGRAV', 'WebGrav'], ['WEB_ORDER_FAKTURERING', 'Web Order/Fakturering'], ['WEB_DIARIUM', 'Web Diarium'], ['WEB_ANLAGGNINGSREDOVISNING', 'Web Anläggningsredovisning']]),
          EnumSortValues: new Map([['ANLAGGNINGSREDOVISNING', 'AR'], ['BISATTNINGSJOURNAL', 'BJ'], ['BOKNING', 'BO'], ['DIARIUM', 'DI'], ['EKONOMI__LEVERANTORSRESKONTRA', 'EK'], ['GRAV', 'GA'], ['KREMATIONSJOURNAL', 'KJ'], ['MUSIK', 'MU'], ['ORDER_FAKTURERING__KUNDRESKONTRA', 'OF'], ['TIDREDOVISNING', 'TI'], ['WEBBOKNING', 'WBO'], ['WEBEKONOMI', 'WEK'], ['WEBLEVERANTORSRESKONTRA', 'WLR'], ['WEBTIDREDOVISNING', 'WTI'], ['WEBBISATTNINGSJOURNAL', 'WBJ'], ['WEBGRAV', 'WGA'], ['WEB_ORDER_FAKTURERING', 'WOF'], ['WEB_DIARIUM', 'WDI'], ['WEB_ANLAGGNINGSREDOVISNING', 'WAR']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREDOVISNING=Anläggningsredovisning;BISATTNINGSJOURNAL=Bisättningsjournal;BOKNING=Bokning;DIARIUM=Diarium;EKONOMI__LEVERANTORSRESKONTRA=Ekonomi, Leverantörsreskontra;GRAV=Grav;KREMATIONSJOURNAL=Kremationsjournal;MUSIK=Musik;ORDER_FAKTURERING__KUNDRESKONTRA=Order/Fakturering, Kundreskontra;TIDREDOVISNING=Tidredovisning;WEBBOKNING=WebBokning;WEBEKONOMI=WebEkonomi;WEBLEVERANTORSRESKONTRA=WebLeverantörsreskontra;WEBTIDREDOVISNING=WebTidredovisning;WEBBISATTNINGSJOURNAL=WebBisättningsjournal;WEBGRAV=WebGrav;WEB_ORDER_FAKTURERING=Web Order/Fakturering;WEB_DIARIUM=Web Diarium;WEB_ANLAGGNINGSREDOVISNING=Web Anläggningsredovisning"',
          InterfaceType: 'ifChecklist',
        },
        LICENSTYP: {
          AttributeName: 'LICENSTYP',
          DisplayLabel: 'Licenstyp',
          Hint: 'Begränsad licens/Fullvärdig licens/Grundlicens/Grupplicens/Utökad licens',
          DataType: 'Enum',
          EnumValues: new Map([['BEGRANSAD_LICENS', 'Begränsad licens'], ['FULLVARDIG_LICENS', 'Fullvärdig licens'], ['GRUNDLICENS', 'Grundlicens'], ['GRUPPLICENS', 'Grupplicens'], ['UTOKAD_LICENS', 'Utökad licens']]),
          EnumSortValues: new Map([['BEGRANSAD_LICENS', 'B'], ['FULLVARDIG_LICENS', 'F'], ['GRUNDLICENS', 'W'], ['GRUPPLICENS', 'G'], ['UTOKAD_LICENS', 'U']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEGRANSAD_LICENS=Begränsad licens;FULLVARDIG_LICENS=Fullvärdig licens;GRUNDLICENS=Grundlicens;GRUPPLICENS=Grupplicens;UTOKAD_LICENS=Utökad licens"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        AnvantSenast: {
          AttributeName: 'AnvantSenast',
          DisplayLabel: 'Använt senast',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Subsyscode2: {
          AttributeName: 'Subsyscode2',
          DisplayLabel: 'Subsyscode2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSArbetsstalle: {
      CollectionName: 'SYSArbetsstalle',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Arbetsstalle',
        Abstract: false,
        SOLabel: 'Arbetsställe',
        SOGLabel: 'Arbetsställe',
        SBLabel: 'Arbetsstället',
        SBGLabel: 'Arbetsstället',
        POLabel: 'Arbetsställen',
        POGLabel: 'Arbetsställen',
        PBLabel: 'Arbetsställena',
        PBGLabel: 'Arbetsställena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsstället primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsstället versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetsstället id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsstället fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontobegransning: {
          AssociationName: 'Kontobegransning',
          DisplayLabel: 'Kodbegränsning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKStalleKontourval',
          AssociatedComponentName: 'StalleKontourval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSFramsidanAuth: {
      CollectionName: 'SYSFramsidanAuth',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FramsidanAuth',
        Abstract: false,
        SOLabel: 'Autenticering',
        SOGLabel: 'Autenticerings',
        SBLabel: 'Autenticeringen',
        SBGLabel: 'Autenticeringens',
        POLabel: 'Autenticeringar',
        POGLabel: 'Autenticeringars',
        PBLabel: 'Autenticeringarna',
        PBGLabel: 'Autenticeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Autenticeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Autenticeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Autenticeringens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Autenticeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'api-nyckel/login',
          DataType: 'Enum',
          EnumValues: new Map([['API_NYCKEL', 'api-nyckel'], ['LOGIN', 'login']]),
          EnumSortValues: new Map([['API_NYCKEL', 'A'], ['LOGIN', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="API_NYCKEL=api-nyckel;LOGIN=login"',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          Required: true,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifNone',
        },
        LOSENORD: {
          AttributeName: 'LOSENORD',
          DisplayLabel: 'Lösenord',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifNone',
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSAutogiroMall: {
      CollectionName: 'SYSAutogiroMall',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AutogiroMall',
        Abstract: false,
        SOLabel: 'Autogiromall',
        SOGLabel: 'Autogiromall',
        SBLabel: 'Autogiromallen',
        SBGLabel: 'Autogiromallen',
        POLabel: 'Autogiromallar',
        POGLabel: 'Autogiromallar',
        PBLabel: 'Autogiromallarna',
        PBGLabel: 'Autogiromallarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Autogiromallen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Autogiromallen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Autogiromallen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Autogiromallen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ANTAL_DELBET: {
          AttributeName: 'ANTAL_DELBET',
          DisplayLabel: 'Antal delbetalningar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PERIODICITET: {
          AttributeName: 'PERIODICITET',
          DisplayLabel: 'Periodicitet',
          Hint: 'Varje månad/Varannan månad/Var tredje månad/Var fjärde månad/Var sjätte månad/Varje år',
          DataType: 'Enum',
          EnumValues: new Map([['VARJE_MANAD', 'Varje månad'], ['VARANNAN_MANAD', 'Varannan månad'], ['VAR_TREDJE_MANAD', 'Var tredje månad'], ['VAR_FJARDE_MANAD', 'Var fjärde månad'], ['VAR_SJATTE_MANAD', 'Var sjätte månad'], ['VARJE_AR', 'Varje år']]),
          EnumSortValues: new Map([['VARJE_MANAD', '1'], ['VARANNAN_MANAD', '2'], ['VAR_TREDJE_MANAD', '3'], ['VAR_FJARDE_MANAD', '4'], ['VAR_SJATTE_MANAD', '6'], ['VARJE_AR', '12']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VARJE_MANAD=Varje månad;VARANNAN_MANAD=Varannan månad;VAR_TREDJE_MANAD=Var tredje månad;VAR_FJARDE_MANAD=Var fjärde månad;VAR_SJATTE_MANAD=Var sjätte månad;VARJE_AR=Varje år"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        BETALNINGSDAG: {
          AttributeName: 'BETALNINGSDAG',
          DisplayLabel: 'Betalningsdag',
          Hint: 'Sista bankdag/1/2/3/4/5/6/7/8/9/10/11/12/13/14/15/16/17/18/19/20/21/22/23/24/25/26/27/28/29/30/31',
          DataType: 'Enum',
          EnumValues: new Map([['BSISTA_BANKDAG', 'Sista bankdag'], ['B1', '1'], ['B2', '2'], ['B3', '3'], ['B4', '4'], ['B5', '5'], ['B6', '6'], ['B7', '7'], ['B8', '8'], ['B9', '9'], ['B10', '10'], ['B11', '11'], ['B12', '12'], ['B13', '13'], ['B14', '14'], ['B15', '15'], ['B16', '16'], ['B17', '17'], ['B18', '18'], ['B19', '19'], ['B20', '20'], ['B21', '21'], ['B22', '22'], ['B23', '23'], ['B24', '24'], ['B25', '25'], ['B26', '26'], ['B27', '27'], ['B28', '28'], ['B29', '29'], ['B30', '30'], ['B31', '31']]),
          EnumSortValues: new Map([['BSISTA_BANKDAG', '0'], ['B1', '1'], ['B2', '2'], ['B3', '3'], ['B4', '4'], ['B5', '5'], ['B6', '6'], ['B7', '7'], ['B8', '8'], ['B9', '9'], ['B10', '10'], ['B11', '11'], ['B12', '12'], ['B13', '13'], ['B14', '14'], ['B15', '15'], ['B16', '16'], ['B17', '17'], ['B18', '18'], ['B19', '19'], ['B20', '20'], ['B21', '21'], ['B22', '22'], ['B23', '23'], ['B24', '24'], ['B25', '25'], ['B26', '26'], ['B27', '27'], ['B28', '28'], ['B29', '29'], ['B30', '30'], ['B31', '31']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BSISTA_BANKDAG=Sista bankdag;B1=1;B2=2;B3=3;B4=4;B5=5;B6=6;B7=7;B8=8;B9=9;B10=10;B11=11;B12=12;B13=13;B14=14;B15=15;B16=16;B17=17;B18=18;B19=19;B20=20;B21=21;B22=22;B23=23;B24=24;B25=25;B26=26;B27=27;B28=28;B29=29;B30=30;B31=31"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SLUTBETALAS: {
          AttributeName: 'SLUTBETALAS',
          DisplayLabel: 'Slutbetalt innev. år',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BETMANAD_1: {
          AttributeName: 'BETMANAD_1',
          DisplayLabel: 'Januari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_2: {
          AttributeName: 'BETMANAD_2',
          DisplayLabel: 'Februari',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_3: {
          AttributeName: 'BETMANAD_3',
          DisplayLabel: 'Mars',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_4: {
          AttributeName: 'BETMANAD_4',
          DisplayLabel: 'April',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_5: {
          AttributeName: 'BETMANAD_5',
          DisplayLabel: 'Maj',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_6: {
          AttributeName: 'BETMANAD_6',
          DisplayLabel: 'Juni',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_7: {
          AttributeName: 'BETMANAD_7',
          DisplayLabel: 'Juli',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_8: {
          AttributeName: 'BETMANAD_8',
          DisplayLabel: 'Augusti',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_9: {
          AttributeName: 'BETMANAD_9',
          DisplayLabel: 'September',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_10: {
          AttributeName: 'BETMANAD_10',
          DisplayLabel: 'Oktober',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_11: {
          AttributeName: 'BETMANAD_11',
          DisplayLabel: 'November',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BETMANAD_12: {
          AttributeName: 'BETMANAD_12',
          DisplayLabel: 'December',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        Dragningar: {
          AttributeName: 'Dragningar',
          DisplayLabel: 'Dragningstillfällen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Id-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSUndo: {
      CollectionName: 'SYSUndo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Undo',
        Abstract: false,
        SOLabel: 'Backning',
        SOGLabel: 'Backnings',
        SBLabel: 'Backningen',
        SBGLabel: 'Backningens',
        POLabel: 'Backningar',
        POGLabel: 'Backningars',
        PBLabel: 'Backningarna',
        PBGLabel: 'Backningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Backningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Backningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Backningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Backningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Sammanslagning adresser/Förnya avtal/Sammanslagning avlidna/Byte av artiklar',
          DataType: 'Enum',
          EnumValues: new Map([['SAMMANSLAGNING_ADRESSER', 'Sammanslagning adresser'], ['FORNYA_AVTAL', 'Förnya avtal'], ['SAMMANSLAGNING_AVLIDNA', 'Sammanslagning avlidna'], ['BYTE_AV_ARTIKLAR', 'Byte av artiklar']]),
          EnumSortValues: new Map([['SAMMANSLAGNING_ADRESSER', 'S'], ['FORNYA_AVTAL', 'F'], ['SAMMANSLAGNING_AVLIDNA', 'A'], ['BYTE_AV_ARTIKLAR', 'B']]),
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SAMMANSLAGNING_ADRESSER=Sammanslagning adresser;FORNYA_AVTAL=Förnya avtal;SAMMANSLAGNING_AVLIDNA=Sammanslagning avlidna;BYTE_AV_ARTIKLAR=Byte av artiklar"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN: {
          AttributeName: 'SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        UndoData: {
          AssociationName: 'UndoData',
          DisplayLabel: 'Undodata',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUndoData',
          AssociatedComponentName: 'UndoData',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        UndoInfo: {
          AssociationName: 'UndoInfo',
          DisplayLabel: 'Undoinfo',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUndoInfo',
          AssociatedComponentName: 'UndoInfo',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUndoData: {
      CollectionName: 'SYSUndoData',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'UndoData',
        Abstract: false,
        SOLabel: 'Backningsdata',
        SOGLabel: 'Backningsdatas',
        SBLabel: 'Backningsdatan',
        SBGLabel: 'Backningsdatans',
        POLabel: 'Backningsdata',
        POGLabel: 'Backningsdatas',
        PBLabel: 'Backningsdatan',
        PBGLabel: 'Backningsdatans',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Backningsdatans primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Backningsdatans versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Backningsdatans id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Backningsdatans fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UNDOSQL1: {
          AttributeName: 'UNDOSQL1',
          DisplayLabel: 'UNDOSQL1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        UNDOSQL2: {
          AttributeName: 'UNDOSQL2',
          DisplayLabel: 'UNDOSQL2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        UNDOSQL3: {
          AttributeName: 'UNDOSQL3',
          DisplayLabel: 'UNDOSQL3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        UNDOSQL4: {
          AttributeName: 'UNDOSQL4',
          DisplayLabel: 'UNDOSQL4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        UNDOSQL5: {
          AttributeName: 'UNDOSQL5',
          DisplayLabel: 'UNDOSQL5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        UNDOSQL6: {
          AttributeName: 'UNDOSQL6',
          DisplayLabel: 'UNDOSQL6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        ANTALRADER: {
          AttributeName: 'ANTALRADER',
          DisplayLabel: 'Antal rader',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Undo: {
          AssociationName: 'Undo',
          DisplayLabel: 'Undo',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUndo',
          AssociatedComponentName: 'Undo',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUndoError: {
      CollectionName: 'SYSUndoError',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UndoError',
        Abstract: false,
        SOLabel: 'Backningsfel',
        SOGLabel: 'Backningsfels',
        SBLabel: 'Backningsfelet',
        SBGLabel: 'Backningsfelets',
        POLabel: 'Backningsfel',
        POGLabel: 'Backningsfels',
        PBLabel: 'Backningsfelen',
        PBGLabel: 'Backningsfelens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Backningsfelets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Backningsfelets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Backningsfelets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Backningsfelets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Undo: {
          AssociationName: 'Undo',
          DisplayLabel: 'Undo',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUndo',
          AssociatedComponentName: 'Undo',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUndoInfo: {
      CollectionName: 'SYSUndoInfo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'UndoInfo',
        Abstract: false,
        SOLabel: 'Backningsinformation',
        SOGLabel: 'Backningsinformation',
        SBLabel: 'Backningsinformationen',
        SBGLabel: 'Backningsinformationen',
        POLabel: 'Backningsinformation',
        POGLabel: 'Backningsinformation',
        PBLabel: 'Backningsinformationen',
        PBGLabel: 'Backningsinformationen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Backningsinformationen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Backningsinformationen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Backningsinformationen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Backningsinformationen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        SUBSYSTEM: {
          AttributeName: 'SUBSYSTEM',
          DisplayLabel: 'Delsystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        BM: {
          AttributeName: 'BM',
          DisplayLabel: 'Modell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        IDKEY: {
          AttributeName: 'IDKEY',
          DisplayLabel: 'Nyckel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Undo: {
          AssociationName: 'Undo',
          DisplayLabel: 'Undo',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUndo',
          AssociatedComponentName: 'Undo',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUndoKey: {
      CollectionName: 'SYSUndoKey',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UndoKey',
        Abstract: false,
        SOLabel: 'Backningsnyckel',
        SOGLabel: 'Backningsnyckels',
        SBLabel: 'Backningsnyckeln',
        SBGLabel: 'Backningsnyckelns',
        POLabel: 'Backningsnycklar',
        POGLabel: 'Backningsnycklars',
        PBLabel: 'Backningsnycklarna',
        PBGLabel: 'Backningsnycklarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Backningsnyckelns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Backningsnyckelns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Backningsnyckelns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Backningsnyckelns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KEY1: {
          AttributeName: 'KEY1',
          DisplayLabel: 'Nyckel 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KEY2: {
          AttributeName: 'KEY2',
          DisplayLabel: 'Nyckel 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KEY3: {
          AttributeName: 'KEY3',
          DisplayLabel: 'Nyckel 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KEY4: {
          AttributeName: 'KEY4',
          DisplayLabel: 'Nyckel 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Undo: {
          AssociationName: 'Undo',
          DisplayLabel: 'Undo',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUndo',
          AssociatedComponentName: 'Undo',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSBank: {
      CollectionName: 'SYSBank',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bank',
        Abstract: false,
        SOLabel: 'Bank',
        SOGLabel: 'Bank',
        SBLabel: 'Banken',
        SBGLabel: 'Banken',
        POLabel: 'Banker',
        POGLabel: 'Banker',
        PBLabel: 'Bankerna',
        PBGLabel: 'Bankerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Banken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Banken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Banken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Banken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CLEARINGNR: {
          AttributeName: 'CLEARINGNR',
          DisplayLabel: 'Clearingnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        ADRESS: {
          AttributeName: 'ADRESS',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 100,
        },
        POSTADRESS: {
          AttributeName: 'POSTADRESS',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'LowerCase="False"',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        POSTNUMMER: {
          AttributeName: 'POSTNUMMER',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        LAND_ID: {
          AttributeName: 'LAND_ID',
          DisplayLabel: 'Land',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SWIFT_ADRESS: {
          AttributeName: 'SWIFT_ADRESS',
          DisplayLabel: 'SWIFT-adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        SORTCODE: {
          AttributeName: 'SORTCODE',
          DisplayLabel: 'Sortcode',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        NATIONAL_BANK_ID: {
          AttributeName: 'NATIONAL_BANK_ID',
          DisplayLabel: 'Nationellt bankid',
          Hint: 'ATBLZ - Nationellt bankid i Österrike/AUBSB - Nationellt bankid i Australien/CACPA - Nationellt bankid i Kanada/CHBCC - Nationellt bankid i Schweiz, utan checksiffra/CHSIC - Nationellt bankid i Schweiz, med checksiffra/CNAPS - Nationellt bankid i Kina/DEBLZ - Nationellt bankid i Tyskland/ESNCC - Nationellt bankid i Spanien/GBDSC - Nationellt bankid i UK/GRBIC - Nationellt bankid i Grekland/HKNCC - Nationellt bankid i Hong Kong/IENCC - Nationellt bankid i Irland/INFSC - Nationellt bankid i Indien/ITNCC - Nationellt bankid i Italien/JPZGN- Nationellt bankid i Japan/NZNCC- Nationellt bankid i Nya Zealand/PLKNR - Nationellt bankid i Polen/PTNCC - Nationellt bankid i Portugal/RUCBC - Nationellt bankid i Ryssland/SESBA - Nationellt bankid i Sverige/SGIBG - Nationellt bankid i Singapor/THCBC - Nationellt bankid i Thailand/TWNCC - Nationellt bankid i Taiwan/USABA - Nationellt bankid i USA (Fedwire, NACHA)/USPID - Bank id som används av CHIPs i USA/ZANCC - Nationellt bankid i Sydafrica',
          DataType: 'Enum',
          EnumValues: new Map([['ATBLZ___NATIONELLT_BANKID_I_OSTERRIKE', 'ATBLZ - Nationellt bankid i Österrike'], ['AUBSB___NATIONELLT_BANKID_I_AUSTRALIEN', 'AUBSB - Nationellt bankid i Australien'], ['CACPA___NATIONELLT_BANKID_I_KANADA', 'CACPA - Nationellt bankid i Kanada'], ['CHBCC___NATIONELLT_BANKID_I_SCHWEIZ__UTAN_CHECKSIFFRA', 'CHBCC - Nationellt bankid i Schweiz, utan checksiffra'], ['CHSIC___NATIONELLT_BANKID_I_SCHWEIZ__MED_CHECKSIFFRA', 'CHSIC - Nationellt bankid i Schweiz, med checksiffra'], ['CNAPS___NATIONELLT_BANKID_I_KINA', 'CNAPS - Nationellt bankid i Kina'], ['DEBLZ___NATIONELLT_BANKID_I_TYSKLAND', 'DEBLZ - Nationellt bankid i Tyskland'], ['ESNCC___NATIONELLT_BANKID_I_SPANIEN', 'ESNCC - Nationellt bankid i Spanien'], ['GBDSC___NATIONELLT_BANKID_I_UK', 'GBDSC - Nationellt bankid i UK'], ['GRBIC___NATIONELLT_BANKID_I_GREKLAND', 'GRBIC - Nationellt bankid i Grekland'], ['HKNCC___NATIONELLT_BANKID_I_HONG_KONG', 'HKNCC - Nationellt bankid i Hong Kong'], ['IENCC___NATIONELLT_BANKID_I_IRLAND', 'IENCC - Nationellt bankid i Irland'], ['INFSC___NATIONELLT_BANKID_I_INDIEN', 'INFSC - Nationellt bankid i Indien'], ['ITNCC___NATIONELLT_BANKID_I_ITALIEN', 'ITNCC - Nationellt bankid i Italien'], ['JPZGN__NATIONELLT_BANKID_I_JAPAN', 'JPZGN- Nationellt bankid i Japan'], ['NZNCC__NATIONELLT_BANKID_I_NYA_ZEALAND', 'NZNCC- Nationellt bankid i Nya Zealand'], ['PLKNR___NATIONELLT_BANKID_I_POLEN', 'PLKNR - Nationellt bankid i Polen'], ['PTNCC___NATIONELLT_BANKID_I_PORTUGAL', 'PTNCC - Nationellt bankid i Portugal'], ['RUCBC___NATIONELLT_BANKID_I_RYSSLAND', 'RUCBC - Nationellt bankid i Ryssland'], ['SESBA___NATIONELLT_BANKID_I_SVERIGE', 'SESBA - Nationellt bankid i Sverige'], ['SGIBG___NATIONELLT_BANKID_I_SINGAPOR', 'SGIBG - Nationellt bankid i Singapor'], ['THCBC___NATIONELLT_BANKID_I_THAILAND', 'THCBC - Nationellt bankid i Thailand'], ['TWNCC___NATIONELLT_BANKID_I_TAIWAN', 'TWNCC - Nationellt bankid i Taiwan'], ['USABA___NATIONELLT_BANKID_I_USA__FEDWIRE__NACHA_', 'USABA - Nationellt bankid i USA (Fedwire, NACHA)'], ['USPID___BANK_ID_SOM_ANVANDS_AV_CHIPS_I_USA', 'USPID - Bank id som används av CHIPs i USA'], ['ZANCC___NATIONELLT_BANKID_I_SYDAFRICA', 'ZANCC - Nationellt bankid i Sydafrica']]),
          EnumSortValues: new Map([['ATBLZ___NATIONELLT_BANKID_I_OSTERRIKE', 'ATBLZ'], ['AUBSB___NATIONELLT_BANKID_I_AUSTRALIEN', 'AUBSB'], ['CACPA___NATIONELLT_BANKID_I_KANADA', 'CACPA'], ['CHBCC___NATIONELLT_BANKID_I_SCHWEIZ__UTAN_CHECKSIFFRA', 'CHBCC'], ['CHSIC___NATIONELLT_BANKID_I_SCHWEIZ__MED_CHECKSIFFRA', 'CHSIC'], ['CNAPS___NATIONELLT_BANKID_I_KINA', 'CNAPS'], ['DEBLZ___NATIONELLT_BANKID_I_TYSKLAND', 'DEBLZ'], ['ESNCC___NATIONELLT_BANKID_I_SPANIEN', 'ESNCC'], ['GBDSC___NATIONELLT_BANKID_I_UK', 'GBDSC'], ['GRBIC___NATIONELLT_BANKID_I_GREKLAND', 'GRBIC'], ['HKNCC___NATIONELLT_BANKID_I_HONG_KONG', 'HKNCC'], ['IENCC___NATIONELLT_BANKID_I_IRLAND', 'IENCC'], ['INFSC___NATIONELLT_BANKID_I_INDIEN', 'INFSC'], ['ITNCC___NATIONELLT_BANKID_I_ITALIEN', 'ITNCC'], ['JPZGN__NATIONELLT_BANKID_I_JAPAN', 'JPZGN'], ['NZNCC__NATIONELLT_BANKID_I_NYA_ZEALAND', 'NZNCC'], ['PLKNR___NATIONELLT_BANKID_I_POLEN', 'PLKNR'], ['PTNCC___NATIONELLT_BANKID_I_PORTUGAL', 'PTNCC'], ['RUCBC___NATIONELLT_BANKID_I_RYSSLAND', 'RUCBC'], ['SESBA___NATIONELLT_BANKID_I_SVERIGE', 'SESBA'], ['SGIBG___NATIONELLT_BANKID_I_SINGAPOR', 'SGIBG'], ['THCBC___NATIONELLT_BANKID_I_THAILAND', 'THCBC'], ['TWNCC___NATIONELLT_BANKID_I_TAIWAN', 'TWNCC'], ['USABA___NATIONELLT_BANKID_I_USA__FEDWIRE__NACHA_', 'USABA'], ['USPID___BANK_ID_SOM_ANVANDS_AV_CHIPS_I_USA', 'USPID'], ['ZANCC___NATIONELLT_BANKID_I_SYDAFRICA', 'ZANCC']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATBLZ___NATIONELLT_BANKID_I_OSTERRIKE=ATBLZ - Nationellt bankid i Österrike;AUBSB___NATIONELLT_BANKID_I_AUSTRALIEN=AUBSB - Nationellt bankid i Australien;CACPA___NATIONELLT_BANKID_I_KANADA=CACPA - Nationellt bankid i Kanada;CHBCC___NATIONELLT_BANKID_I_SCHWEIZ__UTAN_CHECKSIFFRA=CHBCC - Nationellt bankid i Schweiz, utan checksiffra;CHSIC___NATIONELLT_BANKID_I_SCHWEIZ__MED_CHECKSIFFRA=CHSIC - Nationellt bankid i Schweiz, med checksiffra;CNAPS___NATIONELLT_BANKID_I_KINA=CNAPS - Nationellt bankid i Kina;DEBLZ___NATIONELLT_BANKID_I_TYSKLAND=DEBLZ - Nationellt bankid i Tyskland;ESNCC___NATIONELLT_BANKID_I_SPANIEN=ESNCC - Nationellt bankid i Spanien;GBDSC___NATIONELLT_BANKID_I_UK=GBDSC - Nationellt bankid i UK;GRBIC___NATIONELLT_BANKID_I_GREKLAND=GRBIC - Nationellt bankid i Grekland;HKNCC___NATIONELLT_BANKID_I_HONG_KONG=HKNCC - Nationellt bankid i Hong Kong;IENCC___NATIONELLT_BANKID_I_IRLAND=IENCC - Nationellt bankid i Irland;INFSC___NATIONELLT_BANKID_I_INDIEN=INFSC - Nationellt bankid i Indien;ITNCC___NATIONELLT_BANKID_I_ITALIEN=ITNCC - Nationellt bankid i Italien;JPZGN__NATIONELLT_BANKID_I_JAPAN=JPZGN- Nationellt bankid i Japan;NZNCC__NATIONELLT_BANKID_I_NYA_ZEALAND=NZNCC- Nationellt bankid i Nya Zealand;PLKNR___NATIONELLT_BANKID_I_POLEN=PLKNR - Nationellt bankid i Polen;PTNCC___NATIONELLT_BANKID_I_PORTUGAL=PTNCC - Nationellt bankid i Portugal;RUCBC___NATIONELLT_BANKID_I_RYSSLAND=RUCBC - Nationellt bankid i Ryssland;SESBA___NATIONELLT_BANKID_I_SVERIGE=SESBA - Nationellt bankid i Sverige;SGIBG___NATIONELLT_BANKID_I_SINGAPOR=SGIBG - Nationellt bankid i Singapor;THCBC___NATIONELLT_BANKID_I_THAILAND=THCBC - Nationellt bankid i Thailand;TWNCC___NATIONELLT_BANKID_I_TAIWAN=TWNCC - Nationellt bankid i Taiwan;USABA___NATIONELLT_BANKID_I_USA__FEDWIRE__NACHA_=USABA - Nationellt bankid i USA (Fedwire, NACHA);USPID___BANK_ID_SOM_ANVANDS_AV_CHIPS_I_USA=USPID - Bank id som används av CHIPs i USA;ZANCC___NATIONELLT_BANKID_I_SYDAFRICA=ZANCC - Nationellt bankid i Sydafrica"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Land: {
          AssociationName: 'Land',
          DisplayLabel: 'Land',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKommunikatorBatch: {
      CollectionName: 'SYSKommunikatorBatch',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KommunikatorBatch',
        Abstract: false,
        SOLabel: 'Batch',
        SOGLabel: 'Batch',
        SBLabel: 'Batchen',
        SBGLabel: 'Batchens',
        POLabel: 'Batchar',
        POGLabel: 'Batchars',
        PBLabel: 'Batcharna',
        PBGLabel: 'Batcharnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Batchens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Batchens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Batchens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BATCHID: {
          AttributeName: 'BATCHID',
          DisplayLabel: 'BATCHID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAGEDATUM: {
          AttributeName: 'FRAGEDATUM',
          DisplayLabel: 'Frågedatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAGETYP: {
          AttributeName: 'FRAGETYP',
          DisplayLabel: 'Fråga Spar/Medlem',
          Hint: 'Båda/Medlem',
          DataType: 'Enum',
          EnumValues: new Map([['BADA', 'Båda'], ['MEDLEM', 'Medlem']]),
          EnumSortValues: new Map([['BADA', 'B'], ['MEDLEM', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BADA=Båda;MEDLEM=Medlem"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ADRESSTYP: {
          AttributeName: 'ADRESSTYP',
          DisplayLabel: 'Adressfråga',
          Hint: 'Fråga - adressbok/Fråga - bevakning/Fråga - lokalt skydd',
          DataType: 'Enum',
          EnumValues: new Map([['FRAGA___ADRESSBOK', 'Fråga - adressbok'], ['FRAGA___BEVAKNING', 'Fråga - bevakning'], ['FRAGA___LOKALT_SKYDD', 'Fråga - lokalt skydd']]),
          EnumSortValues: new Map([['FRAGA___ADRESSBOK', 'A'], ['FRAGA___BEVAKNING', 'B'], ['FRAGA___LOKALT_SKYDD', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FRAGA___ADRESSBOK=Fråga - adressbok;FRAGA___BEVAKNING=Fråga - bevakning;FRAGA___LOKALT_SKYDD=Fråga - lokalt skydd"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HAMTAD: {
          AttributeName: 'HAMTAD',
          DisplayLabel: 'Hämtad',
          Hint: 'Hämtad/Inte hämtad',
          DataType: 'Enum',
          EnumValues: new Map([['HAMTAD', 'Hämtad'], ['INTE_HAMTAD', 'Inte hämtad']]),
          EnumSortValues: new Map([['HAMTAD', 'Y'], ['INTE_HAMTAD', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HAMTAD=Hämtad;INTE_HAMTAD=Inte hämtad"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Loggtext: {
          AttributeName: 'Loggtext',
          DisplayLabel: 'Loggtext',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Programlog: {
          AssociationName: 'Programlog',
          DisplayLabel: 'Programlogg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSTEDSYSProgramlog',
          AssociatedComponentName: 'Programlog',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSBetalningsvillkor: {
      CollectionName: 'SYSBetalningsvillkor',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Betalningsvillkor',
        Abstract: false,
        SOLabel: 'Betalningsvillkor',
        SOGLabel: 'Betalningsvillkor',
        SBLabel: 'Betalningsvillkoret',
        SBGLabel: 'Betalningsvillkoret',
        POLabel: 'Betalningsvillkor',
        POGLabel: 'Betalningsvillkor',
        PBLabel: 'Betalningsvillkoren',
        PBGLabel: 'Betalningsvillkoren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Betalningsvillkoret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Betalningsvillkoret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Betalningsvillkoret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Betalningsvillkoret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETALNINGSVILLKORKOD: {
          AttributeName: 'BETALNINGSVILLKORKOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        ANTALDAGAR: {
          AttributeName: 'ANTALDAGAR',
          DisplayLabel: 'Antal dagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MaxValue="365"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FRILEVMANAD: {
          AttributeName: 'FRILEVMANAD',
          DisplayLabel: 'Fri leverans månad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        ANTALRANTEDAGAR: {
          AttributeName: 'ANTALRANTEDAGAR',
          DisplayLabel: 'Antal räntedagar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MaxValue="365"',
        },
        KRAVRUTIN_ID: {
          AttributeName: 'KRAVRUTIN_ID',
          DisplayLabel: 'Kravrutin_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RANTEFAKTURERAS: {
          AttributeName: 'RANTEFAKTURERAS',
          DisplayLabel: 'Räntefaktureras',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'KodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AGRESSO_KRAVKOD: {
          AttributeName: 'AGRESSO_KRAVKOD',
          DisplayLabel: 'Kravkod, Agresso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kravrutin: {
          AssociationName: 'Kravrutin',
          DisplayLabel: 'Kravrutin',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKravrutin',
          AssociatedComponentName: 'Kravrutin',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKommunikatorBev: {
      CollectionName: 'SYSKommunikatorBev',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KommunikatorBev',
        Abstract: false,
        SOLabel: 'Bevakning avliden',
        SOGLabel: 'Bevakning avliden',
        SBLabel: 'Bevakningen av avliden',
        SBGLabel: 'Bevakningens av avliden',
        POLabel: 'Bevakningar av avlidna',
        POGLabel: 'Bevakningars av avlidna',
        PBLabel: 'Bevakningarna av avlidna',
        PBGLabel: 'Bevakningarnas av avlidna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bevakningens av avliden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bevakningens av avliden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bevakningens av avliden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANDRAD_AV_ANV_TIMESTAMP: {
          AttributeName: 'ANDRAD_AV_ANV_TIMESTAMP',
          DisplayLabel: 'Ändrad av användare',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRAGEDATUM: {
          AttributeName: 'FRAGEDATUM',
          DisplayLabel: 'Frågedatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSBevakning: {
      CollectionName: 'SYSBevakning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bevakning',
        Abstract: false,
        SOLabel: 'Bevakning',
        SOGLabel: 'Bevakning',
        SBLabel: 'Bevakningen',
        SBGLabel: 'Bevakningen',
        POLabel: 'Bevakningar',
        POGLabel: '',
        PBLabel: 'Bevakningarna',
        PBGLabel: 'Bevakningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bevakningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bevakningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bevakningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bevakningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTIFYNAME: {
          AttributeName: 'NOTIFYNAME',
          DisplayLabel: 'Name',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Active: {
          AttributeName: 'Active',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        Description: {
          AttributeName: 'Description',
          DisplayLabel: 'Description',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 500,
        },
        STARTTYPE: {
          AttributeName: 'STARTTYPE',
          DisplayLabel: 'StartType',
          Hint: 'Programstart/Manuellt',
          DataType: 'Enum',
          EnumValues: new Map([['PROGRAMSTART', 'Programstart'], ['MANUELLT', 'Manuellt']]),
          EnumSortValues: new Map([['PROGRAMSTART', 'P'], ['MANUELLT', 'M']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PROGRAMSTART=Programstart;MANUELLT=Manuellt"',
          GUIEditable: true,
        },
        INTERFACETYPE: {
          AttributeName: 'INTERFACETYPE',
          DisplayLabel: 'INTERFACETYPE',
          Hint: 'Skylt/Kompakt lista/Varning',
          DataType: 'Enum',
          EnumValues: new Map([['SKYLT', 'Skylt'], ['KOMPAKT_LISTA', 'Kompakt lista'], ['VARNING', 'Varning']]),
          EnumSortValues: new Map([['SKYLT', 'S'], ['KOMPAKT_LISTA', 'L'], ['VARNING', 'W']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKYLT=Skylt;KOMPAKT_LISTA=Kompakt lista;VARNING=Varning"',
          GUIEditable: true,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Vy Id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ROUTINE_ID: {
          AttributeName: 'ROUTINE_ID',
          DisplayLabel: 'Rutin id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ROLE_ID: {
          AttributeName: 'ROLE_ID',
          DisplayLabel: 'Roll',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RECIPIENT_TYPE: {
          AttributeName: 'RECIPIENT_TYPE',
          DisplayLabel: 'Reciprient Type',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        CONDITION_USERS: {
          AttributeName: 'CONDITION_USERS',
          DisplayLabel: 'CONDITION_USERS',
          Hint: 'Behörig/Delsystemansvarig/Sysadm',
          DataType: 'Enum',
          EnumValues: new Map([['BEHORIG', 'Behörig'], ['DELSYSTEMANSVARIG', 'Delsystemansvarig'], ['SYSADM', 'Sysadm']]),
          EnumSortValues: new Map([['BEHORIG', 'B'], ['DELSYSTEMANSVARIG', 'D'], ['SYSADM', 'S']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEHORIG=Behörig;DELSYSTEMANSVARIG=Delsystemansvarig;SYSADM=Sysadm"',
          GUIEditable: true,
        },
        TRIGGER_TIME: {
          AttributeName: 'TRIGGER_TIME',
          DisplayLabel: 'Triggertime',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        TRIGGER_TO_USERS: {
          AttributeName: 'TRIGGER_TO_USERS',
          DisplayLabel: 'Trigger to Users',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        TRIGGER_TO_ROLE: {
          AttributeName: 'TRIGGER_TO_ROLE',
          DisplayLabel: 'Trigger to Role',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rutin: {
          AssociationName: 'Rutin',
          DisplayLabel: 'Rutin',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRutin',
          AssociatedComponentName: 'Rutin',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Roll: {
          AssociationName: 'Roll',
          DisplayLabel: 'Roll',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRoll',
          AssociatedComponentName: 'Roll',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSReportNewBevakning: {
      CollectionName: 'SYSReportNewBevakning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ReportNewBevakning',
        Abstract: false,
        SOLabel: 'Bevakning',
        SOGLabel: 'Bevaknings',
        SBLabel: 'Bevakningen',
        SBGLabel: 'Bevakningens',
        POLabel: 'Bevakningar',
        POGLabel: 'Bevakningars',
        PBLabel: 'Bevakningarna',
        PBGLabel: 'Bevakningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bevakningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bevakningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bevakningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bevakningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REPORT_ID: {
          AttributeName: 'REPORT_ID',
          DisplayLabel: 'Report ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DAGAR: {
          AttributeName: 'DAGAR',
          DisplayLabel: 'Dagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="å=360;m=30;d=1";DefaultGroup="d";GroupTexts="dagar=d;dag=d;mån=m;månad=m;månader=m;år=å"',
          FormatterDisplayParams: 'Groups="år=360;mån=30;dagar/dag=1";GroupNameSep=" "',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSUploadBlob: {
      CollectionName: 'SYSUploadBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UploadBlob',
        Abstract: false,
        SOLabel: 'Blob',
        SOGLabel: 'Blobs',
        SBLabel: 'Bloben',
        SBGLabel: 'Blobens',
        POLabel: 'Blobar',
        POGLabel: 'Blobars',
        PBLabel: 'Blobarna',
        PBGLabel: 'Blobarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Blobens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Blobens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Blobens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPLOAD_TIME: {
          AttributeName: 'UPLOAD_TIME',
          DisplayLabel: 'Uppladdningstid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BLOB: {
          AttributeName: 'BLOB',
          DisplayLabel: 'Blob',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSGruppVerkat: {
      CollectionName: 'SYSGruppVerkat',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'GruppVerkat',
        Abstract: false,
        SOLabel: 'Bokföringsgrupp, rutin',
        SOGLabel: 'Bokföringsgrupp, rutin',
        SBLabel: 'Bokföringsgrupp, rutinen',
        SBGLabel: 'Bokföringsgrupp, rutinen',
        POLabel: 'Bokföringsgrupp, rutiner',
        POGLabel: 'Bokföringsgrupp, rutiner',
        PBLabel: 'Bokföringsgrupp, rutinerna',
        PBGLabel: 'Bokföringsgrupp, rutinerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsgrupp, rutinen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsgrupp, rutinen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsgrupp, rutinen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsgrupp, rutinen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VERKAT_KOD: {
          AttributeName: 'VERKAT_KOD',
          DisplayLabel: 'Verifikationskategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BVR=Verifikationsregistrering;BPV=Periodisera verifikationer;BIS=Import enligt SIE;BIL=Inläsning av löneverifikationer;BII=Internfördelning från Lön;BOL=Bokför om lön;BPA=Avsluta projekt;BBO=Bokför omfördelning;BÄM=Bokför om ändamålsbestämda medel;BAK=Bokföringsfil från KOB;BFK=Kollektfil från KOB;BOM=Bokför om momsskuld;BAR=Ankomstregistrering;BDB=Definitivbokning;BBU=Bokför utbetalningsuppdrag;BBR=Återredovisning av utbetalningar;BFB=Fakturabunt;BJB=Justera belopp för leverantörsfakturor;BJL=Makulera fakturahändelse;BMI=Manuell inbetalning;BAI=Inbetalningar KOB och Autogiro;BIF=Inbetalningar Bg/Pg;BAA=Återredovisning från orderintegration;BBB=Betalning av bankkontofakturor;BRI=Betalning av internfakturor;BIA=Insättning på avtal;BKK=Kreditering;BUT=Utbetalning av tillgodohavande;BBT=Beräkna tillgodoränta;FKU=Kravutskrift;BJK=Makulering/justering av fakturahändelser;BMK=Makulering/justering av kontohändelser;FOR=Order;FKO=Kreditorder;FIO=Importera orderunderlag;FFA=Fakturering;FDR=Dröjsmålsräntefakturering;FBT=Kundfakturabunt;FGA=Fakturera gravskötslar;BKG=Kreditera gravskötslar;FAV=Avräkna avräkningsavtal;FSA=Fakturera gravskötselavtal;FAK=Avräkna fasttidsavtal;FUF=Uppräkna fasttidsavtal;FBE=Skapa beställningsorder;BJA=Justera saldo på avtal;FBO=Fakturera aktiviteter;BAV=Bokför avskrivningar;BIN=Bokför internränta;BNS=Nedskrivning;BAU=Avyttring/utrangering/omklassificering;BAP=Aktivera pågående investeringar;BKI=Ombokför påg. investeringar/investeringsrader;BMA=Makulera aktivering av påg. investeringar;BMO=Makulera ombokföring av påg. investeringar/investeringsrader;BMV=Makulera senaste bokförda händelsen;BAO=Omklassificering;BAB=Byt investeringskonto;FKJ=Fakturera kremationer;BTI=Bokför tidrapporteringar;FBJ=Fakturera bisättningar;BWB=Bokföringsorder;FWO=WebOrder"',
        },
        JOURNALHANTERING: {
          AttributeName: 'JOURNALHANTERING',
          DisplayLabel: 'Journalhantering',
          Hint: 'Manuellt/Fråga vid avslut/Bokför direkt',
          DataType: 'Enum',
          EnumValues: new Map([['MANUELLT', 'Manuellt'], ['FRAGA_VID_AVSLUT', 'Fråga vid avslut'], ['BOKFOR_DIREKT', 'Bokför direkt']]),
          EnumSortValues: new Map([['MANUELLT', 'MAN'], ['FRAGA_VID_AVSLUT', 'FAV'], ['BOKFOR_DIREKT', 'BDI']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MANUELLT=Manuellt;FRAGA_VID_AVSLUT=Fråga vid avslut;BOKFOR_DIREKT=Bokför direkt"',
          InterfaceType: 'ifChecklist',
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD_SIGNATUR: {
          AttributeName: 'SENAST_ANDRAD_SIGNATUR',
          DisplayLabel: 'Senast ändrad signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokforingsgrupp: {
          AssociationName: 'Bokforingsgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Grupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSGrupp: {
      CollectionName: 'SYSGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['Serietyp 1B', 'JOURNALNR'], ['Serietyp 2B', 'VERNR'], ['Serietyp 3B', 'BUNTNR'], ['Serietyp 4B', 'BOKFORDNR'], ['Delsystem 1B', 'SYS'], ['Delsystem 2B', 'EK'], ['Delsystem 3B', 'LR'], ['Delsystem 4B', 'KR'], ['Delsystem 5B', 'OF'], ['Delsystem 6B', 'BO'], ['Delsystem 7B', 'GA'], ['Serietyp 1F', 'JOURNALNR'], ['Serietyp 2F', 'VERNR'], ['Serietyp 3F', 'FAKTURANR'], ['Serietyp 4F', 'ORDERNR'], ['Delsystem 1F', 'SYS'], ['Delsystem 2F', 'OF'], ['Delsystem 3F', 'KR'], ['Delsystem 4F', 'GA'], ['Delsystem 5F', 'BO'], ['DisplayLabel 1B', 'Journalnummer'], ['DisplayLabel 2B', 'Verifikationsnummer'], ['DisplayLabel 3B', 'Buntnummer'], ['DisplayLabel 4B', 'Bokföringsordernummer'], ['DisplayLabel 1F', 'Journalnummer'], ['DisplayLabel 2F', 'Verifikationsnummer'], ['DisplayLabel 3F', 'Fakturanummer'], ['DisplayLabel 4F', 'Ordernummer'], ['AllowSelection', '15006']]),
      RootType: {
        TypeValue: 'Grupp',
        Abstract: true,
        SOLabel: 'Bokföringsgrupp',
        SOGLabel: 'Bokföringsgrupp',
        SBLabel: 'Bokföringsgruppen',
        SBGLabel: 'Bokföringsgruppen',
        POLabel: 'Bokföringsgrupper',
        POGLabel: 'Bokföringsgrupper',
        PBLabel: 'Bokföringsgrupperna',
        PBGLabel: 'Bokföringsgrupperna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'BokfGrupp',
            Abstract: false,
            SOLabel: 'Bokföringsgrupp',
            SOGLabel: 'Bokföringsgrupp',
            SBLabel: 'Bokföringsgruppen',
            SBGLabel: 'Bokföringsgruppen',
            POLabel: 'Bokföringsgrupper',
            POGLabel: 'Bokföringsgrupper',
            PBLabel: 'Bokföringsgrupperna',
            PBGLabel: 'Bokföringsgrupperna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'BokfgruppFakt',
                Abstract: false,
                SOLabel: 'Faktureringsgrupp',
                SOGLabel: 'Faktureringsgrupp',
                SBLabel: 'Faktureringsgruppen',
                SBGLabel: 'Faktureringsgruppen',
                POLabel: 'Faktureringsgrupper',
                POGLabel: 'Faktureringsgrupper',
                PBLabel: 'Faktureringsgrupperna',
                PBGLabel: 'Faktureringsgrupperna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFGRUPP', 'Bokföringsgrupp'], ['BOKFGRUPPFAKT', 'Faktureringsgrupp']]),
          EnumSortValues: new Map([['BOKFGRUPP', 'B'], ['BOKFGRUPPFAKT', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        SERIE_ID_1: {
          AttributeName: 'SERIE_ID_1',
          DisplayLabel: 'Serie 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_2: {
          AttributeName: 'SERIE_ID_2',
          DisplayLabel: 'Serie 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_3: {
          AttributeName: 'SERIE_ID_3',
          DisplayLabel: 'Serie 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_4: {
          AttributeName: 'SERIE_ID_4',
          DisplayLabel: 'Serie 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_5: {
          AttributeName: 'SERIE_ID_5',
          DisplayLabel: 'Serie 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_6: {
          AttributeName: 'SERIE_ID_6',
          DisplayLabel: 'Serie 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_7: {
          AttributeName: 'SERIE_ID_7',
          DisplayLabel: 'Serie 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_8: {
          AttributeName: 'SERIE_ID_8',
          DisplayLabel: 'Serie 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_9: {
          AttributeName: 'SERIE_ID_9',
          DisplayLabel: 'Serie 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_ID_10: {
          AttributeName: 'SERIE_ID_10',
          DisplayLabel: 'Serie 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
          AttributeGroup: 'Borttagen',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        SerieBen1: {
          AttributeName: 'SerieBen1',
          DisplayLabel: 'Journalnummerserie',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SerieBen2: {
          AttributeName: 'SerieBen2',
          DisplayLabel: 'Verifikationsnummerserie',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SerieBen3: {
          AttributeName: 'SerieBen3',
          DisplayLabel: 'Fakturanummerserie',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SerieBen4: {
          AttributeName: 'SerieBen4',
          DisplayLabel: 'Ordernummerserie',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTEGRATIONSTYP: {
          AttributeName: 'INTEGRATIONSTYP',
          DisplayLabel: 'Integration med redovisning',
          Hint: 'Aveny/Bokföringsunderlag till annat system/Lista/Orderintegration/Ingen',
          DataType: 'Enum',
          EnumValues: new Map([['AVENY', 'Aveny'], ['BOKFORINGSUNDERLAG_TILL_ANNAT_SYSTEM', 'Bokföringsunderlag till annat system'], ['LISTA', 'Lista'], ['ORDERINTEGRATION', 'Orderintegration'], ['INGEN', 'Ingen']]),
          EnumSortValues: new Map([['AVENY', 'A'], ['BOKFORINGSUNDERLAG_TILL_ANNAT_SYSTEM', 'B'], ['LISTA', 'L'], ['ORDERINTEGRATION', 'O'], ['INGEN', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVENY=Aveny;BOKFORINGSUNDERLAG_TILL_ANNAT_SYSTEM=Bokföringsunderlag till annat system;LISTA=Lista;ORDERINTEGRATION=Orderintegration;INGEN=Ingen"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['BokfGrupp'],
        },
        AVSANDARKOD_PG: {
          AttributeName: 'AVSANDARKOD_PG',
          DisplayLabel: 'Avsändarkod till PlusGirot',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 2,
          ValidInComps: ['BokfGrupp'],
          AttributeGroup: 'Leverantörsfakturor',
        },
        AVSLUTA_SKOTSEL: {
          AttributeName: 'AVSLUTA_SKOTSEL',
          DisplayLabel: 'Avsluta skötsel vid kreditering av erbjudande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
          ValidInComps: ['BokfGrupp'],
          AttributeGroup: 'Gravskötsel',
        },
        ORDINARIE_DETALJNIVA: {
          AttributeName: 'ORDINARIE_DETALJNIVA',
          DisplayLabel: 'Ordinarie summeringsnivå',
          Hint: 'Verifikationsrad/Verifikation/Journal/Datum',
          DataType: 'Enum',
          EnumValues: new Map([['VERIFIKATIONSRAD', 'Verifikationsrad'], ['VERIFIKATION', 'Verifikation'], ['JOURNAL_DATUM', 'Journal/Datum']]),
          EnumSortValues: new Map([['VERIFIKATIONSRAD', '0'], ['VERIFIKATION', '1'], ['JOURNAL_DATUM', '2']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VERIFIKATIONSRAD=Verifikationsrad;VERIFIKATION=Verifikation;JOURNAL_DATUM=Journal/Datum"',
          GUIEditable: true,
          ValidInComps: ['BokfGrupp'],
        },
        KBKostnadskonto: {
          AttributeName: 'KBKostnadskonto',
          DisplayLabel: 'KBKostnadskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        Kostnadskonto: {
          AttributeName: 'Kostnadskonto',
          DisplayLabel: 'Kostnadskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        KBLevskuldkonto: {
          AttributeName: 'KBLevskuldkonto',
          DisplayLabel: 'KBLevskuldkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        Levskuldkonto: {
          AttributeName: 'Levskuldkonto',
          DisplayLabel: 'Leverantörsskuldkonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        KBPrelkontoAR: {
          AttributeName: 'KBPrelkontoAR',
          DisplayLabel: 'KBPrelkontoAR',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        PrelkontoAR: {
          AttributeName: 'PrelkontoAR',
          DisplayLabel: 'Preliminärkonto vid ankomstregistrering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        KBIngaendeMomsKonto: {
          AttributeName: 'KBIngaendeMomsKonto',
          DisplayLabel: 'KBIngaendeMomsKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        IngaendeMomsKonto: {
          AttributeName: 'IngaendeMomsKonto',
          DisplayLabel: 'Konto för ingående moms',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        KBInterimskontoKostnad: {
          AttributeName: 'KBInterimskontoKostnad',
          DisplayLabel: 'KBInterimskontoKostnad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        InterimskontoKostnad: {
          AttributeName: 'InterimskontoKostnad',
          DisplayLabel: 'Interimskonto för kostnader',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        KBUtgaendeMomsKonto: {
          AttributeName: 'KBUtgaendeMomsKonto',
          DisplayLabel: 'KBUtgaendeMomsKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        UtgaendeMomsKonto: {
          AttributeName: 'UtgaendeMomsKonto',
          DisplayLabel: 'UtgaendeMomsKonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        KBInterimsKontoIntakt: {
          AttributeName: 'KBInterimsKontoIntakt',
          DisplayLabel: 'KBInterimsKontoIntakt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        InterimsKontoIntakt: {
          AttributeName: 'InterimsKontoIntakt',
          DisplayLabel: 'Interimskonto för intäkter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfGrupp'],
        },
        ELEKTRONISK_ATTEST: {
          AttributeName: 'ELEKTRONISK_ATTEST',
          DisplayLabel: 'Elektronisk attest',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          ValidInComps: ['BokfGrupp'],
          AttributeGroup: 'Leverantörsfakturor',
        },
        RuleGRUPP_ID: {
          AttributeName: 'RuleGRUPP_ID',
          DisplayLabel: 'RuleGRUPP_ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDERTYP: {
          AttributeName: 'ORDERTYP',
          DisplayLabel: 'Ordertyp att fakturera',
          Hint: 'Direktorder/Erbjudande/Beställningsorder/Fasttidsavtalsorder/Periodmall/Avräkningsavtalsorder',
          DataType: 'Enum',
          EnumValues: new Map([['DIREKTORDER', 'Direktorder'], ['ERBJUDANDE', 'Erbjudande'], ['BESTALLNINGSORDER', 'Beställningsorder'], ['FASTTIDSAVTALSORDER', 'Fasttidsavtalsorder'], ['PERIODMALL', 'Periodmall'], ['AVRAKNINGSAVTALSORDER', 'Avräkningsavtalsorder']]),
          EnumSortValues: new Map([['DIREKTORDER', 'D'], ['ERBJUDANDE', 'E'], ['BESTALLNINGSORDER', 'O'], ['FASTTIDSAVTALSORDER', 'V'], ['PERIODMALL', 'P'], ['AVRAKNINGSAVTALSORDER', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DIREKTORDER=Direktorder;ERBJUDANDE=Erbjudande;BESTALLNINGSORDER=Beställningsorder;FASTTIDSAVTALSORDER=Fasttidsavtalsorder;PERIODMALL=Periodmall;AVRAKNINGSAVTALSORDER=Avräkningsavtalsorder"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        FAKTURERINGSAVGIFT: {
          AttributeName: 'FAKTURERINGSAVGIFT',
          DisplayLabel: 'Administrationsavgift fast',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        ADMINAVGIFT_PROC: {
          AttributeName: 'ADMINAVGIFT_PROC',
          DisplayLabel: 'Administrationsavgift procentuell',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        FORESL_KUNDKATEGORI_ID: {
          AttributeName: 'FORESL_KUNDKATEGORI_ID',
          DisplayLabel: 'Föreslagen kundkategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        FAKTURATEXT: {
          AttributeName: 'FAKTURATEXT',
          DisplayLabel: 'Text på faktura',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        AVR_METOD: {
          AttributeName: 'AVR_METOD',
          DisplayLabel: 'Avräkningsmetod',
          Hint: 'Helår/Halvår/Kvartal/Månad',
          DataType: 'Enum',
          EnumValues: new Map([['HELAR', 'Helår'], ['HALVAR', 'Halvår'], ['KVARTAL', 'Kvartal'], ['MANAD', 'Månad']]),
          EnumSortValues: new Map([['HELAR', 'A'], ['HALVAR', 'H'], ['KVARTAL', 'K'], ['MANAD', 'M']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HELAR=Helår;HALVAR=Halvår;KVARTAL=Kvartal;MANAD=Månad"',
          GUIEditable: true,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Gravskötsel',
        },
        AVR_ART_ID: {
          AttributeName: 'AVR_ART_ID',
          DisplayLabel: 'Avräkningsartikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        AVR_AVRUND_ART_ID: {
          AttributeName: 'AVR_AVRUND_ART_ID',
          DisplayLabel: 'Avrundningsartikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        ADMINARTIKEL_ID: {
          AttributeName: 'ADMINARTIKEL_ID',
          DisplayLabel: 'Administrationsartikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        SAMFAKTURERAS: {
          AttributeName: 'SAMFAKTURERAS',
          DisplayLabel: 'Samfaktureras',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        FAKTURERINGSSATT: {
          AttributeName: 'FAKTURERINGSSATT',
          DisplayLabel: 'Faktureringssätt',
          Hint: 'Faktura/Bankkonto/Autogiro/KOB-faktura',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['BANKKONTO', 'Bankkonto'], ['AUTOGIRO', 'Autogiro'], ['KOB_FAKTURA', 'KOB-faktura']]),
          EnumSortValues: new Map([['FAKTURA', 'F'], ['BANKKONTO', 'B'], ['AUTOGIRO', 'U'], ['KOB_FAKTURA', 'O']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;BANKKONTO=Bankkonto;AUTOGIRO=Autogiro;KOB_FAKTURA=KOB-faktura"',
          GUIEditable: true,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        BETALNINGSVILLKOR_ID: {
          AttributeName: 'BETALNINGSVILLKOR_ID',
          DisplayLabel: 'BetalningsvillkorID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        AVRUNDNINGSVILLKOR: {
          AttributeName: 'AVRUNDNINGSVILLKOR',
          DisplayLabel: 'Avrundningsvillkor',
          Hint: '1,00/Ingen avrundning',
          DataType: 'Enum',
          EnumValues: new Map([['A1_00', '1,00'], ['AINGEN_AVRUNDNING', 'Ingen avrundning']]),
          EnumSortValues: new Map([['A1_00', '100'], ['AINGEN_AVRUNDNING', '1']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="A1_00=1,00;AINGEN_AVRUNDNING=Ingen avrundning"',
          GUIEditable: true,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        SKOTSEL: {
          AttributeName: 'SKOTSEL',
          DisplayLabel: 'Faktureringsgrupp per skötselrad',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          ValidInComps: ['BokfgruppFakt'],
        },
        UTSKRIFT_ARBUND: {
          AttributeName: 'UTSKRIFT_ARBUND',
          DisplayLabel: 'Skriv ut på arbetsunderlag',
          Hint: 'Fakturerade gravskötslar/Betalda gravskötslar/Alla gravskötslar/Ta ej med på arbetsunderlag',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURERADE_GRAVSKOTSLAR', 'Fakturerade gravskötslar'], ['BETALDA_GRAVSKOTSLAR', 'Betalda gravskötslar'], ['ALLA_GRAVSKOTSLAR', 'Alla gravskötslar'], ['TA_EJ_MED_PA_ARBETSUNDERLAG', 'Ta ej med på arbetsunderlag']]),
          EnumSortValues: new Map([['FAKTURERADE_GRAVSKOTSLAR', 'Y'], ['BETALDA_GRAVSKOTSLAR', 'N'], ['ALLA_GRAVSKOTSLAR', 'A'], ['TA_EJ_MED_PA_ARBETSUNDERLAG', 'E']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURERADE_GRAVSKOTSLAR=Fakturerade gravskötslar;BETALDA_GRAVSKOTSLAR=Betalda gravskötslar;ALLA_GRAVSKOTSLAR=Alla gravskötslar;TA_EJ_MED_PA_ARBETSUNDERLAG=Ta ej med på arbetsunderlag"',
          GUIEditable: true,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Gravskötsel',
        },
        UTLADR: {
          AttributeName: 'UTLADR',
          DisplayLabel: 'Utländska adresser',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        ERBJ_TILLGODO_GRUPP_ID: {
          AttributeName: 'ERBJ_TILLGODO_GRUPP_ID',
          DisplayLabel: 'Fakt.grupp för kunder med tillgodohavande',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        ERBJ_TILLGODO_FROM: {
          AttributeName: 'ERBJ_TILLGODO_FROM',
          DisplayLabel: 'Faktura tillgodoh, from',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BokfgruppFakt'],
        },
        ERBJ_TILLGODO_TOM: {
          AttributeName: 'ERBJ_TILLGODO_TOM',
          DisplayLabel: 'Fakturera tillgodoh, tom',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BokfgruppFakt'],
        },
        MANUELLT_FAKTURANR_ORDER: {
          AttributeName: 'MANUELLT_FAKTURANR_ORDER',
          DisplayLabel: 'Manuell fakturanummer på order',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          ValidInComps: ['BokfgruppFakt'],
        },
        RANTEFAKTURERAS: {
          AttributeName: 'RANTEFAKTURERAS',
          DisplayLabel: 'Räntefakturera',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BokfgruppFakt'],
          AttributeGroup: 'Kundfakturor',
        },
        RANTEFAKT_GRUPP_ID: {
          AttributeName: 'RANTEFAKT_GRUPP_ID',
          DisplayLabel: 'Räntefaktureras på avvikande grupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        KBIntaktskonto: {
          AttributeName: 'KBIntaktskonto',
          DisplayLabel: 'KBIntaktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        Intaktskonto: {
          AttributeName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        KBKundfordrkonto: {
          AttributeName: 'KBKundfordrkonto',
          DisplayLabel: 'KBKundfordrkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        Kundfordrkonto: {
          AttributeName: 'Kundfordrkonto',
          DisplayLabel: 'Kundfordringars konto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        KBOresavrundkonto: {
          AttributeName: 'KBOresavrundkonto',
          DisplayLabel: 'KBOresavrundkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        Oresavrundkonto: {
          AttributeName: 'Oresavrundkonto',
          DisplayLabel: 'Konto fär öresavrundning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        KBOAdminAvgiftkonto: {
          AttributeName: 'KBOAdminAvgiftkonto',
          DisplayLabel: 'KBOAdminAvgiftkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        AdminAvgiftkonto: {
          AttributeName: 'AdminAvgiftkonto',
          DisplayLabel: 'Konto för administrationsavgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        AdminArtikel: {
          AttributeName: 'AdminArtikel',
          DisplayLabel: 'Administrationsartikel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        AdminArtikelnr: {
          AttributeName: 'AdminArtikelnr',
          DisplayLabel: 'Administrationsartikelnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        AdminArtikelMoms: {
          AttributeName: 'AdminArtikelMoms',
          DisplayLabel: 'Administrationsartikelmoms',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        BetalningsvillkorAntalDagar: {
          AttributeName: 'BetalningsvillkorAntalDagar',
          DisplayLabel: 'Antal dagar (betalningsvillkor)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        BetalningsvillkorText: {
          AttributeName: 'BetalningsvillkorText',
          DisplayLabel: 'Betalningsvillkor text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        DROJS_ARTIKEL_ID: {
          AttributeName: 'DROJS_ARTIKEL_ID',
          DisplayLabel: 'Artikel, dröjsmålsränta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BokfgruppFakt'],
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'IDkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'GAS',
        },
        GRUPPTYP_ID: {
          AttributeName: 'GRUPPTYP_ID',
          DisplayLabel: 'Gupptid, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVSER_KGF: {
          AttributeName: 'AVSER_KGF',
          DisplayLabel: 'Avser KGF',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EndastForOrderImport: {
          AttributeName: 'EndastForOrderImport',
          DisplayLabel: 'Används endast för orderimport',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Extern utskrift',
        },
        AVITYP: {
          AttributeName: 'AVITYP',
          DisplayLabel: 'Avityp för extern utskrift',
          Hint: 'Utan avi/Utan avi OCR/Plusgiro OCR/Bankgiro/Bankgiro OCR',
          DataType: 'Enum',
          EnumValues: new Map([['UTAN_AVI', 'Utan avi'], ['UTAN_AVI_OCR', 'Utan avi OCR'], ['PLUSGIRO_OCR', 'Plusgiro OCR'], ['BANKGIRO', 'Bankgiro'], ['BANKGIRO_OCR', 'Bankgiro OCR']]),
          EnumSortValues: new Map([['UTAN_AVI', 'N'], ['UTAN_AVI_OCR', 'O'], ['PLUSGIRO_OCR', 'Q'], ['BANKGIRO', 'B'], ['BANKGIRO_OCR', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UTAN_AVI=Utan avi;UTAN_AVI_OCR=Utan avi OCR;PLUSGIRO_OCR=Plusgiro OCR;BANKGIRO=Bankgiro;BANKGIRO_OCR=Bankgiro OCR"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Extern utskrift',
        },
        EXTRA_FAKTURARAD: {
          AttributeName: 'EXTRA_FAKTURARAD',
          DisplayLabel: 'Text på faktura',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANV_FOR_ATTESTORDER: {
          AttributeName: 'ANV_FOR_ATTESTORDER',
          DisplayLabel: 'Används för attestorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KOB_TILLAT_MOMS: {
          AttributeName: 'KOB_TILLAT_MOMS',
          DisplayLabel: 'KOB, tillåt moms',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Övrigt',
        },
        POSTTYP_FAKTURA: {
          AttributeName: 'POSTTYP_FAKTURA',
          DisplayLabel: 'Posttyp, faktura',
          Hint: 'Ekonomibrev (B-post)/1:a klassbrev (A-post)',
          DataType: 'Enum',
          EnumValues: new Map([['PEKONOMIBREV__B_POST_', 'Ekonomibrev (B-post)'], ['P1_A_KLASSBREV__A_POST_', '1:a klassbrev (A-post)']]),
          EnumSortValues: new Map([['PEKONOMIBREV__B_POST_', 'B'], ['P1_A_KLASSBREV__A_POST_', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PEKONOMIBREV__B_POST_=Ekonomibrev (B-post);P1_A_KLASSBREV__A_POST_=1:a klassbrev (A-post)"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        POSTTYP_PAMINNELSE: {
          AttributeName: 'POSTTYP_PAMINNELSE',
          DisplayLabel: 'Posttyp, påminnelse',
          Hint: 'Ekonomibrev (B-post)/1:a klassbrev (A-post)',
          DataType: 'Enum',
          EnumValues: new Map([['PEKONOMIBREV__B_POST_', 'Ekonomibrev (B-post)'], ['P1_A_KLASSBREV__A_POST_', '1:a klassbrev (A-post)']]),
          EnumSortValues: new Map([['PEKONOMIBREV__B_POST_', 'B'], ['P1_A_KLASSBREV__A_POST_', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PEKONOMIBREV__B_POST_=Ekonomibrev (B-post);P1_A_KLASSBREV__A_POST_=1:a klassbrev (A-post)"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERIODORDER: {
          AttributeName: 'PERIODORDER',
          DisplayLabel: 'Hantera periodorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERIODORDER_UPPDATERA_PRISER: {
          AttributeName: 'PERIODORDER_UPPDATERA_PRISER',
          DisplayLabel: 'Periodmall, använd aktuella priser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Konteringsvarde: {
          AssociationName: 'Konteringsvarde',
          DisplayLabel: 'Konteringsvärde',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kostnadskonto: {
          AssociationName: 'Kostnadskonto',
          DisplayLabel: 'Kostnadskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Levskuldkonto: {
          AssociationName: 'Levskuldkonto',
          DisplayLabel: 'Leverantörsskuldkonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        PrelkontoAR: {
          AssociationName: 'PrelkontoAR',
          DisplayLabel: 'Preliminärkonto vid ankomstregistrering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        IngaendeMomsKonto: {
          AssociationName: 'IngaendeMomsKonto',
          DisplayLabel: 'Konto för ingående moms',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InterimskontoKostnad: {
          AssociationName: 'InterimskontoKostnad',
          DisplayLabel: 'Interimskonto för kostnader',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        UtgaendeMomsKonto: {
          AssociationName: 'UtgaendeMomsKonto',
          DisplayLabel: 'Konto för utgående moms',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        InterimsKontoIntakt: {
          AssociationName: 'InterimsKontoIntakt',
          DisplayLabel: 'Interimskonto för intäkter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ForeslKundkategori: {
          AssociationName: 'ForeslKundkategori',
          DisplayLabel: 'Föreslagen kundkategori',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKundkategori',
          AssociatedComponentName: 'KundKategori',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kundfordrkonto: {
          AssociationName: 'Kundfordrkonto',
          DisplayLabel: 'Kundfordringars konto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Oresavrundkonto: {
          AssociationName: 'Oresavrundkonto',
          DisplayLabel: 'Konto för öresavrundning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AdminAvgiftKonto: {
          AssociationName: 'AdminAvgiftKonto',
          DisplayLabel: 'Konto för administrationsavgift',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Avrakningsartikel: {
          AssociationName: 'Avrakningsartikel',
          DisplayLabel: 'Avräkningsartikel',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avrundningsartikel: {
          AssociationName: 'Avrundningsartikel',
          DisplayLabel: 'Avrundningsartikel',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AdminArtikel: {
          AssociationName: 'AdminArtikel',
          DisplayLabel: 'Artikel för administrationsavgift',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsvillkor: {
          AssociationName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBetalningsvillkor',
          AssociatedComponentName: 'Betalningsvillkor',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KundkategoriFaktgrupp: {
          AssociationName: 'KundkategoriFaktgrupp',
          DisplayLabel: 'KundkategoriFaktgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKundkatFaktGrupp',
          AssociatedComponentName: 'KundkatFaktGrupp',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TillgodohGrupp: {
          AssociationName: 'TillgodohGrupp',
          DisplayLabel: 'TillgodohGrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RantefaktGrupp: {
          AssociationName: 'RantefaktGrupp',
          DisplayLabel: 'RantefaktGrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Grupp',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Drojsmalsavgift: {
          AssociationName: 'Drojsmalsavgift',
          DisplayLabel: 'Artikel för dröjsmålsränta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Avgift',
          JoinAssociation: true,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Grupptyp: {
          AssociationName: 'Grupptyp',
          DisplayLabel: 'Grupptyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBokfgrupptyp',
          AssociatedComponentName: 'Bokfgrupptyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Verifikationskategorier: {
          AssociationName: 'Verifikationskategorier',
          DisplayLabel: 'Verifikationskategorier',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGruppVerkat',
          AssociatedComponentName: 'GruppVerkat',
          JoinAssociation: false,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Attestgrupp: {
          AssociationName: 'Attestgrupp',
          DisplayLabel: 'Attestgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGruppAttestgrupp',
          AssociatedComponentName: 'GruppAttestgrupp',
          JoinAssociation: false,
          ValidInComps: ['BokfGrupp'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturalayoutgrupp: {
          AssociationName: 'Fakturalayoutgrupp',
          DisplayLabel: 'Fakturalayoutgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturalayoutGrupp',
          AssociatedComponentName: 'FakturalayoutGrupp',
          JoinAssociation: false,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ArtikelgruppGrupp: {
          AssociationName: 'ArtikelgruppGrupp',
          DisplayLabel: 'Artikelgrupper',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtGruppFaktgrupp',
          AssociatedComponentName: 'ArtgruppFaktGrupp',
          JoinAssociation: false,
          ValidInComps: ['BokfgruppFakt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSBokfgrupptyp: {
      CollectionName: 'SYSBokfgrupptyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bokfgrupptyp',
        Abstract: false,
        SOLabel: 'Bokföringsgrupptyp',
        SOGLabel: 'Bokföringsgrupptyps',
        SBLabel: 'Bokföringsgrupptypen',
        SBGLabel: 'Bokföringsgrupptypens',
        POLabel: 'Bokföringsgrupptyper',
        POGLabel: 'Bokföringsgrupptypers',
        PBLabel: 'Bokföringsgrupptyperna',
        PBGLabel: 'Bokföringsgrupptypernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsgrupptypens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsgrupptypens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsgrupptypens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsgrupptypens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GILTIG_FOR_TYP: {
          AttributeName: 'GILTIG_FOR_TYP',
          DisplayLabel: 'Giltig för typ',
          Hint: 'Bokföringsgrupp/Faktureringsgrupp',
          DataType: 'Enum',
          EnumValues: new Map([['BOKFORINGSGRUPP', 'Bokföringsgrupp'], ['FAKTURERINGSGRUPP', 'Faktureringsgrupp']]),
          EnumSortValues: new Map([['BOKFORINGSGRUPP', 'B'], ['FAKTURERINGSGRUPP', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKFORINGSGRUPP=Bokföringsgrupp;FAKTURERINGSGRUPP=Faktureringsgrupp"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DUPLIKATA_GRUPPER: {
          AttributeName: 'DUPLIKATA_GRUPPER',
          DisplayLabel: 'Duplikata grupper',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSBokfPeriod: {
      CollectionName: 'SYSBokfPeriod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokfPeriod',
        Abstract: false,
        SOLabel: 'Bokföringsperiod',
        SOGLabel: 'Bokföringsperiod',
        SBLabel: 'Bokföringsperioden',
        SBGLabel: 'Bokföringsperioden',
        POLabel: 'Bokföringsperioder',
        POGLabel: 'Bokföringsperioder',
        PBLabel: 'Bokföringsperioderna',
        PBGLabel: 'Bokföringsperioderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsperioden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsperioden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsperioden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsperioden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        PERIOD: {
          AttributeName: 'PERIOD',
          DisplayLabel: 'Period',
          Hint: 'Ex 1,2, ..13',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="13"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Månad',
          Hint: 'Ex Januari, Februari',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
          Required: true,
        },
        FORKORTNING: {
          AttributeName: 'FORKORTNING',
          DisplayLabel: 'Månad, förkortning',
          Hint: 'Ex Jan, Feb',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
          Required: true,
        },
        FRAN_DATUM: {
          AttributeName: 'FRAN_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        TILL_DATUM: {
          AttributeName: 'TILL_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        LAST: {
          AttributeName: 'LAST',
          DisplayLabel: 'Låst',
          Hint: 'Låst/Ej låst',
          DataType: 'Enum',
          EnumValues: new Map([['LAST', 'Låst'], ['EJ_LAST', 'Ej låst']]),
          EnumSortValues: new Map([['LAST', 'Y'], ['EJ_LAST', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAST=Låst;EJ_LAST=Ej låst"',
          GUIEditable: true,
        },
        BOKSLUTSPERIOD: {
          AttributeName: 'BOKSLUTSPERIOD',
          DisplayLabel: 'Bokslutsperiod',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        BokfarPeriod: {
          AttributeName: 'BokfarPeriod',
          DisplayLabel: 'År och period',
          Hint: '2010-10',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LAST_DATUM: {
          AttributeName: 'LAST_DATUM',
          DisplayLabel: 'Låst datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokfar: {
          AssociationName: 'Bokfar',
          DisplayLabel: 'Bokföringsår',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokfar',
          AssociatedComponentName: 'Bokfar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSBokfarBlob: {
      CollectionName: 'SYSBokfarBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokfarBlob',
        Abstract: false,
        SOLabel: 'Bokföringsår',
        SOGLabel: 'Bokföringsår',
        SBLabel: 'Bokföringsåret',
        SBGLabel: 'Bokföringsåret',
        POLabel: 'Bokföringsår',
        POGLabel: 'Bokföringsår',
        PBLabel: 'Bokföringsåren',
        PBGLabel: 'Bokföringsåren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsåret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsåret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsåret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsåret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FIL: {
          AttributeName: 'FIL',
          DisplayLabel: 'Fil',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STORLEK: {
          AttributeName: 'STORLEK',
          DisplayLabel: 'Filstorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Inläsningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN: {
          AttributeName: 'SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSBokfar: {
      CollectionName: 'SYSBokfar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y'], ['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Bokfar',
        Abstract: false,
        SOLabel: 'Bokföringsår',
        SOGLabel: 'Bokföringsår',
        SBLabel: 'Bokföringsåret',
        SBGLabel: 'Bokföringsåret',
        POLabel: 'Bokföringsår',
        POGLabel: 'Bokföringsår',
        PBLabel: 'Bokföringsåren',
        PBGLabel: 'Bokföringsåren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokföringsåret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokföringsåret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokföringsåret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokföringsåret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        FRAN_DATUM: {
          AttributeName: 'FRAN_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        TILL_DATUM: {
          AttributeName: 'TILL_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        LAST: {
          AttributeName: 'LAST',
          DisplayLabel: 'Bokföringsår låst',
          Hint: 'Låst/Ej låst',
          DataType: 'Enum',
          EnumValues: new Map([['LAST', 'Låst'], ['EJ_LAST', 'Ej låst']]),
          EnumSortValues: new Map([['LAST', 'Y'], ['EJ_LAST', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAST=Låst;EJ_LAST=Ej låst"',
          GUIEditable: true,
        },
        VALUTA_ID: {
          AttributeName: 'VALUTA_ID',
          DisplayLabel: 'Valuta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IB_LAST: {
          AttributeName: 'IB_LAST',
          DisplayLabel: 'Ingåendebalans låst',
          Hint: 'Låst/Öppen',
          DataType: 'Enum',
          EnumValues: new Map([['LAST', 'Låst'], ['OPPEN', 'Öppen']]),
          EnumSortValues: new Map([['LAST', 'Y'], ['OPPEN', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAST=Låst;OPPEN=Öppen"',
          GUIEditable: true,
        },
        AKTUELLT_ORGNR: {
          AttributeName: 'AKTUELLT_ORGNR',
          DisplayLabel: 'Aktuellt orgnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTUELLT_ORGNAMN: {
          AttributeName: 'AKTUELLT_ORGNAMN',
          DisplayLabel: 'Aktuellt orgnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EK_ARKIV_SKICKAT_STATUS: {
          AttributeName: 'EK_ARKIV_SKICKAT_STATUS',
          DisplayLabel: 'Arkivering, status',
          Hint: 'Skickad till Svenska kyrkans e-arkiv/Arkiverad i Svenska kyrkans e-arkiv/Felaktig/Arkiverad i Aveny/Ej arkiverad',
          DataType: 'Enum',
          EnumValues: new Map([['SKICKAD_TILL_SVENSKA_KYRKANS_E_ARKIV', 'Skickad till Svenska kyrkans e-arkiv'], ['ARKIVERAD_I_SVENSKA_KYRKANS_E_ARKIV', 'Arkiverad i Svenska kyrkans e-arkiv'], ['FELAKTIG', 'Felaktig'], ['ARKIVERAD_I_AVENY', 'Arkiverad i Aveny'], ['EJ_ARKIVERAD', 'Ej arkiverad']]),
          EnumSortValues: new Map([['SKICKAD_TILL_SVENSKA_KYRKANS_E_ARKIV', 'S'], ['ARKIVERAD_I_SVENSKA_KYRKANS_E_ARKIV', 'M'], ['FELAKTIG', 'F'], ['ARKIVERAD_I_AVENY', 'A'], ['EJ_ARKIVERAD', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKICKAD_TILL_SVENSKA_KYRKANS_E_ARKIV=Skickad till Svenska kyrkans e-arkiv;ARKIVERAD_I_SVENSKA_KYRKANS_E_ARKIV=Arkiverad i Svenska kyrkans e-arkiv;FELAKTIG=Felaktig;ARKIVERAD_I_AVENY=Arkiverad i Aveny;EJ_ARKIVERAD=Ej arkiverad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_SKICKAT_DATUM: {
          AttributeName: 'EK_ARKIV_SKICKAT_DATUM',
          DisplayLabel: 'Arkivpaket, skickat datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_SKICKAT_TID: {
          AttributeName: 'EK_ARKIV_SKICKAT_TID',
          DisplayLabel: 'Arkivpaket, skickat klockslag',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_SKICKAT_STORLEK: {
          AttributeName: 'EK_ARKIV_SKICKAT_STORLEK',
          DisplayLabel: 'Arkivpaket, storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_SKICKAT_SPEC_VERSION: {
          AttributeName: 'EK_ARKIV_SKICKAT_SPEC_VERSION',
          DisplayLabel: 'Arkivpaket, version',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_KVITTENS_STATUS: {
          AttributeName: 'EK_ARKIV_KVITTENS_STATUS',
          DisplayLabel: 'Arkivering, status kvittens',
          Hint: 'Ej mottagen/Mottagen/Felaktig',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_MOTTAGEN', 'Ej mottagen'], ['MOTTAGEN', 'Mottagen'], ['FELAKTIG', 'Felaktig']]),
          EnumSortValues: new Map([['EJ_MOTTAGEN', 'E'], ['MOTTAGEN', 'M'], ['FELAKTIG', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_MOTTAGEN=Ej mottagen;MOTTAGEN=Mottagen;FELAKTIG=Felaktig"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_KVITTENS_DATUM: {
          AttributeName: 'EK_ARKIV_KVITTENS_DATUM',
          DisplayLabel: 'Arkivering, kvittens datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_KVITTENS_STORLEK: {
          AttributeName: 'EK_ARKIV_KVITTENS_STORLEK',
          DisplayLabel: 'Arkivering, kvittens storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Arkivering',
        },
        ANTAGEN_DATUM: {
          AttributeName: 'ANTAGEN_DATUM',
          DisplayLabel: 'Antagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAGEN_TEXT: {
          AttributeName: 'ANTAGEN_TEXT',
          DisplayLabel: 'Antagen text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        HarBokforing: {
          AttributeName: 'HarBokforing',
          DisplayLabel: 'Har bokföring',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        LAST_DATUM: {
          AttributeName: 'LAST_DATUM',
          DisplayLabel: 'Låst, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SkaArkiveras: {
          AttributeName: 'SkaArkiveras',
          DisplayLabel: 'Ska arkiveras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Arkivering',
        },
        KanArkiveras: {
          AttributeName: 'KanArkiveras',
          DisplayLabel: 'Kan arkiveras (Ja/Nej)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Arkivering',
        },
        EK_ARKIV_SKAPAT_DATUM: {
          AttributeName: 'EK_ARKIV_SKAPAT_DATUM',
          DisplayLabel: 'Arkivpaket, skapat datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          AttributeGroup: 'Arkivering',
        },
        KanArkiverasDatum: {
          AttributeName: 'KanArkiverasDatum',
          DisplayLabel: 'Kan arkiveras, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        KanArkiverasText: {
          AttributeName: 'KanArkiverasText',
          DisplayLabel: 'Kan arkiveras',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BordeVaraArkiverad: {
          AttributeName: 'BordeVaraArkiverad',
          DisplayLabel: 'Borde vara arkiverad',
          Hint: 'Om inte året är arkiverat så stoppar det GDPR-gallring för Ekonomi - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Arkivering',
        },
        SKV_LAST: {
          AttributeName: 'SKV_LAST',
          DisplayLabel: 'Skattemässiga värden låsta',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKV_LAST_DATUM: {
          AttributeName: 'SKV_LAST_DATUM',
          DisplayLabel: 'Låst, skattemässiga värden datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Systemvaluta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokfperiod: {
          AssociationName: 'Bokfperiod',
          DisplayLabel: 'Bokföringsperioder',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokfPeriod',
          AssociatedComponentName: 'BokfPeriod',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSBokngrupp: {
      CollectionName: 'SYSBokngrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bokngrupp',
        Abstract: false,
        SOLabel: 'Bokningsgrupp',
        SOGLabel: 'Bokningsgrupp',
        SBLabel: 'Bokningsgruppen',
        SBGLabel: 'Bokningsgruppen',
        POLabel: 'Bokningsgrupper',
        POGLabel: 'Bokningsgrupper',
        PBLabel: 'Bokningsgrupperna',
        PBGLabel: 'Bokningsgrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokningsgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokningsgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokningsgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokningsgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        SKK_ORG_ID: {
          AttributeName: 'SKK_ORG_ID',
          DisplayLabel: 'Svenskakyrkans kalender OrganisationsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKK_ORG_WSSURL: {
          AttributeName: 'SKK_ORG_WSSURL',
          DisplayLabel: 'wssURL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SMTP_INTERN: {
          AttributeName: 'SMTP_INTERN',
          DisplayLabel: 'Epost, intern',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Intaktskonto: {
          AttributeName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBIntaktskonto: {
          AttributeName: 'KBIntaktskonto',
          DisplayLabel: 'KBIntaktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKK_REGION_ID: {
          AttributeName: 'SKK_REGION_ID',
          DisplayLabel: 'RegionID/ProjektID',
          Hint: 'ID för de enheter som inte har OrgID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPARR_FR: {
          AttributeName: 'SPARR_FR',
          DisplayLabel: 'Spärra bokningar fr.o.m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        SPARR_TO: {
          AttributeName: 'SPARR_TO',
          DisplayLabel: 'Spärra bokningar t.o.m',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        BoknGruppResurs: {
          AssociationName: 'BoknGruppResurs',
          DisplayLabel: 'Bokningsgrupp av resurser',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBoknGruppResurs',
          AssociatedComponentName: 'BokngruppResurs',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktTypResrubrik: {
          AssociationName: 'AktTypResrubrik',
          DisplayLabel: 'Resursrubrik på aktivitetstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktTypResrubrik',
          AssociatedComponentName: 'AktTypResrubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AkttypBoknGrupp: {
          AssociationName: 'AkttypBoknGrupp',
          DisplayLabel: 'Aktivitetsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOTEDBOAkttypBokngrupp',
          AssociatedComponentName: 'AktTypBoknGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        VerksamhetstypBoknGrupp: {
          AssociationName: 'VerksamhetstypBoknGrupp',
          DisplayLabel: 'Verksamhetstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOVerktypBoknGrupp',
          AssociatedComponentName: 'VerktypBoknGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSDelsystemansvar: {
      CollectionName: 'SYSDelsystemansvar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Delsystemansvar',
        Abstract: false,
        SOLabel: 'Delsystemansvar',
        SOGLabel: 'Delsystemansvar',
        SBLabel: 'Delsystemansvaret',
        SBGLabel: 'Delsystemansvaret',
        POLabel: 'Delsystemansvar',
        POGLabel: 'Delsystemansvar',
        PBLabel: 'Delsystemansvaren',
        PBGLabel: 'Delsystemansvaren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Delsystemansvaret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Delsystemansvaret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Delsystemansvaret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Delsystemansvaret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSDiariegrupp: {
      CollectionName: 'SYSDiariegrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Diariegrupp',
        Abstract: false,
        SOLabel: 'Diariegrupp',
        SOGLabel: 'Diariegrupp',
        SBLabel: 'Diariegruppen',
        SBGLabel: 'Diariegruppen',
        POLabel: 'Diariegrupper',
        POGLabel: 'Diariegrupper',
        PBLabel: 'Diariegrupperna',
        PBGLabel: 'Diariegrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Diariegruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Diariegruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Diariegruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Diariegruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        POSTLISTA_SERIEID: {
          AttributeName: 'POSTLISTA_SERIEID',
          DisplayLabel: 'Postlista serie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        DIARIENRSERIE_ID: {
          AttributeName: 'DIARIENRSERIE_ID',
          DisplayLabel: 'Diarienummerserie ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        PostlistSerie: {
          AssociationName: 'PostlistSerie',
          DisplayLabel: 'Postlisteserie',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'StandigNummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gruppplan: {
          AssociationName: 'Gruppplan',
          DisplayLabel: 'Gruppplan',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DIGruppplan',
          AssociatedComponentName: 'Gruppplan',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Diarieplannr: {
          AssociationName: 'Diarieplannr',
          DisplayLabel: 'Diarieplannummer',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'DITEDDIDiarieplannr',
          AssociatedComponentName: 'Diarieplannr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSDigitalSignering: {
      CollectionName: 'SYSDigitalSignering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '19013']]),
      RootType: {
        TypeValue: 'DigitalSignering',
        Abstract: true,
        SOLabel: 'Digital signering',
        SOGLabel: 'Digital signerings',
        SBLabel: 'Digital signeringen',
        SBGLabel: 'Digital signeringens',
        POLabel: 'Digital signeringar',
        POGLabel: 'Digital signeringars',
        PBLabel: 'Digital signeringarna',
        PBGLabel: 'Digital signeringarnas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'DigitalAveny',
            Abstract: false,
            SOLabel: 'Aveny signering',
            SOGLabel: 'Aveny signerings',
            SBLabel: 'Aveny signeringen',
            SBGLabel: 'Aveny signeringens',
            POLabel: 'Aveny signeringar',
            POGLabel: 'Aveny signeringars',
            PBLabel: 'Aveny signeringarna',
            PBGLabel: 'Aveny signeringarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'DigitalGrav',
            Abstract: false,
            SOLabel: 'Grav signering',
            SOGLabel: 'Grav signerings',
            SBLabel: 'Grav signeringen',
            SBGLabel: 'Grav signeringens',
            POLabel: 'Grav signeringar',
            POGLabel: 'Grav signeringars',
            PBLabel: 'Grav signeringarna',
            PBGLabel: 'Grav signeringarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'DigitalBisattning',
            Abstract: false,
            SOLabel: 'Bisättning signering',
            SOGLabel: 'Bisättning signerings',
            SBLabel: 'Bisättning signeringen',
            SBGLabel: 'Bisättning signeringens',
            POLabel: 'Bisättning signeringar',
            POGLabel: 'Bisättning signeringars',
            PBLabel: 'Bisättning signeringarna',
            PBGLabel: 'Bisättning signeringarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Digital signeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Digital signeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['DIGITALAVENY', 'Aveny signering'], ['DIGITALGRAV', 'Grav signering'], ['DIGITALBISATTNING', 'Bisättning signering']]),
          EnumSortValues: new Map([['DIGITALAVENY', 'A'], ['DIGITALGRAV', 'G'], ['DIGITALBISATTNING', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DIGITALAVENY=Aveny signering;DIGITALGRAV=Grav signering;DIGITALBISATTNING=Bisättning signering"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Digital signeringens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Digital signeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGN_LEV: {
          AttributeName: 'SIGN_LEV',
          DisplayLabel: 'Signeringstjänst',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="K=Kivra;S=Scrive"',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'PersNames="Y"',
          GUIEditable: true,
          MaxInputLength: 125,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MAILADRESS: {
          AttributeName: 'MAILADRESS',
          DisplayLabel: 'E-post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatEmail',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Väntar/Påskrivet/Återtagen/Förfallen',
          DataType: 'Enum',
          EnumValues: new Map([['VANTAR', 'Väntar'], ['PASKRIVET', 'Påskrivet'], ['ATERTAGEN', 'Återtagen'], ['FORFALLEN', 'Förfallen']]),
          EnumSortValues: new Map([['VANTAR', 'V'], ['PASKRIVET', 'P'], ['ATERTAGEN', 'A'], ['FORFALLEN', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VANTAR=Väntar;PASKRIVET=Påskrivet;ATERTAGEN=Återtagen;FORFALLEN=Förfallen"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        SYS_HANDELSE_ID: {
          AttributeName: 'SYS_HANDELSE_ID',
          DisplayLabel: 'Utskickshändelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGN_SYS_HANDELSE_ID: {
          AttributeName: 'SIGN_SYS_HANDELSE_ID',
          DisplayLabel: 'Signeringshändelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Delsystem: {
          AttributeName: 'Delsystem',
          DisplayLabel: 'Skickat av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalSign: {
          AttributeName: 'AntalSign',
          DisplayLabel: 'Antal signerade',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGNDATE: {
          AttributeName: 'SIGNDATE',
          DisplayLabel: 'Signerad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          FormatterDisplayParams: 'HideZeroTime="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notless, T.notgreater, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Dokument: {
          AttributeName: 'Dokument',
          DisplayLabel: 'Dokument',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Skickaddatum: {
          AttributeName: 'Skickaddatum',
          DisplayLabel: 'Skickad datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notless, T.notgreater],
          DefaultCondOperator: T.interval,
        },
        Gravutskick: {
          AttributeName: 'Gravutskick',
          DisplayLabel: 'Gravutskick mottagare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Gravplats: {
          AttributeName: 'Gravplats',
          DisplayLabel: 'Gravplats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravhandelseID: {
          AttributeName: 'GravhandelseID',
          DisplayLabel: 'GravhandelseID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BisattningHandelseID: {
          AttributeName: 'BisattningHandelseID',
          DisplayLabel: 'BisattningHandelseID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bisattning: {
          AttributeName: 'Bisattning',
          DisplayLabel: 'Bisättning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bisattningutskick: {
          AttributeName: 'Bisattningutskick',
          DisplayLabel: 'Bisattningutskick mottagare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Utskickshändelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SysHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        SignHandelse: {
          AssociationName: 'SignHandelse',
          DisplayLabel: 'Signeringshändelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SysHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Gravhandelse: {
          AssociationName: 'Gravhandelse',
          DisplayLabel: 'Grav utskickshändelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: true,
          ValidInComps: ['DigitalGrav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BisattningHandelse: {
          AssociationName: 'BisattningHandelse',
          DisplayLabel: 'Bisättning utskickhändelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: true,
          ValidInComps: ['DigitalBisattning'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sammahandelse: {
          AssociationName: 'Sammahandelse',
          DisplayLabel: 'Signeringar på samma händelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSDigitalSignering',
          AssociatedComponentName: 'DigitalSignering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSDigitalaTenants: {
      CollectionName: 'SYSDigitalaTenants',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'DigitalaTenants',
        Abstract: false,
        SOLabel: 'Digital tenant',
        SOGLabel: 'Digital tenants',
        SBLabel: 'Digitala tenant',
        SBGLabel: 'Digitala tenants',
        POLabel: 'Digitala tenants',
        POGLabel: 'Digitala tenants',
        PBLabel: 'Digitala tenants',
        PBGLabel: 'Digitala tenants',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Digitala tenants primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Digitala tenants versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Digitala tenants fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REQUEST_ID: {
          AttributeName: 'REQUEST_ID',
          DisplayLabel: 'Request ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 64,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REQUEST_DATE: {
          AttributeName: 'REQUEST_DATE',
          DisplayLabel: 'Förfrågan datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notless, T.notgreater, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VAT_NR: {
          AttributeName: 'VAT_NR',
          DisplayLabel: 'Momsreg nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 14,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        COMPANYNAME: {
          AttributeName: 'COMPANYNAME',
          DisplayLabel: 'Företagsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 96,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TENANT_KEY: {
          AttributeName: 'TENANT_KEY',
          DisplayLabel: 'Extern nyckel (tenant_key)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 64,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CREATED_AT: {
          AttributeName: 'CREATED_AT',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notless, T.notgreater, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SHA_LOGO: {
          AttributeName: 'SHA_LOGO',
          DisplayLabel: 'SHA logo checksum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 32,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSUDAttributes: {
      CollectionName: 'SYSUDAttributes',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UDAttributes',
        Abstract: false,
        SOLabel: 'Egendefinierat fält',
        SOGLabel: 'Egendefinierat fält',
        SBLabel: 'Egendefinierade fältet',
        SBGLabel: 'Egendefinierade fältet',
        POLabel: 'Egendefinierade fält',
        POGLabel: 'Egendefinierade fält',
        PBLabel: 'Egendefinierade fälten',
        PBGLabel: 'Egendefinierade fälten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Egendefinierade fältet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Egendefinierade fältet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Egendefinierade fältet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Egendefinierade fältet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UDA_TYPE: {
          AttributeName: 'UDA_TYPE',
          DisplayLabel: 'Typ',
          Hint: 'Text/Heltal/Decimaltal/Belopp/Datum (ÅÅÅÅ-MM-DD)/Årtal (ÅÅÅÅ)/Månad (ÅÅÅÅ-MM)/Vecka (ÅÅÅÅ-VV)/Kryssruta/Lista (Tillåtna värden)/Lista (Förslag)',
          DataType: 'Enum',
          EnumValues: new Map([['TEXT', 'Text'], ['HELTAL', 'Heltal'], ['DECIMALTAL', 'Decimaltal'], ['BELOPP', 'Belopp'], ['DATUM__AAAA_MM_DD_', 'Datum (ÅÅÅÅ-MM-DD)'], ['ARTAL__AAAA_', 'Årtal (ÅÅÅÅ)'], ['MANAD__AAAA_MM_', 'Månad (ÅÅÅÅ-MM)'], ['VECKA__AAAA_VV_', 'Vecka (ÅÅÅÅ-VV)'], ['KRYSSRUTA', 'Kryssruta'], ['LISTA__TILLATNA_VARDEN_', 'Lista (Tillåtna värden)'], ['LISTA__FORSLAG_', 'Lista (Förslag)']]),
          EnumSortValues: new Map([['TEXT', 'A'], ['HELTAL', 'I'], ['DECIMALTAL', 'F'], ['BELOPP', 'C'], ['DATUM__AAAA_MM_DD_', 'D'], ['ARTAL__AAAA_', 'Y'], ['MANAD__AAAA_MM_', 'M'], ['VECKA__AAAA_VV_', 'V'], ['KRYSSRUTA', 'B'], ['LISTA__TILLATNA_VARDEN_', 'S'], ['LISTA__FORSLAG_', 'P']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TEXT=Text;HELTAL=Heltal;DECIMALTAL=Decimaltal;BELOPP=Belopp;DATUM__AAAA_MM_DD_=Datum (ÅÅÅÅ-MM-DD);ARTAL__AAAA_=Årtal (ÅÅÅÅ);MANAD__AAAA_MM_=Månad (ÅÅÅÅ-MM);VECKA__AAAA_VV_=Vecka (ÅÅÅÅ-VV);KRYSSRUTA=Kryssruta;LISTA__TILLATNA_VARDEN_=Lista (Tillåtna värden);LISTA__FORSLAG_=Lista (Förslag)"',
          InterfaceType: 'ifBoolean',
        },
        FIELD_SIZE: {
          AttributeName: 'FIELD_SIZE',
          DisplayLabel: 'Antal tecken',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        ATTRIBUTE_NAME: {
          AttributeName: 'ATTRIBUTE_NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        HINT: {
          AttributeName: 'HINT',
          DisplayLabel: 'Beskrivning',
          Hint: 'Visas när man håller över fältet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DEFAULT_VALUE: {
          AttributeName: 'DEFAULT_VALUE',
          DisplayLabel: 'Förvalt värde',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        VALID_VALUES: {
          AttributeName: 'VALID_VALUES',
          DisplayLabel: 'Giltiga värden',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Enabled/Disabled',
          DataType: 'Enum',
          EnumValues: new Map([['ENABLED', 'Enabled'], ['DISABLED', 'Disabled']]),
          EnumSortValues: new Map([['ENABLED', 'E'], ['DISABLED', 'D']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENABLED=Enabled;DISABLED=Disabled"',
          InterfaceType: 'ifBoolean',
        },
        UDA_GROUP: {
          AttributeName: 'UDA_GROUP',
          DisplayLabel: 'Grupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        UDA_REQUIRED: {
          AttributeName: 'UDA_REQUIRED',
          DisplayLabel: 'Krav',
          Hint: 'Måste fältet fyllas i?',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifBoolean',
        },
        UDA_ORDER: {
          AttributeName: 'UDA_ORDER',
          DisplayLabel: 'Sorteringsordning',
          Hint: 'I vilken ordning ska fältet synas?',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        WEB_AVENY: {
          AttributeName: 'WEB_AVENY',
          DisplayLabel: 'WebAveny',
          Hint: 'Ska fältet synas i Web Aveny? - Visas ej/Kan ändras av bokningssignaturen/Kan ändras av alla',
          DataType: 'Enum',
          EnumValues: new Map([['VISAS_EJ', 'Visas ej'], ['KAN_ANDRAS_AV_BOKNINGSSIGNATUREN', 'Kan ändras av bokningssignaturen'], ['KAN_ANDRAS_AV_ALLA', 'Kan ändras av alla']]),
          EnumSortValues: new Map([['VISAS_EJ', 'N'], ['KAN_ANDRAS_AV_BOKNINGSSIGNATUREN', 'V'], ['KAN_ANDRAS_AV_ALLA', 'Ä']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VISAS_EJ=Visas ej;KAN_ANDRAS_AV_BOKNINGSSIGNATUREN=Kan ändras av bokningssignaturen;KAN_ANDRAS_AV_ALLA=Kan ändras av alla"',
          InterfaceType: 'ifBoolean',
        },
        SYNKAOUTLOOK: {
          AttributeName: 'SYNKAOUTLOOK',
          DisplayLabel: 'Outlook',
          Hint: 'Ska fältet synkas med till outlook? - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSUDNotes: {
      CollectionName: 'SYSUDNotes',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UDNotes',
        Abstract: false,
        SOLabel: 'Egendefinierad notering',
        SOGLabel: 'Egendefinierad notering',
        SBLabel: 'Egendefinierade noteringen',
        SBGLabel: 'Egendefinierade noteringen',
        POLabel: 'Egendefinierade noteringar',
        POGLabel: 'Egendefinierade noteringar',
        PBLabel: 'Egendefinierade noteringarna',
        PBGLabel: 'Egendefinierade noteringarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Egendefinierade noteringen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Egendefinierade noteringen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Egendefinierade noteringen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Egendefinierade noteringen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ATTRIBUTE_NAME: {
          AttributeName: 'ATTRIBUTE_NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        HINT: {
          AttributeName: 'HINT',
          DisplayLabel: 'Beskrivning',
          Hint: 'Visas när man håller över fältet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Enabled/Disabled',
          DataType: 'Enum',
          EnumValues: new Map([['ENABLED', 'Enabled'], ['DISABLED', 'Disabled']]),
          EnumSortValues: new Map([['ENABLED', 'E'], ['DISABLED', 'D']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENABLED=Enabled;DISABLED=Disabled"',
        },
        UDN_ORDER: {
          AttributeName: 'UDN_ORDER',
          DisplayLabel: 'Sorteringsordning',
          Hint: 'I vilken ordning ska fältet synas?',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WEB_AVENY: {
          AttributeName: 'WEB_AVENY',
          DisplayLabel: 'WebAveny',
          Hint: 'Ska fältet synas i Web Aveny? - Visas ej/Kan ändras av bokningssignaturen/Kan ändras av alla',
          DataType: 'Enum',
          EnumValues: new Map([['VISAS_EJ', 'Visas ej'], ['KAN_ANDRAS_AV_BOKNINGSSIGNATUREN', 'Kan ändras av bokningssignaturen'], ['KAN_ANDRAS_AV_ALLA', 'Kan ändras av alla']]),
          EnumSortValues: new Map([['VISAS_EJ', 'N'], ['KAN_ANDRAS_AV_BOKNINGSSIGNATUREN', 'V'], ['KAN_ANDRAS_AV_ALLA', 'Ä']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VISAS_EJ=Visas ej;KAN_ANDRAS_AV_BOKNINGSSIGNATUREN=Kan ändras av bokningssignaturen;KAN_ANDRAS_AV_ALLA=Kan ändras av alla"',
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSEpostBegrepp: {
      CollectionName: 'SYSEpostBegrepp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Epostbegrepp',
        Abstract: false,
        SOLabel: 'Epostbegrepp',
        SOGLabel: 'Epostbegrepp',
        SBLabel: 'Epostbegreppet',
        SBGLabel: 'Epostbegreppet',
        POLabel: 'Epostbegrepp',
        POGLabel: 'Epostbegrepp',
        PBLabel: 'Epostbegreppen',
        PBGLabel: 'Epostbegreppen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Epostbegreppet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Epostbegreppet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Epostbegreppet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Epostbegreppet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        DELSYSTEM: {
          AttributeName: 'DELSYSTEM',
          DisplayLabel: 'Delsystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
        },
        KLASSNAMN: {
          AttributeName: 'KLASSNAMN',
          DisplayLabel: 'Klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        ATTRIBUT_1: {
          AttributeName: 'ATTRIBUT_1',
          DisplayLabel: 'Attribut 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        ATTRIBUT_2: {
          AttributeName: 'ATTRIBUT_2',
          DisplayLabel: 'Attribut 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        ATTRIBUT_3: {
          AttributeName: 'ATTRIBUT_3',
          DisplayLabel: 'Attribut 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        ATTRIBUT_4: {
          AttributeName: 'ATTRIBUT_4',
          DisplayLabel: 'Attribut 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        ATTRIBUT_5: {
          AttributeName: 'ATTRIBUT_5',
          DisplayLabel: 'Attribut 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSEpostlogg: {
      CollectionName: 'SYSEpostlogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Epostlogg',
        Abstract: false,
        SOLabel: 'Epostlogg',
        SOGLabel: 'Epostlogg',
        SBLabel: 'Epostloggen',
        SBGLabel: 'Epostloggen',
        POLabel: 'Epostloggar',
        POGLabel: 'Epostloggar',
        PBLabel: 'Epostloggarna',
        PBGLabel: 'Epostloggarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Epostloggen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Epostloggen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Epostloggen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Epostloggen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_1: {
          AttributeName: 'VARDE_1',
          DisplayLabel: 'Värde 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_2: {
          AttributeName: 'VARDE_2',
          DisplayLabel: 'Värde 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_3: {
          AttributeName: 'VARDE_3',
          DisplayLabel: 'Värde 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_4: {
          AttributeName: 'VARDE_4',
          DisplayLabel: 'Värde 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_5: {
          AttributeName: 'VARDE_5',
          DisplayLabel: 'Värde 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        SENDER: {
          AttributeName: 'SENDER',
          DisplayLabel: 'Avsändare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        SKICKATDATUM: {
          AttributeName: 'SKICKATDATUM',
          DisplayLabel: 'Skickat datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        SKICKADTID: {
          AttributeName: 'SKICKADTID',
          DisplayLabel: 'Skickad tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
        },
        SMTPSERVER: {
          AttributeName: 'SMTPSERVER',
          DisplayLabel: 'smtpserver',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        MOTTAGARE: {
          AttributeName: 'MOTTAGARE',
          DisplayLabel: 'Mottagare',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.interval, T.notinterval],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSEpostloggBlob',
          AssociatedComponentName: 'EpostloggBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    SYSEpostloggBlob: {
      CollectionName: 'SYSEpostloggBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'EpostloggBlob',
        Abstract: false,
        SOLabel: 'Epostlogg mottagare',
        SOGLabel: 'Epostloggs mottagare',
        SBLabel: 'Epostloggen mottagare',
        SBGLabel: 'Epostloggens mottagare',
        POLabel: 'Epostloggar mottagare',
        POGLabel: 'Epostloggars mottagare',
        PBLabel: 'Epostloggarna mottagare',
        PBGLabel: 'Epostloggarnas mottagare',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Epostloggens mottagare primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Epostloggens mottagare versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Epostloggens mottagare fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAGARE: {
          AttributeName: 'MOTTAGARE',
          DisplayLabel: 'Mottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
      },
      Associations: {
      },
    },
    SYSFakturaformedlare: {
      CollectionName: 'SYSFakturaformedlare',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Fakturaformedlare',
        Abstract: false,
        SOLabel: 'Fakturaförmedlare',
        SOGLabel: 'Fakturaförmedlares',
        SBLabel: 'Fakturaförmedlaren',
        SBGLabel: 'Fakturaförmedlarens',
        POLabel: 'Fakturaförmedlare',
        POGLabel: 'Fakturaförmedlares',
        PBLabel: 'Fakturaförmedlarna',
        PBGLabel: 'Fakturaförmedlarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturaförmedlarens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturaförmedlarens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturaförmedlarens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturaförmedlarens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        FAKTURERINGSSATT: {
          AttributeName: 'FAKTURERINGSSATT',
          DisplayLabel: 'Gäller för faktureringssätt',
          Hint: 'Faktura/Bankkonto/Autogiro/KOB-faktura',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['BANKKONTO', 'Bankkonto'], ['AUTOGIRO', 'Autogiro'], ['KOB_FAKTURA', 'KOB-faktura']]),
          EnumSortValues: new Map([['FAKTURA', 'F'], ['BANKKONTO', 'B'], ['AUTOGIRO', 'U'], ['KOB_FAKTURA', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;BANKKONTO=Bankkonto;AUTOGIRO=Autogiro;KOB_FAKTURA=KOB-faktura"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LEVERANSKATALOG: {
          AttributeName: 'LEVERANSKATALOG',
          DisplayLabel: 'Leveranskatalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KVITTENSKATALOG: {
          AttributeName: 'KVITTENSKATALOG',
          DisplayLabel: 'Kvittenskatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Id-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        KalkLeveranskatalog: {
          AttributeName: 'KalkLeveranskatalog',
          DisplayLabel: 'Leveranskatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KalkKvittenskatalog: {
          AttributeName: 'KalkKvittenskatalog',
          DisplayLabel: 'Kvittenskatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INFOTEXT: {
          AttributeName: 'INFOTEXT',
          DisplayLabel: 'Dröjsmål/påminnelse text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVAND_EFAKT_FORETAG: {
          AttributeName: 'ANVAND_EFAKT_FORETAG',
          DisplayLabel: 'E-fakturering företag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVAND_EFAKT_PRIV: {
          AttributeName: 'ANVAND_EFAKT_PRIV',
          DisplayLabel: 'E-fakturering priva',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVAND_FAKTURERING: {
          AttributeName: 'ANVAND_FAKTURERING',
          DisplayLabel: 'Fakturering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EFAKT_PREFIX: {
          AttributeName: 'EFAKT_PREFIX',
          DisplayLabel: 'EfakturaID prefix',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 4,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FTP_HOST: {
          AttributeName: 'FTP_HOST',
          DisplayLabel: 'FTP host',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FTP_USERNAME: {
          AttributeName: 'FTP_USERNAME',
          DisplayLabel: 'FTP username',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FTP_PASSWORD: {
          AttributeName: 'FTP_PASSWORD',
          DisplayLabel: 'FTP password',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FTP_PORT: {
          AttributeName: 'FTP_PORT',
          DisplayLabel: 'FTP port',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FTP_DIRECTORY: {
          AttributeName: 'FTP_DIRECTORY',
          DisplayLabel: 'FTP directory',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FAKTUTSTALLARE_BANK: {
          AttributeName: 'FAKTUTSTALLARE_BANK',
          DisplayLabel: 'Fakturautställarens bank',
          Hint: 'SEB/Handelsbanken/Danske Bank/Swedbank/Nordea/SkandiaBanken/Sparbanken Öresund/ICA-banken/Länsförsäkringar Bank/DNB Bank/Sparbanken Syd/SBAB Bank/Ålandsbanken',
          DataType: 'Enum',
          EnumValues: new Map([['SEB', 'SEB'], ['HANDELSBANKEN', 'Handelsbanken'], ['DANSKE_BANK', 'Danske Bank'], ['SWEDBANK', 'Swedbank'], ['NORDEA', 'Nordea'], ['SKANDIABANKEN', 'SkandiaBanken'], ['SPARBANKEN_ORESUND', 'Sparbanken Öresund'], ['ICA_BANKEN', 'ICA-banken'], ['LANSFORSAKRINGAR_BANK', 'Länsförsäkringar Bank'], ['DNB_BANK', 'DNB Bank'], ['SPARBANKEN_SYD', 'Sparbanken Syd'], ['SBAB_BANK', 'SBAB Bank'], ['ALANDSBANKEN', 'Ålandsbanken']]),
          EnumSortValues: new Map([['SEB', 'SEB'], ['HANDELSBANKEN', 'SHB'], ['DANSKE_BANK', 'OEB'], ['SWEDBANK', 'FSPA'], ['NORDEA', 'NB'], ['SKANDIABANKEN', 'SKB'], ['SPARBANKEN_ORESUND', 'FINN'], ['ICA_BANKEN', 'ICA'], ['LANSFORSAKRINGAR_BANK', 'LFB'], ['DNB_BANK', 'DNB'], ['SPARBANKEN_SYD', 'SYD'], ['SBAB_BANK', 'SBAB'], ['ALANDSBANKEN', 'AAB']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEB=SEB;HANDELSBANKEN=Handelsbanken;DANSKE_BANK=Danske Bank;SWEDBANK=Swedbank;NORDEA=Nordea;SKANDIABANKEN=SkandiaBanken;SPARBANKEN_ORESUND=Sparbanken Öresund;ICA_BANKEN=ICA-banken;LANSFORSAKRINGAR_BANK=Länsförsäkringar Bank;DNB_BANK=DNB Bank;SPARBANKEN_SYD=Sparbanken Syd;SBAB_BANK=SBAB Bank;ALANDSBANKEN=Ålandsbanken"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOGOTYPE_ID: {
          AttributeName: 'LOGOTYPE_ID',
          DisplayLabel: 'Logotype ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EPOST_MEDDELANDE: {
          AttributeName: 'EPOST_MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    SYSFakturakod: {
      CollectionName: 'SYSFakturakod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Fakturakod',
        Abstract: false,
        SOLabel: 'Fakturakod',
        SOGLabel: 'Fakturakods',
        SBLabel: 'Fakturakoden',
        SBGLabel: 'Fakturakodens',
        POLabel: 'Fakturakoder',
        POGLabel: 'Fakturakoders',
        PBLabel: 'Fakturakoderna',
        PBGLabel: 'Fakturakodernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturakodens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturakodens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturakodens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturakodens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        Standard: {
          AttributeName: 'Standard',
          DisplayLabel: 'Standard',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        KBLevkostKonto: {
          AttributeName: 'KBLevkostKonto',
          DisplayLabel: 'KBLevkostKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Fakturakod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleFakturakodID: {
          AttributeName: 'RuleFakturakodID',
          DisplayLabel: 'RuleFakturakodID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SOKTYP: {
          AttributeName: 'SOKTYP',
          DisplayLabel: 'Sökning i referensfält',
          Hint: 'Börjar på/Exakt/Fritext',
          DataType: 'Enum',
          EnumValues: new Map([['BORJAR_PA', 'Börjar på'], ['EXAKT', 'Exakt'], ['FRITEXT', 'Fritext']]),
          EnumSortValues: new Map([['BORJAR_PA', 'B'], ['EXAKT', 'E'], ['FRITEXT', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BORJAR_PA=Börjar på;EXAKT=Exakt;FRITEXT=Fritext"',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        LevKostKonto: {
          AssociationName: 'LevKostKonto',
          DisplayLabel: 'Kostnadskonto',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSFakturalayoutGrupp: {
      CollectionName: 'SYSFakturalayoutGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'FakturalayoutGrupp',
        Abstract: false,
        SOLabel: 'Fakturalayoutgrupp',
        SOGLabel: 'Fakturalayoutgrupp',
        SBLabel: 'Fakturalayoutgruppen',
        SBGLabel: 'Fakturalayoutgruppen',
        POLabel: 'Fakturalayoutgrupper',
        POGLabel: 'Fakturalayoutgrupper',
        PBLabel: 'Fakturalayoutgrupperna',
        PBGLabel: 'Fakturalayoutgrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturalayoutgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturalayoutgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturalayoutgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturalayoutgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGSNUMMER: {
          AttributeName: 'ORDNINGSNUMMER',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Layoutbenamning: {
          AttributeName: 'Layoutbenamning',
          DisplayLabel: 'Layoutbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GruppBenamning: {
          AttributeName: 'GruppBenamning',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORESLAGEN_KIVRA: {
          AttributeName: 'FORESLAGEN_KIVRA',
          DisplayLabel: 'Förslagen layout för Kivra',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Grupp: {
          AssociationName: 'Grupp',
          DisplayLabel: 'Grupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Grupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Fakturalayout: {
          AssociationName: 'Fakturalayout',
          DisplayLabel: 'Fakturalayout',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturalayout',
          AssociatedComponentName: 'Fakturalayout',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSFakturaradskod: {
      CollectionName: 'SYSFakturaradskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Fakturaradskod',
        Abstract: false,
        SOLabel: 'Fakturaradskod',
        SOGLabel: 'Fakturaradskods',
        SBLabel: 'Fakturaradskoden',
        SBGLabel: 'Fakturaradskodens',
        POLabel: 'Fakturaradskoder',
        POGLabel: 'Fakturaradskoders',
        PBLabel: 'Fakturaradskoderna',
        PBGLabel: 'Fakturaradskodernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturaradskodens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturaradskodens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturaradskodens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturaradskodens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        Standard: {
          AttributeName: 'Standard',
          DisplayLabel: 'Standard',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        KBLevkostKonto: {
          AttributeName: 'KBLevkostKonto',
          DisplayLabel: 'KBLevkostKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleFakturaradskodID: {
          AttributeName: 'RuleFakturaradskodID',
          DisplayLabel: 'RuleFakturaradskodID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Fakturaradskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        LevKostKonto: {
          AssociationName: 'LevKostKonto',
          DisplayLabel: 'Kostnadskonto',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSFramsidan: {
      CollectionName: 'SYSFramsidan',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Framsidan',
        Abstract: false,
        SOLabel: 'Framsidan',
        SOGLabel: 'Framsidan',
        SBLabel: 'Framsidan',
        SBGLabel: 'Framsidan',
        POLabel: 'Framsidan',
        POGLabel: 'Framsidan',
        PBLabel: 'Framsidan',
        PBGLabel: 'Framsidan',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Framsidan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Framsidan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Framsidan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Framsidan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        ROUTINE_NAME: {
          AttributeName: 'ROUTINE_NAME',
          DisplayLabel: 'Rutinnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OUTPUT_FORMAT: {
          AttributeName: 'OUTPUT_FORMAT',
          DisplayLabel: 'Format',
          Hint: 'XML/XML alla fält/JSON/JSONP/HTML/Bild/Nedladdning/ICAL',
          DataType: 'Enum',
          EnumValues: new Map([['XML', 'XML'], ['XML_ALLA_FALT', 'XML alla fält'], ['JSON', 'JSON'], ['JSONP', 'JSONP'], ['HTML', 'HTML'], ['BILD', 'Bild'], ['NEDLADDNING', 'Nedladdning'], ['ICAL', 'ICAL']]),
          EnumSortValues: new Map([['XML', 'X'], ['XML_ALLA_FALT', 'A'], ['JSON', 'J'], ['JSONP', 'P'], ['HTML', 'H'], ['BILD', 'I'], ['NEDLADDNING', 'B'], ['ICAL', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="XML=XML;XML_ALLA_FALT=XML alla fält;JSON=JSON;JSONP=JSONP;HTML=HTML;BILD=Bild;NEDLADDNING=Nedladdning;ICAL=ICAL"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REPORT_ID: {
          AttributeName: 'REPORT_ID',
          DisplayLabel: 'Rapport',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SQL_FILTER: {
          AttributeName: 'SQL_FILTER',
          DisplayLabel: 'SQL-filter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOGIN_KEY: {
          AttributeName: 'LOGIN_KEY',
          DisplayLabel: 'Nyckel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RECORDSET_NAME: {
          AttributeName: 'RECORDSET_NAME',
          DisplayLabel: 'Rotnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RECORD_NAME: {
          AttributeName: 'RECORD_NAME',
          DisplayLabel: 'Radnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CUSTNO: {
          AttributeName: 'CUSTNO',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HTTP_HEADERS: {
          AttributeName: 'HTTP_HEADERS',
          DisplayLabel: 'Http-headers',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UrvalFinns: {
          AttributeName: 'UrvalFinns',
          DisplayLabel: 'Urval finns',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rapport: {
          AssociationName: 'Rapport',
          DisplayLabel: 'Rapport',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSReportNew',
          AssociatedComponentName: 'ReportNew',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Params: {
          AssociationName: 'Params',
          DisplayLabel: 'Parametrar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSFramsidanParam',
          AssociatedComponentName: 'FramsidanParam',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Autenticeringar: {
          AssociationName: 'Autenticeringar',
          DisplayLabel: 'Autenticeringar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSFramsidanAuth',
          AssociatedComponentName: 'FramsidanAuth',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSFranvaro: {
      CollectionName: 'SYSFranvaro',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Franvaro',
        Abstract: false,
        SOLabel: 'Frånvaro',
        SOGLabel: 'Frånvaro',
        SBLabel: 'Frånvaron',
        SBGLabel: 'Frånvaron',
        POLabel: 'Frånvaro',
        POGLabel: 'Frånvaro',
        PBLabel: 'Frånvaron',
        PBGLabel: 'Frånvaron',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Frånvaron primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Frånvaron versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Frånvaron fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användarid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RESERV_ID: {
          AttributeName: 'RESERV_ID',
          DisplayLabel: 'Reserv id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM_FROM: {
          AttributeName: 'DATUM_FROM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM_TOM: {
          AttributeName: 'DATUM_TOM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FOR_BOKFORDER: {
          AttributeName: 'FOR_BOKFORDER',
          DisplayLabel: 'För bokföringsorder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        FOR_UTANORDNING: {
          AttributeName: 'FOR_UTANORDNING',
          DisplayLabel: 'För utanordning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        AUTOSKAPAD: {
          AttributeName: 'AUTOSKAPAD',
          DisplayLabel: 'Autoskapad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AUTOSKAPAD_USER_ID: {
          AttributeName: 'AUTOSKAPAD_USER_ID',
          DisplayLabel: 'Autoskapad, användar id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AUTOSKAPAD_LEVEL: {
          AttributeName: 'AUTOSKAPAD_LEVEL',
          DisplayLabel: 'Autoskapad, nivå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TomDatum: {
          AttributeName: 'TomDatum',
          DisplayLabel: 'TomDatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        TomDatumStr: {
          AttributeName: 'TomDatumStr',
          DisplayLabel: 'TomDatumStr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Datum: {
          AttributeName: 'Datum',
          DisplayLabel: 'Frånvaroperiod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DelegeradFranPath: {
          AttributeName: 'DelegeradFranPath',
          DisplayLabel: 'Delegeringsväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DelegeradFranPathSort: {
          AttributeName: 'DelegeradFranPathSort',
          DisplayLabel: 'Delegeringsväg, med datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DelegeradReservForPath: {
          AttributeName: 'DelegeradReservForPath',
          DisplayLabel: 'Reserv för delegeringsväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DelegeradReservForPathSort: {
          AttributeName: 'DelegeradReservForPathSort',
          DisplayLabel: 'Reserv för delegeringsväg, med datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Reserv: {
          AssociationName: 'Reserv',
          DisplayLabel: 'Användarens reserv',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AutoskapadFran: {
          AssociationName: 'AutoskapadFran',
          DisplayLabel: 'Delegerad från',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSAdranvGallrLogg: {
      CollectionName: 'SYSAdranvGallrLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AdranvGallrLogg',
        Abstract: false,
        SOLabel: 'Gallringslogg',
        SOGLabel: 'Gallringsloggs',
        SBLabel: 'Gallringsloggen',
        SBGLabel: 'Gallringsloggens',
        POLabel: 'Gallringsloggar',
        POGLabel: 'Gallringsloggars',
        PBLabel: 'Gallringsloggarna',
        PBGLabel: 'Gallringsloggarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gallringsloggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gallringsloggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gallringsloggens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'OK/Fel',
          DataType: 'Enum',
          EnumValues: new Map([['OK', 'OK'], ['FEL', 'Fel']]),
          EnumSortValues: new Map([['OK', '1'], ['FEL', '2']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="OK=OK;FEL=Fel"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GALLRAT_ANTAL: {
          AttributeName: 'GALLRAT_ANTAL',
          DisplayLabel: 'Gallrat, antal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.contains],
          DefaultCondOperator: T.contains,
        },
        ANTAL_SEKUNDER: {
          AttributeName: 'ANTAL_SEKUNDER',
          DisplayLabel: 'Tid, antal sekunder',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KortMeddelande: {
          AttributeName: 'KortMeddelande',
          DisplayLabel: 'Kort meddelande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Adressanvandning: {
          AssociationName: 'Adressanvandning',
          DisplayLabel: 'Adressanvändning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdressanvandning',
          AssociatedComponentName: 'Adressanvandning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSMalluserGrupptyp: {
      CollectionName: 'SYSMalluserGrupptyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'MalluserGrupptyp',
        Abstract: false,
        SOLabel: 'GBS-rollens grupptyper',
        SOGLabel: 'GBS-rollens grupptyper',
        SBLabel: 'GBS-rollens grupptyper',
        SBGLabel: 'GBS-rollens grupptyper',
        POLabel: 'GBS-rollens grupptyper',
        POGLabel: 'GBS-rollens grupptyper',
        PBLabel: 'GBS-rollens grupptyper',
        PBGLabel: 'GBS-rollens grupptyper',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GBS-rollens grupptyper primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GBS-rollens grupptyper versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GBS-rollens grupptyper fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPPTYP_ID: {
          AttributeName: 'GRUPPTYP_ID',
          DisplayLabel: 'Grupptyp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grupptyp: {
          AssociationName: 'Grupptyp',
          DisplayLabel: 'Grupptyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBokfgrupptyp',
          AssociatedComponentName: 'Bokfgrupptyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSGDPRInventeringLogg: {
      CollectionName: 'SYSGDPRInventeringLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GDPRInventeringLogg',
        Abstract: false,
        SOLabel: 'GDPR Inventering, logg',
        SOGLabel: 'GDPR Inventering, logg',
        SBLabel: 'GDPR Inventering, logg',
        SBGLabel: 'GDPR Inventering, logg',
        POLabel: 'GDPR Inventering, logg',
        POGLabel: 'GDPR Inventering, logg',
        PBLabel: 'GDPR Inventering, logg',
        PBGLabel: 'GDPR Inventering, logg',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GDPR Inventering, logg primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GDPR Inventering, logg versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GDPR Inventering, logg fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM_TID: {
          AttributeName: 'DATUM_TID',
          DisplayLabel: 'Datum och tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Exporterat av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOKUMENT: {
          AttributeName: 'DOKUMENT',
          DisplayLabel: 'Dokument',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSGDPRInventering: {
      CollectionName: 'SYSGDPRInventering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GDPRInventering',
        Abstract: false,
        SOLabel: 'GDPR, inventering',
        SOGLabel: 'GDPR, inventerings',
        SBLabel: 'GDPR, inventeringen',
        SBGLabel: 'GDPR, inventeringens',
        POLabel: 'GDPR, inventeringar',
        POGLabel: 'GDPR, inventeringars',
        PBLabel: 'GDPR, inventeringarna',
        PBGLabel: 'GDPR, inventeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GDPR, inventeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GDPR, inventeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'GDPR, inventeringens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GDPR, inventeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MALL_NAMN: {
          AttributeName: 'MALL_NAMN',
          DisplayLabel: 'Mallnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Klar: {
          AttributeName: 'Klar',
          DisplayLabel: 'Inventering klar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
      },
      Associations: {
        Svar: {
          AssociationName: 'Svar',
          DisplayLabel: 'Svar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGDPRInventeringSvar',
          AssociatedComponentName: 'GDPRInventeringSvar',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Logg: {
          AssociationName: 'Logg',
          DisplayLabel: 'Logg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGDPRInventeringLogg',
          AssociatedComponentName: 'GDPRInventeringLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSGDPRInventeringSvar: {
      CollectionName: 'SYSGDPRInventeringSvar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GDPRInventeringSvar',
        Abstract: false,
        SOLabel: 'GDPR, inventeringssvar',
        SOGLabel: 'GDPR, inventeringssvars',
        SBLabel: 'GDPR, inventeringssvaret',
        SBGLabel: 'GDPR, inventeringssvarets',
        POLabel: 'GDPR, inventeringssvar',
        POGLabel: 'GDPR, inventeringssvars',
        PBLabel: 'GDPR, inventeringssvaren',
        PBGLabel: 'GDPR, inventeringssvarens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GDPR, inventeringssvarets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GDPR, inventeringssvarets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'GDPR, inventeringssvarets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GDPR, inventeringssvarets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Fält, kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KALLA: {
          AttributeName: 'KALLA',
          DisplayLabel: 'Källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'ANVÄNDS INTE Status',
          Hint: 'Återstår/Preliminär/Klar',
          DataType: 'Enum',
          EnumValues: new Map([['ATERSTAR', 'Återstår'], ['PRELIMINAR', 'Preliminär'], ['KLAR', 'Klar']]),
          EnumSortValues: new Map([['ATERSTAR', 'E'], ['PRELIMINAR', 'P'], ['KLAR', 'K']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATERSTAR=Återstår;PRELIMINAR=Preliminär;KLAR=Klar"',
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD_USER_ID: {
          AttributeName: 'SENAST_ANDRAD_USER_ID',
          DisplayLabel: 'Senast ändrad av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENAST_ANDRAD_DATUM: {
          AttributeName: 'SENAST_ANDRAD_DATUM',
          DisplayLabel: 'Senast ändrad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VER_DATUM_AVENY_SVAR: {
          AttributeName: 'VER_DATUM_AVENY_SVAR',
          DisplayLabel: 'Versionsdatum på svar från Aveny',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AVENY_SVAR: {
          AttributeName: 'AVENY_SVAR',
          DisplayLabel: 'Svar från Aveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        KUND_SVAR: {
          AttributeName: 'KUND_SVAR',
          DisplayLabel: 'Kundens svar/kommentar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        Svar: {
          AttributeName: 'Svar',
          DisplayLabel: 'Svar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Besvarad: {
          AttributeName: 'Besvarad',
          DisplayLabel: 'Besvarad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSGruppAttestgrupp: {
      CollectionName: 'SYSGruppAttestgrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GruppAttestgrupp',
        Abstract: false,
        SOLabel: 'Godkänd attestgrupp',
        SOGLabel: 'Godkänd attestgrupp',
        SBLabel: 'Godkända attestgruppen',
        SBGLabel: 'Godkända attestgruppen',
        POLabel: 'Godkända attestgrupper',
        POGLabel: 'Godkända attestgrupper',
        PBLabel: 'Godkända attestgrupperna',
        PBGLabel: 'Godkända attestgrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Godkända attestgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Godkända attestgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Godkända attestgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Godkända attestgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Attestgrupp: {
          AttributeName: 'Attestgrupp',
          DisplayLabel: 'Attestgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bokfgrupp: {
          AttributeName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Attestgrupp: {
          AssociationName: 'Attestgrupp',
          DisplayLabel: 'Attestgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestGrupp',
          AssociatedComponentName: 'Attestgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokfgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Bokfgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSKommunikatorHistorik: {
      CollectionName: 'SYSKommunikatorHistorik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: '',
        Abstract: true,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSKommunikatorHistoriks primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSKommunikatorHistoriks versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSKommunikatorHistoriks fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEXT_INTERN: {
          AttributeName: 'TEXT_INTERN',
          DisplayLabel: 'Text_Intern',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LISTID: {
          AttributeName: 'LISTID',
          DisplayLabel: 'PrenumerationsId',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt64',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval],
          DefaultCondOperator: T.interval,
        },
        TEXT_EXTERN: {
          AttributeName: 'TEXT_EXTERN',
          DisplayLabel: 'Text_Extern',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        loggLabel: {
          AttributeName: 'loggLabel',
          DisplayLabel: 'Loggnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SysHandelse: {
      CollectionName: 'SysHandelse',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Handelse',
        Abstract: false,
        SOLabel: 'Händelse',
        SOGLabel: 'Händelses',
        SBLabel: 'Händelsen',
        SBGLabel: 'Händelsens',
        POLabel: 'Händelser',
        POGLabel: 'Händelsers',
        PBLabel: 'Händelserna',
        PBGLabel: 'Händelsernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Händelsens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Händelsens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Händelsens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Händelsens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Dokument',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATA_NAMN: {
          AttributeName: 'DATA_NAMN',
          DisplayLabel: 'Dokument',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 260,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSBetalningssatt: {
      CollectionName: 'SYSBetalningssatt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Betalningssatt',
        Abstract: true,
        SOLabel: 'Inbetalningssätt',
        SOGLabel: 'Inbetalningssätt',
        SBLabel: 'Inbetalningssättet',
        SBGLabel: 'Inbetalningssättet',
        POLabel: 'Inbetalningssätt',
        POGLabel: 'Inbetalningssätt',
        PBLabel: 'Inbetalningssätterna',
        PBGLabel: 'Inbetalningssätterna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'InbetKundreskontra',
            Abstract: false,
            SOLabel: 'Inbetalningssätt',
            SOGLabel: 'Inbetalningssätt',
            SBLabel: 'Inbetalningssättet',
            SBGLabel: 'Inbetalningssättet',
            POLabel: 'Inbetalningssätt',
            POGLabel: 'Inbetalningssätt',
            PBLabel: 'Inbetalningssätten',
            PBGLabel: 'Inbetalningssätten',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inbetalningssättet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inbetalningssättet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Betalningssättyp',
          DataType: 'Enum',
          EnumValues: new Map([['INBETKUNDRESKONTRA', 'Inbetalningssätt']]),
          EnumSortValues: new Map([['INBETKUNDRESKONTRA', 'K']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INBETKUNDRESKONTRA=Inbetalningssätt"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Inbetalningssättet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inbetalningssättet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETSATTKOD: {
          AttributeName: 'BETSATTKOD',
          DisplayLabel: 'Betalningsättskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BANK_ID: {
          AttributeName: 'BANK_ID',
          DisplayLabel: 'Bank',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOTYP: {
          AttributeName: 'KONTOTYP',
          DisplayLabel: 'Kontotyp',
          Hint: 'PlusGiro/Bankgiro/Kontant/KOB',
          DataType: 'Enum',
          EnumValues: new Map([['PLUSGIRO', 'PlusGiro'], ['BANKGIRO', 'Bankgiro'], ['KONTANT', 'Kontant'], ['KOB', 'KOB']]),
          EnumSortValues: new Map([['PLUSGIRO', 'P'], ['BANKGIRO', 'B'], ['KONTANT', 'K'], ['KOB', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PLUSGIRO=PlusGiro;BANKGIRO=Bankgiro;KONTANT=Kontant;KOB=KOB"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        KONTONR: {
          AttributeName: 'KONTONR',
          DisplayLabel: 'Gironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        KBLikvidkonto: {
          AttributeName: 'KBLikvidkonto',
          DisplayLabel: 'Likvidkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Likvidkonto: {
          AttributeName: 'Likvidkonto',
          DisplayLabel: 'Likvidkonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATALOG: {
          AttributeName: 'KATALOG',
          DisplayLabel: 'Katalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EFAKTURA: {
          AttributeName: 'EFAKTURA',
          DisplayLabel: 'Till fakturaväxel',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        OCR_KONTROLL: {
          AttributeName: 'OCR_KONTROLL',
          DisplayLabel: 'OCR-Kontroll',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OCR_REFERENS_KONTROLL: {
          AttributeName: 'OCR_REFERENS_KONTROLL',
          DisplayLabel: 'Kontroll på OCR-referens',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OCR_FAKTNR_KONTROLL: {
          AttributeName: 'OCR_FAKTNR_KONTROLL',
          DisplayLabel: 'Fakturanummer/OCR-referens kontroll',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Id-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        KalkKatalog: {
          AttributeName: 'KalkKatalog',
          DisplayLabel: 'Katalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MANUELL_KONTERING: {
          AttributeName: 'MANUELL_KONTERING',
          DisplayLabel: 'Tillåt manuell kontering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BANKAVTAL: {
          AttributeName: 'BANKAVTAL',
          DisplayLabel: 'Bankavtal',
          Hint: 'Konto har mjuk ocr-kontroll i avtal med sin bank/Konto har hård ocr-kontroll i avtal med sin bank',
          DataType: 'Enum',
          EnumValues: new Map([['KONTO_HAR_MJUK_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK', 'Konto har mjuk ocr-kontroll i avtal med sin bank'], ['KONTO_HAR_HARD_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK', 'Konto har hård ocr-kontroll i avtal med sin bank']]),
          EnumSortValues: new Map([['KONTO_HAR_MJUK_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK', 'M'], ['KONTO_HAR_HARD_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK', 'H']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KONTO_HAR_MJUK_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK=Konto har mjuk ocr-kontroll i avtal med sin bank;KONTO_HAR_HARD_OCR_KONTROLL_I_AVTAL_MED_SIN_BANK=Konto har hård ocr-kontroll i avtal med sin bank"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PRIM_BETSATT: {
          AttributeName: 'PRIM_BETSATT',
          DisplayLabel: 'Primärt inbetalningssätt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EFAKTURA_KGF: {
          AttributeName: 'EFAKTURA_KGF',
          DisplayLabel: 'Till fakturaväxel för kgf',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BANKKONTONR: {
          AttributeName: 'BANKKONTONR',
          DisplayLabel: 'Bankkontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ISO_IBANBETSATT: {
          AttributeName: 'ISO_IBANBETSATT',
          DisplayLabel: 'Kopplat till IBAN',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILL_KIVRA: {
          AttributeName: 'TILL_KIVRA',
          DisplayLabel: 'Skickas till Kivra',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TILL_KIVRA_KGF: {
          AttributeName: 'TILL_KIVRA_KGF',
          DisplayLabel: 'Skicka till Kivra för kgf',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IBAN: {
          AttributeName: 'IBAN',
          DisplayLabel: 'IBAN',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Bank: {
          AssociationName: 'Bank',
          DisplayLabel: 'Bank',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBank',
          AssociatedComponentName: 'Bank',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Likvidkonto: {
          AssociationName: 'Likvidkonto',
          DisplayLabel: 'Likvidkonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSJobb: {
      CollectionName: 'SYSJobb',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Jobb',
        Abstract: false,
        SOLabel: 'Jobb',
        SOGLabel: 'Jobbs',
        SBLabel: 'Jobbet',
        SBGLabel: 'Jobbets',
        POLabel: 'Jobb',
        POGLabel: 'Jobbs',
        PBLabel: 'Jobben',
        PBGLabel: 'Jobbens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Jobbets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Jobbets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Jobbets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Intern kategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PARAMS: {
          AttributeName: 'PARAMS',
          DisplayLabel: 'Parametrar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERIOD_ID: {
          AttributeName: 'PERIOD_ID',
          DisplayLabel: 'Period',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        INTERNT: {
          AttributeName: 'INTERNT',
          DisplayLabel: 'Internt jobb',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        UPPL_DATUM: {
          AttributeName: 'UPPL_DATUM',
          DisplayLabel: 'Upplagt datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Upplagt av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Vilande/Initierat/Startas/Körs/Klart/Inget att göra/Pausat/Avbrutet/Fel, startas om/Fel',
          DataType: 'Enum',
          EnumValues: new Map([['VILANDE', 'Vilande'], ['INITIERAT', 'Initierat'], ['STARTAS', 'Startas'], ['KORS', 'Körs'], ['KLART', 'Klart'], ['INGET_ATT_GORA', 'Inget att göra'], ['PAUSAT', 'Pausat'], ['AVBRUTET', 'Avbrutet'], ['FEL__STARTAS_OM', 'Fel, startas om'], ['FEL', 'Fel']]),
          EnumSortValues: new Map([['VILANDE', 'V'], ['INITIERAT', 'I'], ['STARTAS', 'S'], ['KORS', 'R'], ['KLART', 'K'], ['INGET_ATT_GORA', 'N'], ['PAUSAT', 'P'], ['AVBRUTET', 'A'], ['FEL__STARTAS_OM', 'T'], ['FEL', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VILANDE=Vilande;INITIERAT=Initierat;STARTAS=Startas;KORS=Körs;KLART=Klart;INGET_ATT_GORA=Inget att göra;PAUSAT=Pausat;AVBRUTET=Avbrutet;FEL__STARTAS_OM=Fel, startas om;FEL=Fel"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS_PENDING: {
          AttributeName: 'STATUS_PENDING',
          DisplayLabel: 'Väntande status',
          Hint: 'Pausar/Avbryter',
          DataType: 'Enum',
          EnumValues: new Map([['PAUSAR', 'Pausar'], ['AVBRYTER', 'Avbryter']]),
          EnumSortValues: new Map([['PAUSAR', 'P'], ['AVBRYTER', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PAUSAR=Pausar;AVBRYTER=Avbryter"',
        },
        STATUS_TEXT: {
          AttributeName: 'STATUS_TEXT',
          DisplayLabel: 'Statustext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS_TID: {
          AttributeName: 'STATUS_TID',
          DisplayLabel: 'Statustid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.less,
        },
        START_TID: {
          AttributeName: 'START_TID',
          DisplayLabel: 'Starttid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SLUT_TID: {
          AttributeName: 'SLUT_TID',
          DisplayLabel: 'Sluttid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        START_PROGRESS: {
          AttributeName: 'START_PROGRESS',
          DisplayLabel: 'Procent klart vid senaste start',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
          FormatterParseParams: 'Base="P"',
          FormatterDisplayParams: 'Base="P"',
        },
        PROGRESS: {
          AttributeName: 'PROGRESS',
          DisplayLabel: 'Procent klart',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          FormatterParseParams: 'Base="P"',
          FormatterDisplayParams: 'Base="P"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.less,
        },
        SERVERNAMN: {
          AttributeName: 'SERVERNAMN',
          DisplayLabel: 'Körs på server',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        THREAD_ID: {
          AttributeName: 'THREAD_ID',
          DisplayLabel: 'Tråd-ID',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXCLUSIVE_LOCKS: {
          AttributeName: 'EXCLUSIVE_LOCKS',
          DisplayLabel: 'Lås',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTOR_EXE: {
          AttributeName: 'MOTOR_EXE',
          DisplayLabel: 'Bakgrundsmotorns filnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTOR_VER: {
          AttributeName: 'MOTOR_VER',
          DisplayLabel: 'Bakgrundsmotorns version',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTOR_INFO: {
          AttributeName: 'MOTOR_INFO',
          DisplayLabel: 'Bakgrundsmotorns info',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MinuterKvar: {
          AttributeName: 'MinuterKvar',
          DisplayLabel: 'Tid kvar (min)',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatGroupedNr',
        },
        TidKlar: {
          AttributeName: 'TidKlar',
          DisplayLabel: 'Klar (beräknad tid)',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
        },
        SenastLyckade: {
          AttributeName: 'SenastLyckade',
          DisplayLabel: 'Senast lyckade',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTime',
        },
        SenastFelaktiga: {
          AttributeName: 'SenastFelaktiga',
          DisplayLabel: 'Senaste felaktiga',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
        },
        SenastUtforda: {
          AttributeName: 'SenastUtforda',
          DisplayLabel: 'Senaste utförda',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Period: {
          AssociationName: 'Period',
          DisplayLabel: 'Period',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSPeriod',
          AssociatedComponentName: 'Period',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Logg: {
          AssociationName: 'Logg',
          DisplayLabel: 'Jobbets logg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSJobbLogg',
          AssociatedComponentName: 'JobbLogg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSJobbLogg: {
      CollectionName: 'SYSJobbLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'JobbLogg',
        Abstract: false,
        SOLabel: 'Jobblogg',
        SOGLabel: 'Jobbloggs',
        SBLabel: 'Jobbloggen',
        SBGLabel: 'Jobbloggens',
        POLabel: 'Jobblogg',
        POGLabel: 'Jobbloggs',
        PBLabel: 'Jobbloggen',
        PBGLabel: 'Jobbloggens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Jobbloggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Jobbloggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Jobbloggens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JOBB_ID: {
          AttributeName: 'JOBB_ID',
          DisplayLabel: 'Jobb-ID',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Intern kategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PARAMS: {
          AttributeName: 'PARAMS',
          DisplayLabel: 'Parametrar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Upplagt av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_SIGN: {
          AttributeName: 'USER_SIGN',
          DisplayLabel: 'Upplagt av, signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Vilande/Initierat/Startat/Klart/Inget att göra/Pausat/Avbrutet/Fel, startas om/Fel/Borttaget',
          DataType: 'Enum',
          EnumValues: new Map([['VILANDE', 'Vilande'], ['INITIERAT', 'Initierat'], ['STARTAT', 'Startat'], ['KLART', 'Klart'], ['INGET_ATT_GORA', 'Inget att göra'], ['PAUSAT', 'Pausat'], ['AVBRUTET', 'Avbrutet'], ['FEL__STARTAS_OM', 'Fel, startas om'], ['FEL', 'Fel'], ['BORTTAGET', 'Borttaget']]),
          EnumSortValues: new Map([['VILANDE', 'V'], ['INITIERAT', 'I'], ['STARTAT', 'R'], ['KLART', 'K'], ['INGET_ATT_GORA', 'N'], ['PAUSAT', 'P'], ['AVBRUTET', 'A'], ['FEL__STARTAS_OM', 'T'], ['FEL', 'F'], ['BORTTAGET', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VILANDE=Vilande;INITIERAT=Initierat;STARTAT=Startat;KLART=Klart;INGET_ATT_GORA=Inget att göra;PAUSAT=Pausat;AVBRUTET=Avbrutet;FEL__STARTAS_OM=Fel, startas om;FEL=Fel;BORTTAGET=Borttaget"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        STATUS_TEXT: {
          AttributeName: 'STATUS_TEXT',
          DisplayLabel: 'Statustext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        START_TID: {
          AttributeName: 'START_TID',
          DisplayLabel: 'Starttid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SERVERNAMN: {
          AttributeName: 'SERVERNAMN',
          DisplayLabel: 'Kördes på server',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTOR_EXE: {
          AttributeName: 'MOTOR_EXE',
          DisplayLabel: 'Bakgrundsmotorns filnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTOR_VER: {
          AttributeName: 'MOTOR_VER',
          DisplayLabel: 'Bakgrundsmotorns version',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTOR_INFO: {
          AttributeName: 'MOTOR_INFO',
          DisplayLabel: 'Bakgrundsmotorns info',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Jobb: {
          AssociationName: 'Jobb',
          DisplayLabel: 'Jobb',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSJobb',
          AssociatedComponentName: 'Jobb',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKOBPriser: {
      CollectionName: 'SYSKOBPriser',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBPris',
        Abstract: false,
        SOLabel: 'KOB Pris',
        SOGLabel: 'KOB Pris',
        SBLabel: 'KOB Priset',
        SBGLabel: 'KOB Prisets',
        POLabel: 'KOB Priser',
        POGLabel: 'KOB Prisers',
        PBLabel: 'KOB Priserna',
        PBGLabel: 'KOB Prisernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'KOB Prisets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'KOB Prisets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'KOB Prisets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'KOB Prisets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOBARTIKEL_ID: {
          AttributeName: 'KOBARTIKEL_ID',
          DisplayLabel: 'ArtikelID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Från datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PRIS: {
          AttributeName: 'PRIS',
          DisplayLabel: 'Pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        KOBArtikel: {
          AssociationName: 'KOBArtikel',
          DisplayLabel: 'KOB-Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKOBArtikel',
          AssociatedComponentName: 'KOBArtikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    SYSKOBArtikel: {
      CollectionName: 'SYSKOBArtikel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KOBArtikel',
        Abstract: false,
        SOLabel: 'KOB-clearingartikel',
        SOGLabel: 'KOB-clearingartikels',
        SBLabel: 'KOB-clearingartikeln',
        SBGLabel: 'KOB-clearingartikelns',
        POLabel: 'KOB-clearingartiklar',
        POGLabel: 'KOB-clearingartiklars',
        PBLabel: 'KOB-clearingartiklarna',
        PBGLabel: 'KOB-clearingartiklarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'KOB-clearingartikelns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'KOB-clearingartikelns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'KOB-clearingartikelns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'KOB-clearingartikelns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKELNR: {
          AttributeName: 'ARTIKELNR',
          DisplayLabel: 'Artikelnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        FORRATTNINGSTYP: {
          AttributeName: 'FORRATTNINGSTYP',
          DisplayLabel: 'Förrättningstyp',
          Hint: 'Begravning/Vigsel/Konfirmation/Dop/Statlig clearing',
          DataType: 'Enum',
          EnumValues: new Map([['BEGRAVNING', 'Begravning'], ['VIGSEL', 'Vigsel'], ['KONFIRMATION', 'Konfirmation'], ['DOP', 'Dop'], ['STATLIG_CLEARING', 'Statlig clearing']]),
          EnumSortValues: new Map([['BEGRAVNING', '1'], ['VIGSEL', '2'], ['KONFIRMATION', '3'], ['DOP', '4'], ['STATLIG_CLEARING', '5']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEGRAVNING=Begravning;VIGSEL=Vigsel;KONFIRMATION=Konfirmation;DOP=Dop;STATLIG_CLEARING=Statlig clearing"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        INVOICEFAMILYKEY: {
          AttributeName: 'INVOICEFAMILYKEY',
          DisplayLabel: 'INVOICEFAMILYKEY',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INVOICETYPEKEY: {
          AttributeName: 'INVOICETYPEKEY',
          DisplayLabel: 'INVOICETYPEKEY',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTICLEKEY: {
          AttributeName: 'ARTICLEKEY',
          DisplayLabel: 'ARTICLEKEY',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KAN_ANDRA_PRIS: {
          AttributeName: 'KAN_ANDRA_PRIS',
          DisplayLabel: 'Kan ändra pris',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        KAN_ANDRA_ANTAL: {
          AttributeName: 'KAN_ANDRA_ANTAL',
          DisplayLabel: 'Kan ändra antal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        KOBArtikelPris: {
          AttributeName: 'KOBArtikelPris',
          DisplayLabel: 'KOB-artikel pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
        },
        KBLevkostKonto: {
          AttributeName: 'KBLevkostKonto',
          DisplayLabel: 'KBLevkostKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleKOBArtikelID: {
          AttributeName: 'RuleKOBArtikelID',
          DisplayLabel: 'RuleKOBArtikelID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURARADSKOD_ID: {
          AttributeName: 'FAKTURARADSKOD_ID',
          DisplayLabel: 'Fakturaradskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Artikeltyp',
          Hint: 'Avgift/Tjänst',
          DataType: 'Enum',
          EnumValues: new Map([['AVGIFT', 'Avgift'], ['TJANST', 'Tjänst']]),
          EnumSortValues: new Map([['AVGIFT', 'A'], ['TJANST', 'T']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVGIFT=Avgift;TJANST=Tjänst"',
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'Giltig t.o.m.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        LevKostKonto: {
          AssociationName: 'LevKostKonto',
          DisplayLabel: 'Kostnadskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturaradskod: {
          AssociationName: 'Fakturaradskod',
          DisplayLabel: 'Fakturaradskod',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturaradskod',
          AssociatedComponentName: 'Fakturaradskod',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KOBPris: {
          AssociationName: 'KOBPris',
          DisplayLabel: 'KOB-Pris',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSKOBPriser',
          AssociatedComponentName: 'KOBPris',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKommunikationsfil: {
      CollectionName: 'SYSKommunikationsfil',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kommunikationsfil',
        Abstract: false,
        SOLabel: 'Kommunikationsfil',
        SOGLabel: 'Kommunikationsfils',
        SBLabel: 'Kommunikationsfilen',
        SBGLabel: 'Kommunikationsfilens',
        POLabel: 'Kommunikationsfiler',
        POGLabel: 'Kommunikationsfilers',
        PBLabel: 'Kommunikationsfilerna',
        PBGLabel: 'Kommunikationsfilernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kommunikationsfilens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kommunikationsfilens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kommunikationsfilens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kommunikationsfilens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FILSTORLEK: {
          AttributeName: 'FILSTORLEK',
          DisplayLabel: 'Filstorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Filtyp',
          Hint: 'Betalningsfil/SIE-fil/Utbetalningsfil från KOB/Utbetalningskvittens från KOB/Inbetalningsfil från KOB/Redovisningsfil för utbetalningar/Bokföringsfil från KOB/EArkiv kvittens/Redovisningsfil för inbetalningar/Momsunderlag/Översättning anst.nr/Kollektfil från KOB/Lönefil',
          DataType: 'Enum',
          EnumValues: new Map([['BETALNINGSFIL', 'Betalningsfil'], ['SIE_FIL', 'SIE-fil'], ['UTBETALNINGSFIL_FRAN_KOB', 'Utbetalningsfil från KOB'], ['UTBETALNINGSKVITTENS_FRAN_KOB', 'Utbetalningskvittens från KOB'], ['INBETALNINGSFIL_FRAN_KOB', 'Inbetalningsfil från KOB'], ['REDOVISNINGSFIL_FOR_UTBETALNINGAR', 'Redovisningsfil för utbetalningar'], ['BOKFORINGSFIL_FRAN_KOB', 'Bokföringsfil från KOB'], ['EARKIV_KVITTENS', 'EArkiv kvittens'], ['REDOVISNINGSFIL_FOR_INBETALNINGAR', 'Redovisningsfil för inbetalningar'], ['MOMSUNDERLAG', 'Momsunderlag'], ['OVERSATTNING_ANST_NR', 'Översättning anst.nr'], ['KOLLEKTFIL_FRAN_KOB', 'Kollektfil från KOB'], ['LONEFIL', 'Lönefil']]),
          EnumSortValues: new Map([['BETALNINGSFIL', 'B'], ['SIE_FIL', 'S'], ['UTBETALNINGSFIL_FRAN_KOB', 'U'], ['UTBETALNINGSKVITTENS_FRAN_KOB', 'K'], ['INBETALNINGSFIL_FRAN_KOB', 'I'], ['REDOVISNINGSFIL_FOR_UTBETALNINGAR', 'R'], ['BOKFORINGSFIL_FRAN_KOB', 'F'], ['EARKIV_KVITTENS', 'E'], ['REDOVISNINGSFIL_FOR_INBETALNINGAR', 'D'], ['MOMSUNDERLAG', 'M'], ['OVERSATTNING_ANST_NR', 'Ö'], ['KOLLEKTFIL_FRAN_KOB', 'G'], ['LONEFIL', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BETALNINGSFIL=Betalningsfil;SIE_FIL=SIE-fil;UTBETALNINGSFIL_FRAN_KOB=Utbetalningsfil från KOB;UTBETALNINGSKVITTENS_FRAN_KOB=Utbetalningskvittens från KOB;INBETALNINGSFIL_FRAN_KOB=Inbetalningsfil från KOB;REDOVISNINGSFIL_FOR_UTBETALNINGAR=Redovisningsfil för utbetalningar;BOKFORINGSFIL_FRAN_KOB=Bokföringsfil från KOB;EARKIV_KVITTENS=EArkiv kvittens;REDOVISNINGSFIL_FOR_INBETALNINGAR=Redovisningsfil för inbetalningar;MOMSUNDERLAG=Momsunderlag;OVERSATTNING_ANST_NR=Översättning anst.nr;KOLLEKTFIL_FRAN_KOB=Kollektfil från KOB;LONEFIL=Lönefil"',
          GUIEditable: true,
          Required: true,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Inläsningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN: {
          AttributeName: 'SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BILDFIL: {
          AttributeName: 'BILDFIL',
          DisplayLabel: 'Bildfil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDFILSTORLEK: {
          AttributeName: 'BILDFILSTORLEK',
          DisplayLabel: 'Bildfilsstorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
        },
        FIL: {
          AttributeName: 'FIL',
          DisplayLabel: 'Fil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        InlastText: {
          AttributeName: 'InlastText',
          DisplayLabel: 'Inläst',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FELMEDDELANDE: {
          AttributeName: 'FELMEDDELANDE',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        ShortMeddelande: {
          AttributeName: 'ShortMeddelande',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSKonteringskod: {
      CollectionName: 'SYSKonteringskod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Konteringskod',
        Abstract: false,
        SOLabel: 'Konteringskod',
        SOGLabel: 'Konteringskod',
        SBLabel: 'Konteringskoden',
        SBGLabel: 'Konteringskoden',
        POLabel: 'Konteringskoder',
        POGLabel: 'Konteringskoder',
        PBLabel: 'Konteringskoderna',
        PBGLabel: 'Konteringskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konteringskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Konteringskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        Standard: {
          AttributeName: 'Standard',
          DisplayLabel: 'Standard',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="Ja=Y;Nej=N"',
          FormatterDisplayParams: 'TranslateValues="Y=Ja;N=Nej"',
          FormatterValidateParams: 'ValidValues="Ja;Nej"',
          InterfaceType: 'ifChecklist',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSKonvertering: {
      CollectionName: 'SYSKonvertering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Konvertering',
        Abstract: false,
        SOLabel: 'Konvertering',
        SOGLabel: 'Konverterings',
        SBLabel: 'Konverteringen',
        SBGLabel: 'Konverteringens',
        POLabel: 'Konverteringar',
        POGLabel: 'Konverteringars',
        PBLabel: 'Konverteringarna',
        PBGLabel: 'Konverteringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konverteringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konverteringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konverteringens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konverteringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PREFIX: {
          AttributeName: 'PREFIX',
          DisplayLabel: 'Prefix',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PREFIX_KORT: {
          AttributeName: 'PREFIX_KORT',
          DisplayLabel: 'Prefix, kort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FRAN_SYSTEM: {
          AttributeName: 'FRAN_SYSTEM',
          DisplayLabel: 'Från system',
          Hint: 'Aveny Gravbok/Aveny Skötsel/Aveny Bisättning/Aveny Musik/Aveny Kremation/Aveny Bokning/Aveny Aktiviteter/Agrando Gravbok/SoftIT Gravbok/Aveny Begrbyra',
          DataType: 'Enum',
          EnumValues: new Map([['AVENY_GRAVBOK', 'Aveny Gravbok'], ['AVENY_SKOTSEL', 'Aveny Skötsel'], ['AVENY_BISATTNING', 'Aveny Bisättning'], ['AVENY_MUSIK', 'Aveny Musik'], ['AVENY_KREMATION', 'Aveny Kremation'], ['AVENY_BOKNING', 'Aveny Bokning'], ['AVENY_AKTIVITETER', 'Aveny Aktiviteter'], ['AGRANDO_GRAVBOK', 'Agrando Gravbok'], ['SOFTIT_GRAVBOK', 'SoftIT Gravbok'], ['AVENY_BEGRBYRA', 'Aveny Begrbyra']]),
          EnumSortValues: new Map([['AVENY_GRAVBOK', 'AG'], ['AVENY_SKOTSEL', 'AS'], ['AVENY_BISATTNING', 'AB'], ['AVENY_MUSIK', 'AM'], ['AVENY_KREMATION', 'AK'], ['AVENY_BOKNING', 'AO'], ['AVENY_AKTIVITETER', 'AA'], ['AGRANDO_GRAVBOK', 'GG'], ['SOFTIT_GRAVBOK', 'SG'], ['AVENY_BEGRBYRA', 'BB']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AVENY_GRAVBOK=Aveny Gravbok;AVENY_SKOTSEL=Aveny Skötsel;AVENY_BISATTNING=Aveny Bisättning;AVENY_MUSIK=Aveny Musik;AVENY_KREMATION=Aveny Kremation;AVENY_BOKNING=Aveny Bokning;AVENY_AKTIVITETER=Aveny Aktiviteter;AGRANDO_GRAVBOK=Agrando Gravbok;SOFTIT_GRAVBOK=SoftIT Gravbok;AVENY_BEGRBYRA=Aveny Begrbyra"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        ORDNING: {
          AttributeName: 'ORDNING',
          DisplayLabel: 'Ordning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRAN_SERVER: {
          AttributeName: 'FRAN_SERVER',
          DisplayLabel: 'Från server',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAN_DB: {
          AttributeName: 'FRAN_DB',
          DisplayLabel: 'Från databas',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRAN_DIR: {
          AttributeName: 'FRAN_DIR',
          DisplayLabel: 'Från mapp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        USE_PREFIX: {
          AttributeName: 'USE_PREFIX',
          DisplayLabel: 'Prefix används',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Params: {
          AssociationName: 'Params',
          DisplayLabel: 'Parametrar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKonverteringParam',
          AssociatedComponentName: 'KonverteringParam',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKonverteringParam: {
      CollectionName: 'SYSKonverteringParam',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KonverteringParam',
        Abstract: false,
        SOLabel: 'Konverteringsparameter',
        SOGLabel: 'Konverteringsparameters',
        SBLabel: 'Konverteringsparametern',
        SBGLabel: 'Konverteringsparameterns',
        POLabel: 'Konverteringsparametrar',
        POGLabel: 'Konverteringsparametrars',
        PBLabel: 'Konverteringsparametrarna',
        PBGLabel: 'Konverteringsparametrarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konverteringsparameterns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konverteringsparameterns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konverteringsparameterns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konverteringsparameterns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONV_ID: {
          AttributeName: 'KONV_ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VARDE: {
          AttributeName: 'VARDE',
          DisplayLabel: 'Värde',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSKravrutin: {
      CollectionName: 'SYSKravrutin',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kravrutin',
        Abstract: false,
        SOLabel: 'Kravrutin',
        SOGLabel: 'Kravrutin',
        SBLabel: 'Kravrutinen',
        SBGLabel: 'Kravrutinen',
        POLabel: 'Kravrutiner',
        POGLabel: 'Kravrutiner',
        PBLabel: 'Kravrutinerna',
        PBGLabel: 'Kravrutinerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kravrutinen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kravrutinen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kravrutinen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kravrutinen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        REPETERASISTAKRAV: {
          AttributeName: 'REPETERASISTAKRAV',
          DisplayLabel: 'Repetera sista krav',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        DAGARMELLANKRAV: {
          AttributeName: 'DAGARMELLANKRAV',
          DisplayLabel: 'Minsta antal dagar mellan krav',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTAL_RANTEFRIA_DAGAR: {
          AttributeName: 'ANTAL_RANTEFRIA_DAGAR',
          DisplayLabel: 'Antal räntefria dagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Räntefakturera',
        },
        FAKTURERA_DROJSMALSRANTA: {
          AttributeName: 'FAKTURERA_DROJSMALSRANTA',
          DisplayLabel: 'Fakturera dröjsmålsränta',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Räntefakturera',
        },
        MINSTA_RANTERADBELOPP: {
          AttributeName: 'MINSTA_RANTERADBELOPP',
          DisplayLabel: 'Minsta belopp per försenad faktura',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Räntefakturera',
        },
        MINSTA_RANTEFAKTBELOPP: {
          AttributeName: 'MINSTA_RANTEFAKTBELOPP',
          DisplayLabel: 'Minsta räntefakturabelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Räntefakturera',
        },
        FAKTURERA_PAMINNELSEAVGIFT: {
          AttributeName: 'FAKTURERA_PAMINNELSEAVGIFT',
          DisplayLabel: 'Fakturera påminnelseavgift',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Påminnelseavgift',
        },
        PAMINNELSEAVGIFT: {
          AttributeName: 'PAMINNELSEAVGIFT',
          DisplayLabel: 'Påminnelseavgift',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Påminnelseavgift',
        },
        RANTEFAKTURA_TEXT: {
          AttributeName: 'RANTEFAKTURA_TEXT',
          DisplayLabel: 'Inledande text på räntefaktura',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          AttributeGroup: 'Räntefakturera',
        },
        DROJSMALRANTA_ID: {
          AttributeName: 'DROJSMALRANTA_ID',
          DisplayLabel: 'Dröjsmålsränta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBDrojsmalintaktkonto: {
          AttributeName: 'KBDrojsmalintaktkonto',
          DisplayLabel: 'KBDrojsmalintaktkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN_BETDATUM: {
          AttributeName: 'FRAN_BETDATUM',
          DisplayLabel: 'Från betalningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        MIN_ANTAL_FORSDAGAR: {
          AttributeName: 'MIN_ANTAL_FORSDAGAR',
          DisplayLabel: 'Minsta antal förseningsdagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        AVG_PER_PAMINNELSE: {
          AttributeName: 'AVG_PER_PAMINNELSE',
          DisplayLabel: 'Per påminnelse',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          AttributeGroup: 'Påminnelseavgift',
        },
        MAX_ANTAL_PAMINNELSE: {
          AttributeName: 'MAX_ANTAL_PAMINNELSE',
          DisplayLabel: 'Max antal påminnelser',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          AttributeGroup: 'Påminnelseavgift',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'IDKod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        AGRESSO_KRAVKOD: {
          AttributeName: 'AGRESSO_KRAVKOD',
          DisplayLabel: 'Kravkod, Agresso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Drojsmalsranta: {
          AssociationName: 'Drojsmalsranta',
          DisplayLabel: 'Dröjsmålsränta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRanteTabell',
          AssociatedComponentName: 'Rantetabell',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Drojsmalintaktkonto: {
          AssociationName: 'Drojsmalintaktkonto',
          DisplayLabel: 'Intäktskonto för dröjsmål/påmminelseavgift',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kravtext: {
          AssociationName: 'Kravtext',
          DisplayLabel: 'Kravtext',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSKravText',
          AssociatedComponentName: 'Kravtext',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsvillkor: {
          AssociationName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBetalningsvillkor',
          AssociatedComponentName: 'Betalningsvillkor',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKravText: {
      CollectionName: 'SYSKravText',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kravtext',
        Abstract: false,
        SOLabel: 'Kravtext',
        SOGLabel: 'Kravtext',
        SBLabel: 'Kravtexten',
        SBGLabel: 'Kravtexten',
        POLabel: 'Kravtexter',
        POGLabel: 'Kravtexter',
        PBLabel: 'Kravtexterna',
        PBGLabel: 'Kravtexterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kravtexten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kravtexten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kravtexten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kravtexten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KRAVTEXT: {
          AttributeName: 'KRAVTEXT',
          DisplayLabel: 'Kravtext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        KRAVNR: {
          AttributeName: 'KRAVNR',
          DisplayLabel: 'Kravnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        INKASSOLISTA: {
          AttributeName: 'INKASSOLISTA',
          DisplayLabel: 'Inkassolista',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        Sprak: {
          AttributeName: 'Sprak',
          DisplayLabel: 'Språk',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Sprak: {
          AssociationName: 'Sprak',
          DisplayLabel: 'Sprak',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSSprak',
          AssociatedComponentName: 'Sprak',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kravrutin: {
          AssociationName: 'Kravrutin',
          DisplayLabel: 'Kravrutin',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSKravrutin',
          AssociatedComponentName: 'Kravrutin',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKurs: {
      CollectionName: 'SYSKurs',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kurs',
        Abstract: false,
        SOLabel: 'Kurs',
        SOGLabel: 'Kurs',
        SBLabel: 'Kursen',
        SBGLabel: 'Kursen',
        POLabel: 'Kurser',
        POGLabel: 'Kurser',
        PBLabel: 'Kurserna',
        PBGLabel: 'Kurserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kursen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kursen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kursen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kursen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FROM_DATUM: {
          AttributeName: 'FROM_DATUM',
          DisplayLabel: 'Fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        TOM_DATUM: {
          AttributeName: 'TOM_DATUM',
          DisplayLabel: 'T o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KOPKURS: {
          AttributeName: 'KOPKURS',
          DisplayLabel: 'Köpkurs',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="4"',
          FormatterDisplayParams: 'Decimals="4"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SALJKURS: {
          AttributeName: 'SALJKURS',
          DisplayLabel: 'Säljkurs',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterParseParams: 'Decimals="4"',
          FormatterDisplayParams: 'Decimals="4"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Valuta',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSLeveransvillkor: {
      CollectionName: 'SYSLeveransvillkor',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Leveransvillkor',
        Abstract: false,
        SOLabel: 'Leveransvillkor',
        SOGLabel: 'Leveransvillkor',
        SBLabel: 'Leveransvillkoret',
        SBGLabel: 'Leveransvillkoret',
        POLabel: 'Leveransvillkor',
        POGLabel: 'Leveransvillkor',
        PBLabel: 'Leveransvillkoren',
        PBGLabel: 'Leveransvillkoren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Leveransvillkoret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Leveransvillkoret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Leveransvillkoret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Leveransvillkoret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVVILLKORKOD: {
          AttributeName: 'LEVVILLKORKOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'KodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSLKF: {
      CollectionName: 'SYSLKF',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'LKF',
        Abstract: false,
        SOLabel: 'LKF-kod',
        SOGLabel: 'LKF-kod',
        SBLabel: 'LKF-koden',
        SBGLabel: 'LKF-koden',
        POLabel: 'LKF-koder',
        POGLabel: 'LKF-koder',
        PBLabel: 'LKF-koderna',
        PBGLabel: 'LKF-koderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'LKF-koden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'LKF-koden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'LKF-koden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'LKF-koden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'LKF-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Län/Kommun/Församling',
          DataType: 'Enum',
          EnumValues: new Map([['LAN', 'Län'], ['KOMMUN', 'Kommun'], ['FORSAMLING', 'Församling']]),
          EnumSortValues: new Map([['LAN', 'L'], ['KOMMUN', 'K'], ['FORSAMLING', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAN=Län;KOMMUN=Kommun;FORSAMLING=Församling"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Hemförsamling/Egen kod',
          DataType: 'Enum',
          EnumValues: new Map([['HEMFORSAMLING', 'Hemförsamling'], ['EGEN_KOD', 'Egen kod']]),
          EnumSortValues: new Map([['HEMFORSAMLING', 'H'], ['EGEN_KOD', 'E']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HEMFORSAMLING=Hemförsamling;EGEN_KOD=Egen kod"',
          InterfaceType: 'ifChecklist',
        },
        StatusBen: {
          AttributeName: 'StatusBen',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KodBen: {
          AttributeName: 'KodBen',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Yes;']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        POSTNR: {
          AssociationName: 'POSTNR',
          DisplayLabel: 'Postnummer',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSPOSTNR',
          AssociatedComponentName: 'Postnr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSLoggTable: {
      CollectionName: 'SYSLoggTable',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'LoggTable',
        Abstract: false,
        SOLabel: 'Loggtabell',
        SOGLabel: 'Loggtabell',
        SBLabel: 'Loggtabellen',
        SBGLabel: 'Loggtabellen',
        POLabel: 'Loggtabeller',
        POGLabel: 'Loggtabeller',
        PBLabel: 'Loggtabellerna',
        PBGLabel: 'Loggtabellerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Loggtabellen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Loggtabellen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Loggtabellen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Loggtabellen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEM: {
          AttributeName: 'SUBSYSTEM',
          DisplayLabel: 'Delsystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TABLENAME: {
          AttributeName: 'TABLENAME',
          DisplayLabel: 'Tabellnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BIZMODELNAME: {
          AttributeName: 'BIZMODELNAME',
          DisplayLabel: 'Modelnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        LOGG_ON_INSERT: {
          AttributeName: 'LOGG_ON_INSERT',
          DisplayLabel: 'Logga tillägg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        LOGG_ON_UPDATE: {
          AttributeName: 'LOGG_ON_UPDATE',
          DisplayLabel: 'Logga uppdateringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        LOGG_ON_DELETE: {
          AttributeName: 'LOGG_ON_DELETE',
          DisplayLabel: 'Logga borttag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        CLEARTYPE: {
          AttributeName: 'CLEARTYPE',
          DisplayLabel: 'Rensningstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CLEARCOUNT: {
          AttributeName: 'CLEARCOUNT',
          DisplayLabel: 'Antal vid rensning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOGG_ON_INSERT_STARTDATE: {
          AttributeName: 'LOGG_ON_INSERT_STARTDATE',
          DisplayLabel: 'Logga tillägg, fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOGG_ON_UPDATE_STARTDATE: {
          AttributeName: 'LOGG_ON_UPDATE_STARTDATE',
          DisplayLabel: 'Logga ändringar, fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        LOGG_ON_DELETE_STARTDATE: {
          AttributeName: 'LOGG_ON_DELETE_STARTDATE',
          DisplayLabel: 'Logga borttag, fr o m datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
      },
    },
    SYSLand: {
      CollectionName: 'SYSLand',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Land',
        Abstract: false,
        SOLabel: 'Land',
        SOGLabel: 'Land',
        SBLabel: 'Landet',
        SBGLabel: 'Landet',
        POLabel: 'Länder',
        POGLabel: 'Länder',
        PBLabel: 'Länderna',
        PBGLabel: 'Länderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Landet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Landet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Landet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Landet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LANDKOD: {
          AttributeName: 'LANDKOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        VALUTA_ID: {
          AttributeName: 'VALUTA_ID',
          DisplayLabel: 'Valuta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPRAK_ID: {
          AttributeName: 'SPRAK_ID',
          DisplayLabel: 'Språk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Valuta: {
          AttributeName: 'Valuta',
          DisplayLabel: 'Valuta',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        Sprak: {
          AttributeName: 'Sprak',
          DisplayLabel: 'Språk',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Valuta: {
          AssociationName: 'Valuta',
          DisplayLabel: 'Valuta',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSValuta',
          AssociatedComponentName: 'Valuta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Sprak: {
          AssociationName: 'Sprak',
          DisplayLabel: 'Språk',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSSprak',
          AssociatedComponentName: 'Sprak',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSLosenordshistorik: {
      CollectionName: 'SYSLosenordshistorik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Losenordshistorik',
        Abstract: false,
        SOLabel: 'Losenordshistorik',
        SOGLabel: 'Losenordshistoriks',
        SBLabel: 'Losenordshistoriken',
        SBGLabel: 'Losenordshistorikens',
        POLabel: 'Losenordshistorik',
        POGLabel: 'Losenordshistoriks',
        PBLabel: 'Losenordshistoriken',
        PBGLabel: 'Losenordshistorikens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Losenordshistorikens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Losenordshistorikens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Losenordshistorikens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OLD_PWD: {
          AttributeName: 'OLD_PWD',
          DisplayLabel: 'Lösenord',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PWD_METHOD: {
          AttributeName: 'PWD_METHOD',
          DisplayLabel: 'Lösenordshashmetod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSLosenordskrav: {
      CollectionName: 'SYSLosenordskrav',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Losenordskrav',
        Abstract: false,
        SOLabel: 'Lösenordskrav',
        SOGLabel: 'Lösenordskrav',
        SBLabel: 'Lösenordskravet',
        SBGLabel: 'Lösenordskravet',
        POLabel: 'Lösenordskrav',
        POGLabel: '',
        PBLabel: 'Lösenordskraven',
        PBGLabel: 'Lösenordskraven',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Lösenordskravet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Lösenordskravet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Lösenordskravet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Lösenordskravet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PWD_CONSTR_ORDER: {
          AttributeName: 'PWD_CONSTR_ORDER',
          DisplayLabel: 'Ordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IS_DEFAULT_LEVEL: {
          AttributeName: 'IS_DEFAULT_LEVEL',
          DisplayLabel: 'Standardnivå',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        REQ_LOWERCASE: {
          AttributeName: 'REQ_LOWERCASE',
          DisplayLabel: 'Kräv gement tecken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        REQ_UPPERCASE: {
          AttributeName: 'REQ_UPPERCASE',
          DisplayLabel: 'Kräv versalt tecken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        REQ_DIGITS: {
          AttributeName: 'REQ_DIGITS',
          DisplayLabel: 'Kräv siffra',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        REQ_SPEC_CHAR: {
          AttributeName: 'REQ_SPEC_CHAR',
          DisplayLabel: 'Kräv specialtecken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        MIN_PWD_LENGTH: {
          AttributeName: 'MIN_PWD_LENGTH',
          DisplayLabel: 'Minsta längd',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MAX_PWD_LENGTH: {
          AttributeName: 'MAX_PWD_LENGTH',
          DisplayLabel: 'Längsta längd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NR_SAVED_HASHES: {
          AttributeName: 'NR_SAVED_HASHES',
          DisplayLabel: 'Jämför mot antal tidigare lösenord',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CHECK_FORBIDDEN_WORDS: {
          AttributeName: 'CHECK_FORBIDDEN_WORDS',
          DisplayLabel: 'Kontrollera mot ordlista',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANSI_ONLY: {
          AttributeName: 'ANSI_ONLY',
          DisplayLabel: 'Inga diakritiska tecken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PWD_EXPIRE_TIME: {
          AttributeName: 'PWD_EXPIRE_TIME',
          DisplayLabel: 'Bytesintervall, dagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        PWD_MIN_CHANGE_INTERVAL: {
          AttributeName: 'PWD_MIN_CHANGE_INTERVAL',
          DisplayLabel: 'Minsta tid mellan byten, dagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
      },
    },
    SYSAIMeddelande: {
      CollectionName: 'SYSAIMeddelande',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AIMeddelande',
        Abstract: false,
        SOLabel: 'Meddelande',
        SOGLabel: 'Meddelande',
        SBLabel: 'Meddelande',
        SBGLabel: 'Meddelande',
        POLabel: 'Meddelande',
        POGLabel: 'Meddelande',
        PBLabel: 'Meddelande',
        PBGLabel: 'Meddelande',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Meddelande primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Meddelande versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Meddelande fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CHAT_ID: {
          AttributeName: 'CHAT_ID',
          DisplayLabel: 'CHAT_ID',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ROLL: {
          AttributeName: 'ROLL',
          DisplayLabel: 'Roll',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INNEHALL: {
          AttributeName: 'INNEHALL',
          DisplayLabel: 'Innehåll',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKAPAD_TID: {
          AttributeName: 'SKAPAD_TID',
          DisplayLabel: 'Skapad, tidpunkt',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FELMEDDELANDE: {
          AttributeName: 'FELMEDDELANDE',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        INPUT_TOKEN_USAGE: {
          AttributeName: 'INPUT_TOKEN_USAGE',
          DisplayLabel: 'INPUT_TOKEN_USAGE',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        OUTPUT_TOKEN_USAGE: {
          AttributeName: 'OUTPUT_TOKEN_USAGE',
          DisplayLabel: 'OUTPUT_TOKEN_USAGE',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNINGSNR: {
          AttributeName: 'ORDNINGSNR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Internal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Attachments: {
          AssociationName: 'Attachments',
          DisplayLabel: 'Attachments',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAIAttachment',
          AssociatedComponentName: 'AIAttachment',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSMeddelande: {
      CollectionName: 'SYSMeddelande',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Meddelande',
        Abstract: false,
        SOLabel: 'Meddelande',
        SOGLabel: 'Meddelandes',
        SBLabel: 'Meddelandet',
        SBGLabel: 'Meddelandets',
        POLabel: 'Meddelanden',
        POGLabel: 'Meddelandens',
        PBLabel: 'Meddelandena',
        PBGLabel: 'Meddelandenas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Meddelandets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Meddelandets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Meddelandets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Meddelandets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYPKOD: {
          AttributeName: 'TYPKOD',
          DisplayLabel: 'Meddelandetyp',
          Hint: 'Testmeddelande/Periodbokslut/Årsbokslut/Ny analysmall',
          DataType: 'Enum',
          EnumValues: new Map([['TESTMEDDELANDE', 'Testmeddelande'], ['PERIODBOKSLUT', 'Periodbokslut'], ['ARSBOKSLUT', 'Årsbokslut'], ['NY_ANALYSMALL', 'Ny analysmall']]),
          EnumSortValues: new Map([['TESTMEDDELANDE', 'TEST'], ['PERIODBOKSLUT', 'EKPB'], ['ARSBOKSLUT', 'EKAB'], ['NY_ANALYSMALL', 'EKNELA']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TESTMEDDELANDE=Testmeddelande;PERIODBOKSLUT=Periodbokslut;ARSBOKSLUT=Årsbokslut;NY_ANALYSMALL=Ny analysmall"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Skapat tidpunkt',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        GILTIGT_TILL: {
          AttributeName: 'GILTIGT_TILL',
          DisplayLabel: 'Giltigt till tidpunkt',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Mottagare: {
          AssociationName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMeddelandeTill',
          AssociatedComponentName: 'MeddelandeTill',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSMoms: {
      CollectionName: 'SYSMoms',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Moms',
        Abstract: false,
        SOLabel: 'Moms',
        SOGLabel: 'Moms',
        SBLabel: 'Momsen',
        SBGLabel: 'Momsen',
        POLabel: 'Momser',
        POGLabel: 'Momser',
        PBLabel: 'Momserna',
        PBGLabel: 'Momserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Momsen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Momsen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Momsen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Momsen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOMSKOD: {
          AttributeName: 'MOMSKOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True'], ['ConditionShowValuesHintAttribute', 'BENAMNING;']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        MOMS_SATS1: {
          AttributeName: 'MOMS_SATS1',
          DisplayLabel: 'Momssats före ändringsdatum',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        MOMS_SATS2: {
          AttributeName: 'MOMS_SATS2',
          DisplayLabel: 'Momssats efter ändringsdatum',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATUMMOMSBYTE: {
          AttributeName: 'DATUMMOMSBYTE',
          DisplayLabel: 'Ändringsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        KBIngaendeMomsKonto: {
          AttributeName: 'KBIngaendeMomsKonto',
          DisplayLabel: 'KBIngaendeMomsKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IngaendeMomsKonto: {
          AttributeName: 'IngaendeMomsKonto',
          DisplayLabel: 'IngaendeMomsKonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBUtgaendeMomsKonto: {
          AttributeName: 'KBUtgaendeMomsKonto',
          DisplayLabel: 'KBUtgaendeMomsKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UtgaendeMomsKonto: {
          AttributeName: 'UtgaendeMomsKonto',
          DisplayLabel: 'UtgaendeMomsKonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AGRESSO_MOMSKOD: {
          AttributeName: 'AGRESSO_MOMSKOD',
          DisplayLabel: 'Momskod, Agresso',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        IngaendeMomsKonto: {
          AssociationName: 'IngaendeMomsKonto',
          DisplayLabel: 'Konto för ingående moms',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        UtgaendeMomsKonto: {
          AssociationName: 'UtgaendeMomsKonto',
          DisplayLabel: 'Konto för utgående moms',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSMeddelandeTill: {
      CollectionName: 'SYSMeddelandeTill',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '2060'], ['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'MeddelandeTill',
        Abstract: false,
        SOLabel: 'Mottagare',
        SOGLabel: 'Mottagares',
        SBLabel: 'Mottagaren',
        SBGLabel: 'Mottagarens',
        POLabel: 'Mottagare',
        POGLabel: 'Mottagares',
        PBLabel: 'Mottagarna',
        PBGLabel: 'Mottagarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Mottagarens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Mottagarens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Mottagarens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LAST: {
          AttributeName: 'LAST',
          DisplayLabel: 'Läst',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Meddelande: {
          AssociationName: 'Meddelande',
          DisplayLabel: 'Meddelande',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSMeddelande',
          AssociatedComponentName: 'Meddelande',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSNummer: {
      CollectionName: 'SYSNummer',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y'], ['AllowSelection', '7004']]),
      RootType: {
        TypeValue: 'Nummer',
        Abstract: false,
        SOLabel: 'Nummer',
        SOGLabel: 'Nummer',
        SBLabel: 'Nummret',
        SBGLabel: 'Nummret',
        POLabel: 'Nummer',
        POGLabel: 'Nummer',
        PBLabel: 'Nummrena',
        PBGLabel: 'Nummrena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Nummret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Nummret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Nummret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Nummret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateYear',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        MINVALUE: {
          AttributeName: 'MINVALUE',
          DisplayLabel: 'Min.värde',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        LENGTHVALUE: {
          AttributeName: 'LENGTHVALUE',
          DisplayLabel: 'Antal positioner i numret',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        MAXVALUE: {
          AttributeName: 'MAXVALUE',
          DisplayLabel: 'Maxvärde',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        NEXTVALUE: {
          AttributeName: 'NEXTVALUE',
          DisplayLabel: 'Nästa värde',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        LAST: {
          AttributeName: 'LAST',
          DisplayLabel: 'Nummerserie låst',
          Hint: 'Låst/Ej låst',
          DataType: 'Enum',
          EnumValues: new Map([['LAST', 'Låst'], ['EJ_LAST', 'Ej låst']]),
          EnumSortValues: new Map([['LAST', 'Y'], ['EJ_LAST', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAST=Låst;EJ_LAST=Ej låst"',
          GUIEditable: true,
        },
      },
      Associations: {
        Nummerserie: {
          AssociationName: 'Nummerserie',
          DisplayLabel: 'Nummerserie',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'NummerSerie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSNummerserie: {
      CollectionName: 'SYSNummerserie',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '7004'], ['AllowSelection', '7004']]),
      RootType: {
        TypeValue: 'NummerSerie',
        Abstract: true,
        SOLabel: 'Nummerserie',
        SOGLabel: 'Nummerserie',
        SBLabel: 'Nummerserien',
        SBGLabel: 'Nummerserien',
        POLabel: 'Nummerserier',
        POGLabel: 'Nummerserier',
        PBLabel: 'Nummerserierna',
        PBGLabel: 'Nummerserierna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'ArsbaseradNummerserie',
            Abstract: false,
            SOLabel: 'Årsbaserad nummerserie',
            SOGLabel: 'Årsbaserad nummerserie',
            SBLabel: 'Årsbaserade nummerserien',
            SBGLabel: 'Årsbaserade nummerserien',
            POLabel: 'Årsbaserade nummerserier',
            POGLabel: 'Årsbaserade nummerserier',
            PBLabel: 'Årsbaserade nummerserierna',
            PBGLabel: 'Årsbaserade nummerserierna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'StandigNummerserie',
            Abstract: false,
            SOLabel: 'Ständig nummerserie',
            SOGLabel: 'Ständig nummerserie',
            SBLabel: 'Ständiga nummerserien',
            SBGLabel: 'Ständiga nummerserien',
            POLabel: 'Ständiga nummerserier',
            POGLabel: 'Ständiga nummerserier',
            PBLabel: 'Ständiga nummerserierna',
            PBGLabel: 'Ständiga nummerserierna',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Nummerserien primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Nummerserien versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Årsbaserad/Ständig serie',
          DataType: 'Enum',
          EnumValues: new Map([['ARSBASERADNUMMERSERIE', 'Årsbaserad nummerserie'], ['STANDIGNUMMERSERIE', 'Ständig nummerserie']]),
          EnumSortValues: new Map([['ARSBASERADNUMMERSERIE', 'Y'], ['STANDIGNUMMERSERIE', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARSBASERADNUMMERSERIE=Årsbaserad nummerserie;STANDIGNUMMERSERIE=Ständig nummerserie"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Nummerserien id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Nummerserien fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_TYP: {
          AttributeName: 'SERIE_TYP',
          DisplayLabel: 'Typ av nummerserie',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          MaxInputLength: 10,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PREFIX: {
          AttributeName: 'PREFIX',
          DisplayLabel: 'Prefix',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'IDKod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Serietyp: {
          AssociationName: 'Serietyp',
          DisplayLabel: 'Serietyp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSSerietyp',
          AssociatedComponentName: 'Serietyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Nummer: {
          AssociationName: 'Nummer',
          DisplayLabel: 'Nummer',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummer',
          AssociatedComponentName: 'Nummer',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSSerietyp: {
      CollectionName: 'SYSSerietyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y'], ['AllowSelection', '7004']]),
      RootType: {
        TypeValue: 'Serietyp',
        Abstract: false,
        SOLabel: 'Nummerserietyp',
        SOGLabel: 'Nummerserietyp',
        SBLabel: 'Nummerserietypen',
        SBGLabel: 'Nummerserietypen',
        POLabel: 'Nummerserietyper',
        POGLabel: 'Nummerserietyper',
        PBLabel: 'Nummerserietyperna',
        PBGLabel: 'Nummerserietyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Nummerserietypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Nummerserietypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Nummerserietypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Nummerserietypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_TYP: {
          AttributeName: 'SERIE_TYP',
          DisplayLabel: 'Typ av nummerserie',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        ARS_BASERAD: {
          AttributeName: 'ARS_BASERAD',
          DisplayLabel: 'Årsbaserad',
          Hint: 'Årsbaserad/Ständig',
          DataType: 'Enum',
          EnumValues: new Map([['ARSBASERAD', 'Årsbaserad'], ['STANDIG', 'Ständig']]),
          EnumSortValues: new Map([['ARSBASERAD', 'Y'], ['STANDIG', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARSBASERAD=Årsbaserad;STANDIG=Ständig"',
          GUIEditable: true,
          Required: true,
        },
        GILTIG_I_DELSYSTEM: {
          AttributeName: 'GILTIG_I_DELSYSTEM',
          DisplayLabel: 'Giltig i delsystem',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SERIE_TABELL: {
          AttributeName: 'SERIE_TABELL',
          DisplayLabel: 'Tabellnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 32,
        },
        ANVAND_PREFIX: {
          AttributeName: 'ANVAND_PREFIX',
          DisplayLabel: 'Använd prefix',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          Required: true,
        },
        SORT: {
          AttributeName: 'SORT',
          DisplayLabel: 'Sorteringsordning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Nummerserier: {
          AssociationName: 'Nummerserier',
          DisplayLabel: 'Nummerserier',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'NummerSerie',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSAPIKey: {
      CollectionName: 'SYSAPIKey',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'APIKey',
        Abstract: false,
        SOLabel: 'Nyckel',
        SOGLabel: 'Nyckels',
        SBLabel: 'Nyckeln',
        SBGLabel: 'Nyckelns',
        POLabel: 'Nycklar',
        POGLabel: 'Nycklars',
        PBLabel: 'Nycklarna',
        PBGLabel: 'Nycklarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Nyckelns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Nyckelns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Nyckelns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        API_KEY: {
          AttributeName: 'API_KEY',
          DisplayLabel: 'Nyckel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 400,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYPE: {
          AttributeName: 'TYPE',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
      },
      Associations: {
      },
    },
    SYSLosenordlista: {
      CollectionName: 'SYSLosenordlista',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Losenordlista',
        Abstract: false,
        SOLabel: 'Ord',
        SOGLabel: 'Ords',
        SBLabel: 'Ordet',
        SBGLabel: 'Ordets',
        POLabel: 'Ord',
        POGLabel: 'Ords',
        PBLabel: 'Orden',
        PBGLabel: 'Ordens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ordets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ordets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ordets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ordets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WORD: {
          AttributeName: 'WORD',
          DisplayLabel: 'Ord',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
      },
      Associations: {
      },
    },
    SYSOrdermottagningsvag: {
      CollectionName: 'SYSOrdermottagningsvag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Ordermottagningsvag',
        Abstract: false,
        SOLabel: 'Ordermottagningsväg',
        SOGLabel: 'Ordermottagningsvägs',
        SBLabel: 'Ordermottagningsvägen',
        SBGLabel: 'Ordermottagningsvägens',
        POLabel: 'Ordermottagningsvägar',
        POGLabel: 'Ordermottagningsvägars',
        PBLabel: 'Ordermottagningsvägarna',
        PBGLabel: 'Ordermottagningsvägarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ordermottagningsvägens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ordermottagningsvägens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ordermottagningsvägens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ordermottagningsvägens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IMPORTTYP: {
          AttributeName: 'IMPORTTYP',
          DisplayLabel: 'Importtyp',
          Hint: 'Sveorder/Eniac-format',
          DataType: 'Enum',
          EnumValues: new Map([['SVEORDER', 'Sveorder'], ['ENIAC_FORMAT', 'Eniac-format']]),
          EnumSortValues: new Map([['SVEORDER', 'S'], ['ENIAC_FORMAT', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SVEORDER=Sveorder;ENIAC_FORMAT=Eniac-format"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IMPORTKATALOG: {
          AttributeName: 'IMPORTKATALOG',
          DisplayLabel: 'Importkatalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        XSL: {
          AttributeName: 'XSL',
          DisplayLabel: 'XSL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Id, bokföringsgrupp',
          Hint: 'Används nog inte',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KUNDKATEGORI_ID: {
          AttributeName: 'KUNDKATEGORI_ID',
          DisplayLabel: 'Id, kundkategori',
          Hint: 'Används nog inte',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Id, artikel',
          Hint: 'Används nog inte',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KVITTENSKATALOG: {
          AttributeName: 'KVITTENSKATALOG',
          DisplayLabel: 'Kvittenskatalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sveorder',
        },
        BETALNINGSKATALOG: {
          AttributeName: 'BETALNINGSKATALOG',
          DisplayLabel: 'Betalningskatalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Sveorder',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'ID-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        FORSYSTEM_TYP: {
          AttributeName: 'FORSYSTEM_TYP',
          DisplayLabel: 'Försystem',
          Hint: 'Bokning/Grav/Kremationsjournal/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['BOKNING', 'Bokning'], ['GRAV', 'Grav'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['BOKNING', 'B'], ['GRAV', 'G'], ['KREMATIONSJOURNAL', 'K'], ['OVRIGT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKNING=Bokning;GRAV=Grav;KREMATIONSJOURNAL=Kremationsjournal;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KalkImportkatalog: {
          AttributeName: 'KalkImportkatalog',
          DisplayLabel: 'Importkatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KalkKvittenskatalog: {
          AttributeName: 'KalkKvittenskatalog',
          DisplayLabel: 'Kvittenskatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KalkBetalningskatalog: {
          AttributeName: 'KalkBetalningskatalog',
          DisplayLabel: 'Betalningskatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SKICKA_KVITTENSER: {
          AttributeName: 'SKICKA_KVITTENSER',
          DisplayLabel: 'Skicka kvittenser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKICKA_BETALINFO: {
          AttributeName: 'SKICKA_BETALINFO',
          DisplayLabel: 'Skicka betalningsinformation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KLARMARKERA_INNAN_FAKT: {
          AttributeName: 'KLARMARKERA_INNAN_FAKT',
          DisplayLabel: 'Klarmarkera order manuellt innan fakturering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kundkategori: {
          AssociationName: 'Kundkategori',
          DisplayLabel: 'Kundkategori',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKundkategori',
          AssociatedComponentName: 'KundKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Faktureringsgrupper: {
          AssociationName: 'Faktureringsgrupper',
          DisplayLabel: 'Faktureringsgrupper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSOrdmovagFaktgrupp',
          AssociatedComponentName: 'OrdmotvagFaktgrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSOrdmovagFaktgrupp: {
      CollectionName: 'SYSOrdmovagFaktgrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrdmotvagFaktgrupp',
        Abstract: false,
        SOLabel: 'Ordermottagningsvägars faktureringsgrupp',
        SOGLabel: 'Ordermottagningsvägars faktureringsgrupp',
        SBLabel: 'Ordermottagningsvägars faktureringsgrupp',
        SBGLabel: 'Ordermottagningsvägars faktureringsgrupp',
        POLabel: 'Ordermottagningsvägars faktureringsgrupp',
        POGLabel: 'Ordermottagningsvägars faktureringsgrupp',
        PBLabel: 'Ordermottagningsvägars faktureringsgrupp',
        PBGLabel: 'Ordermottagningsvägars faktureringsgrupp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ordermottagningsvägars faktureringsgrupp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ordermottagningsvägars faktureringsgrupp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ordermottagningsvägars faktureringsgrupp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDMOTVAG_ID: {
          AttributeName: 'ORDMOTVAG_ID',
          DisplayLabel: 'Ordermottagningsväg',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTGRUPP_ID: {
          AttributeName: 'FAKTGRUPP_ID',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Ordermottagninsgvag: {
          AssociationName: 'Ordermottagninsgvag',
          DisplayLabel: 'Ordermottagningsväg',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSOrdermottagningsvag',
          AssociatedComponentName: 'Ordermottagningsvag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSUnsyncedEntities: {
      CollectionName: 'SYSUnsyncedEntities',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UnsyncedEntities',
        Abstract: false,
        SOLabel: 'Osynkat objekt',
        SOGLabel: 'Osynkat objekts',
        SBLabel: 'Osynkade objektet',
        SBGLabel: 'Osynkade objektets',
        POLabel: 'Osynkade objekt',
        POGLabel: 'Osynkade objekts',
        PBLabel: 'Osynkade objekten',
        PBGLabel: 'Osynkade objektens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Osynkade objektets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Osynkade objektets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Osynkade objektets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ADDED_DATE: {
          AttributeName: 'ADDED_DATE',
          DisplayLabel: 'Tillagd',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENTITY_TYPE: {
          AttributeName: 'ENTITY_TYPE',
          DisplayLabel: 'Entitetstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ENTITY_KEY: {
          AttributeName: 'ENTITY_KEY',
          DisplayLabel: 'EntitetsID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CHANGE_TYPE: {
          AttributeName: 'CHANGE_TYPE',
          DisplayLabel: 'Förändringskod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        CHANGE_CONTEXT: {
          AttributeName: 'CHANGE_CONTEXT',
          DisplayLabel: 'Förändrad m.a.p.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        CHANGE_DATA: {
          AttributeName: 'CHANGE_DATA',
          DisplayLabel: 'Förändringsdata',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 500,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SYNCED_DATE: {
          AttributeName: 'SYNCED_DATE',
          DisplayLabel: 'Skickad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RETRY_DATE: {
          AttributeName: 'RETRY_DATE',
          DisplayLabel: 'Skickas tidigast om',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
      },
    },
    SYSReportNewParam: {
      CollectionName: 'SYSReportNewParam',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ReportNewParam',
        Abstract: false,
        SOLabel: 'Parameter',
        SOGLabel: 'Parameters',
        SBLabel: 'Parametern',
        SBGLabel: 'Parameternr',
        POLabel: 'Parametrar',
        POGLabel: 'Parametrars',
        PBLabel: 'Parametrarna',
        PBGLabel: 'Parametrarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Parameternr primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Parameternr versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Parameternr id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Parameternr fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Text/Datum/Tid/Checkbox/Memo/Avliden/Gravperson/Valbar text',
          DataType: 'Enum',
          EnumValues: new Map([['TEXT', 'Text'], ['DATUM', 'Datum'], ['TID', 'Tid'], ['CHECKBOX', 'Checkbox'], ['MEMO', 'Memo'], ['AVLIDEN', 'Avliden'], ['GRAVPERSON', 'Gravperson'], ['VALBAR_TEXT', 'Valbar text']]),
          EnumSortValues: new Map([['TEXT', 'S'], ['DATUM', 'D'], ['TID', 'T'], ['CHECKBOX', 'B'], ['MEMO', 'M'], ['AVLIDEN', 'Y'], ['GRAVPERSON', 'X'], ['VALBAR_TEXT', 'W']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TEXT=Text;DATUM=Datum;TID=Tid;CHECKBOX=Checkbox;MEMO=Memo;AVLIDEN=Avliden;GRAVPERSON=Gravperson;VALBAR_TEXT=Valbar text"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        KRAVS: {
          AttributeName: 'KRAVS',
          DisplayLabel: 'Krävs',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PROPOSE_VALUES: {
          AttributeName: 'PROPOSE_VALUES',
          DisplayLabel: 'Föreslagna värden',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        CALLBACK: {
          AttributeName: 'CALLBACK',
          DisplayLabel: 'anropsmetod',
          Hint: 'UpdateCtrlsForGravPers/UpdateCtrlsForGravsBokning',
          DataType: 'Enum',
          EnumValues: new Map([['UPDATECTRLSFORGRAVPERS', 'UpdateCtrlsForGravPers'], ['UPDATECTRLSFORGRAVSBOKNING', 'UpdateCtrlsForGravsBokning']]),
          EnumSortValues: new Map([['UPDATECTRLSFORGRAVPERS', 'P'], ['UPDATECTRLSFORGRAVSBOKNING', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UPDATECTRLSFORGRAVPERS=UpdateCtrlsForGravPers;UPDATECTRLSFORGRAVSBOKNING=UpdateCtrlsForGravsBokning"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Spara: {
          AttributeName: 'Spara',
          DisplayLabel: 'Spara',
          Hint: 'Nej/Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'NullText="Nej"',
          FormatterDisplayParams: 'NullText="Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSFramsidanParam: {
      CollectionName: 'SYSFramsidanParam',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FramsidanParam',
        Abstract: false,
        SOLabel: 'Parameter',
        SOGLabel: 'Parameters',
        SBLabel: 'Parametern',
        SBGLabel: 'Parameterns',
        POLabel: 'Parametrar',
        POGLabel: 'Parametrars',
        PBLabel: 'Parametrarna',
        PBGLabel: 'Parametrarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Parameterns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Parameterns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Parameterns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Parameterns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PARAMTYPE: {
          AttributeName: 'PARAMTYPE',
          DisplayLabel: 'Typ',
          Hint: 'Urvalsparameter/SQL-parameter',
          DataType: 'Enum',
          EnumValues: new Map([['URVALSPARAMETER', 'Urvalsparameter'], ['SQL_PARAMETER', 'SQL-parameter']]),
          EnumSortValues: new Map([['URVALSPARAMETER', 'C'], ['SQL_PARAMETER', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="URVALSPARAMETER=Urvalsparameter;SQL_PARAMETER=SQL-parameter"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        TO_NAME: {
          AttributeName: 'TO_NAME',
          DisplayLabel: 'Till-parameter (intervall)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          Hint: 'Text/Heltal/Flyttal/Belopp/Datum/Tid/Datum och Tid/Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['TEXT', 'Text'], ['HELTAL', 'Heltal'], ['FLYTTAL', 'Flyttal'], ['BELOPP', 'Belopp'], ['DATUM', 'Datum'], ['TID', 'Tid'], ['DATUM_OCH_TID', 'Datum och Tid'], ['JA_NEJ', 'Ja/Nej']]),
          EnumSortValues: new Map([['TEXT', 'S'], ['HELTAL', 'I'], ['FLYTTAL', 'F'], ['BELOPP', 'C'], ['DATUM', 'D'], ['TID', 'T'], ['DATUM_OCH_TID', 'U'], ['JA_NEJ', 'B']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TEXT=Text;HELTAL=Heltal;FLYTTAL=Flyttal;BELOPP=Belopp;DATUM=Datum;TID=Tid;DATUM_OCH_TID=Datum och Tid;JA_NEJ=Ja/Nej"',
          GUIEditable: true,
        },
        CONDNAME: {
          AttributeName: 'CONDNAME',
          DisplayLabel: 'Urvalsfält',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CONDOPS: {
          AttributeName: 'CONDOPS',
          DisplayLabel: 'Urvalsoperatorer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        DEFAULT_VALUE: {
          AttributeName: 'DEFAULT_VALUE',
          DisplayLabel: 'Standardvärde',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
        },
        ORDNING: {
          AttributeName: 'ORDNING',
          DisplayLabel: 'Ordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSPeriod: {
      CollectionName: 'SYSPeriod',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Period',
        Abstract: false,
        SOLabel: 'Period',
        SOGLabel: 'Periods',
        SBLabel: 'Perioden',
        SBGLabel: 'Periodens',
        POLabel: 'Perioder',
        POGLabel: 'Perioders',
        PBLabel: 'Perioderna',
        PBGLabel: 'Periodernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Periodens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Periodens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Periodens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'År/Månad/Vecka/Dag/Tid',
          DataType: 'Enum',
          EnumValues: new Map([['AR', 'År'], ['MANAD', 'Månad'], ['VECKA', 'Vecka'], ['DAG', 'Dag'], ['TID', 'Tid']]),
          EnumSortValues: new Map([['AR', 'A'], ['MANAD', 'M'], ['VECKA', 'V'], ['DAG', 'D'], ['TID', 'T']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AR=År;MANAD=Månad;VECKA=Vecka;DAG=Dag;TID=Tid"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        INTERVALL: {
          AttributeName: 'INTERVALL',
          DisplayLabel: 'Intervall',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        START_DATUM: {
          AttributeName: 'START_DATUM',
          DisplayLabel: 'Startdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SLUT_DATUM: {
          AttributeName: 'SLUT_DATUM',
          DisplayLabel: 'Slutdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        START_TID: {
          AttributeName: 'START_TID',
          DisplayLabel: 'Starttid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SLUT_TID: {
          AttributeName: 'SLUT_TID',
          DisplayLabel: 'Sluttid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        HELG: {
          AttributeName: 'HELG',
          DisplayLabel: 'Hantera helgdagar',
          Hint: 'Hoppa över helger/Skjut upp till nästa vardag/Skjut upp till nästa helgdag',
          DataType: 'Enum',
          EnumValues: new Map([['HOPPA_OVER_HELGER', 'Hoppa över helger'], ['SKJUT_UPP_TILL_NASTA_VARDAG', 'Skjut upp till nästa vardag'], ['SKJUT_UPP_TILL_NASTA_HELGDAG', 'Skjut upp till nästa helgdag']]),
          EnumSortValues: new Map([['HOPPA_OVER_HELGER', 'S'], ['SKJUT_UPP_TILL_NASTA_VARDAG', 'V'], ['SKJUT_UPP_TILL_NASTA_HELGDAG', 'H']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HOPPA_OVER_HELGER=Hoppa över helger;SKJUT_UPP_TILL_NASTA_VARDAG=Skjut upp till nästa vardag;SKJUT_UPP_TILL_NASTA_HELGDAG=Skjut upp till nästa helgdag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Tillfallen: {
          AssociationName: 'Tillfallen',
          DisplayLabel: 'Tillfällen',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSPeriod',
          AssociatedComponentName: 'Period',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSPersonkategori: {
      CollectionName: 'SYSPersonkategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Personkategori',
        Abstract: false,
        SOLabel: 'Personkategori',
        SOGLabel: 'Personkategoris',
        SBLabel: 'Personkategorin',
        SBGLabel: 'Personkategorins',
        POLabel: 'Personkategorier',
        POGLabel: 'Personkategoriers',
        PBLabel: 'Personkategorierna',
        PBGLabel: 'Personkategoriernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personkategorins primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personkategorins versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personkategorins fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SUBSYSTEM: {
          AttributeName: 'SUBSYSTEM',
          DisplayLabel: 'Delprogram',
          Hint: 'Bisättningsjournal/Bokning/Budget/Diarium/Ekonomi/Grav/Kremation/Kundreskontra/Leverantörsreskontra/Order/Fakturering/Systemadministration/Tidredovisning',
          DataType: 'Enum',
          EnumValues: new Map([['BISATTNINGSJOURNAL', 'Bisättningsjournal'], ['BOKNING', 'Bokning'], ['BUDGET', 'Budget'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['KREMATION', 'Kremation'], ['KUNDRESKONTRA', 'Kundreskontra'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['ORDER_FAKTURERING', 'Order/Fakturering'], ['SYSTEMADMINISTRATION', 'Systemadministration'], ['TIDREDOVISNING', 'Tidredovisning']]),
          EnumSortValues: new Map([['BISATTNINGSJOURNAL', 'BJ'], ['BOKNING', 'BO'], ['BUDGET', 'BU'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['KREMATION', 'KJ'], ['KUNDRESKONTRA', 'KR'], ['LEVERANTORSRESKONTRA', 'LR'], ['ORDER_FAKTURERING', 'OF'], ['SYSTEMADMINISTRATION', 'SYS'], ['TIDREDOVISNING', 'TI']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BISATTNINGSJOURNAL=Bisättningsjournal;BOKNING=Bokning;BUDGET=Budget;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;KREMATION=Kremation;KUNDRESKONTRA=Kundreskontra;LEVERANTORSRESKONTRA=Leverantörsreskontra;ORDER_FAKTURERING=Order/Fakturering;SYSTEMADMINISTRATION=Systemadministration;TIDREDOVISNING=Tidredovisning"',
          GUIEditable: true,
        },
        GALLRING_AKTIV: {
          AttributeName: 'GALLRING_AKTIV',
          DisplayLabel: 'Automatisk gallring aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GALLRING_AKTIVERAD_USER_ID: {
          AttributeName: 'GALLRING_AKTIVERAD_USER_ID',
          DisplayLabel: 'Gallring aktiverad av',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GALLRING_AKTIVERAD_DATUM: {
          AttributeName: 'GALLRING_AKTIVERAD_DATUM',
          DisplayLabel: 'Gallring aktiverad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_SYFTE_KALLA: {
          AttributeName: 'PERS_SYFTE_KALLA',
          DisplayLabel: 'Syfte, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_SYFTE_KUNDSVAR: {
          AttributeName: 'PERS_SYFTE_KUNDSVAR',
          DisplayLabel: 'Syfte, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_PERSONUPPGIFTER_KALLA: {
          AttributeName: 'PERS_PERSONUPPGIFTER_KALLA',
          DisplayLabel: 'Personuppgifter, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_PERSONUPPGIFTER_KUNDSVAR: {
          AttributeName: 'PERS_PERSONUPPGIFTER_KUNDSVAR',
          DisplayLabel: 'Personuppgifter, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KALLA: {
          AttributeName: 'PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KALLA',
          DisplayLabel: 'Känsliga uppgifter (Ja/Nej), källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KUNDSVAR: {
          AttributeName: 'PERS_KANSLIGA_UPPGIFTER_JA_NEJ_KUNDSVAR',
          DisplayLabel: 'Känsliga uppgifter (Ja/Nej), kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_KANSLIGA_UPPGIFTER_KALLA: {
          AttributeName: 'PERS_KANSLIGA_UPPGIFTER_KALLA',
          DisplayLabel: 'Känsliga uppgifter, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_KANSLIGA_UPPGIFTER_KUNDSVAR: {
          AttributeName: 'PERS_KANSLIGA_UPPGIFTER_KUNDSVAR',
          DisplayLabel: 'Känsliga uppgifter, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_INHAMNTNING_REG_KALLA: {
          AttributeName: 'PERS_INHAMNTNING_REG_KALLA',
          DisplayLabel: 'Inhämtning från registrerad, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_INHAMNTNING_REG_KUNDSVAR: {
          AttributeName: 'PERS_INHAMNTNING_REG_KUNDSVAR',
          DisplayLabel: 'Inhämtning från registrerad, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_INHAMNTNING_EJ_REG_KALLA: {
          AttributeName: 'PERS_INHAMNTNING_EJ_REG_KALLA',
          DisplayLabel: 'Inhämtning allmänna källor, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_INHAMNTNING_EJ_REG_KUNDSVAR: {
          AttributeName: 'PERS_INHAMNTNING_EJ_REG_KUNDSVAR',
          DisplayLabel: 'Inhämtning allmänna källor, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_ANDAMAL_KALLA: {
          AttributeName: 'PERS_ANDAMAL_KALLA',
          DisplayLabel: 'Ändamål, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_ANDAMAL_KUNDSVAR: {
          AttributeName: 'PERS_ANDAMAL_KUNDSVAR',
          DisplayLabel: 'Ändamål, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_EJ_ANDAMAL_KALLA: {
          AttributeName: 'PERS_EJ_ANDAMAL_KALLA',
          DisplayLabel: 'Ändamål saknas, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_EJ_ANDAMAL_KUNDSVAR: {
          AttributeName: 'PERS_EJ_ANDAMAL_KUNDSVAR',
          DisplayLabel: 'Ändamål saknas, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_LAGLIG_GRUND_KALLA: {
          AttributeName: 'PERS_LAGLIG_GRUND_KALLA',
          DisplayLabel: 'Laglig grund, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_LAGLIG_GRUND_KUNDSVAR: {
          AttributeName: 'PERS_LAGLIG_GRUND_KUNDSVAR',
          DisplayLabel: 'Laglig grund, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_EJ_LAGLIG_GRUND_KALLA: {
          AttributeName: 'PERS_EJ_LAGLIG_GRUND_KALLA',
          DisplayLabel: 'Laglig grund saknas, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_EJ_LAGLIG_GRUND_KUNDSVAR: {
          AttributeName: 'PERS_EJ_LAGLIG_GRUND_KUNDSVAR',
          DisplayLabel: 'Laglig grund saknas, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_UTLAMNING_KALLA: {
          AttributeName: 'PERS_UTLAMNING_KALLA',
          DisplayLabel: 'Utlämning, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_UTLAMNING_KUNDSVAR: {
          AttributeName: 'PERS_UTLAMNING_KUNDSVAR',
          DisplayLabel: 'Utlämning, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_UTLAMNING_PLANERING_KALLA: {
          AttributeName: 'PERS_UTLAMNING_PLANERING_KALLA',
          DisplayLabel: 'Utlämning planeras, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
        },
        PERS_UTLAMNING_PLANERING_KUNDSVAR: {
          AttributeName: 'PERS_UTLAMNING_PLANERING_KUNDSVAR',
          DisplayLabel: 'Utlämning planeras, kundsvar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERS_FRITEXTFALT_KALLA: {
          AttributeName: 'PERS_FRITEXTFALT_KALLA',
          DisplayLabel: 'Fritextfält, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_FRITEXTFALT_KUNDSVAR: {
          AttributeName: 'PERS_FRITEXTFALT_KUNDSVAR',
          DisplayLabel: 'Fritextfält, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_FRITEXTFALT_SYFTE_KALLA: {
          AttributeName: 'PERS_FRITEXTFALT_SYFTE_KALLA',
          DisplayLabel: 'Fritextfält syfte, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_FRITEXTFALT_SYFTE_KUNDSVAR: {
          AttributeName: 'PERS_FRITEXTFALT_SYFTE_KUNDSVAR',
          DisplayLabel: 'Fritextfält syfte, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_GALLRING_AUTOMATIK_KALLA: {
          AttributeName: 'PERS_GALLRING_AUTOMATIK_KALLA',
          DisplayLabel: 'Automatisk gallring, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_GALLRING_AUTOMATIK_KUNDSVAR: {
          AttributeName: 'PERS_GALLRING_AUTOMATIK_KUNDSVAR',
          DisplayLabel: 'Automatisk gallring, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_GALLRING_MANUELLT_KALLA: {
          AttributeName: 'PERS_GALLRING_MANUELLT_KALLA',
          DisplayLabel: 'Manuell gallring, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_GALLRING_MANUELLT_KUNDSVAR: {
          AttributeName: 'PERS_GALLRING_MANUELLT_KUNDSVAR',
          DisplayLabel: 'Manuell gallring, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        PERS_GALLRING_BESLUT_KALLA: {
          AttributeName: 'PERS_GALLRING_BESLUT_KALLA',
          DisplayLabel: 'Gallring beslut, källa',
          Hint: 'Använd Eniacs förslag till svar/Komplettera Eniacs förslag till svar/Ange eget svar',
          DataType: 'Enum',
          EnumValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'Använd Eniacs förslag till svar'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'Komplettera Eniacs förslag till svar'], ['ANGE_EGET_SVAR', 'Ange eget svar']]),
          EnumSortValues: new Map([['ANVAND_ENIACS_FORSLAG_TILL_SVAR', 'A'], ['KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR', 'K'], ['ANGE_EGET_SVAR', 'E']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANVAND_ENIACS_FORSLAG_TILL_SVAR=Använd Eniacs förslag till svar;KOMPLETTERA_ENIACS_FORSLAG_TILL_SVAR=Komplettera Eniacs förslag till svar;ANGE_EGET_SVAR=Ange eget svar"',
          GUIEditable: true,
        },
        PERS_GALLRING_BESLUT_KUNDSVAR: {
          AttributeName: 'PERS_GALLRING_BESLUT_KUNDSVAR',
          DisplayLabel: 'Gallring beslut, kundsvar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'ANVÄNDS INTE Status',
          Hint: 'Återstår/Preliminär/Klar',
          DataType: 'Enum',
          EnumValues: new Map([['ATERSTAR', 'Återstår'], ['PRELIMINAR', 'Preliminär'], ['KLAR', 'Klar']]),
          EnumSortValues: new Map([['ATERSTAR', 'E'], ['PRELIMINAR', 'P'], ['KLAR', 'K']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ATERSTAR=Återstår;PRELIMINAR=Preliminär;KLAR=Klar"',
        },
        Hanterad: {
          AttributeName: 'Hanterad',
          DisplayLabel: 'Hanterad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        HanteradText: {
          AttributeName: 'HanteradText',
          DisplayLabel: 'Hanterad, text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        GALLRING_ENABLED: {
          AttributeName: 'GALLRING_ENABLED',
          DisplayLabel: 'Gallring möjlig',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HANTERAS_ENL_STANDARD: {
          AttributeName: 'HANTERAS_ENL_STANDARD',
          DisplayLabel: 'ANVÄNDS INTE Hanteras enligt standard',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GALLRING_PASLAGEN: {
          AttributeName: 'GALLRING_PASLAGEN',
          DisplayLabel: 'Gallring, påslagen i systemet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_SYFTE_VERDATUM: {
          AttributeName: 'PERS_SYFTE_VERDATUM',
          DisplayLabel: 'Syfte, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_PERSONUPPGIFTER_VERDATUM: {
          AttributeName: 'PERS_PERSONUPPGIFTER_VERDATUM',
          DisplayLabel: 'Personuppgifter, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_KANSLIGA_UPPGIFTER_JA_NEJ_VERDATUM: {
          AttributeName: 'PERS_KANSLIGA_UPPGIFTER_JA_NEJ_VERDATUM',
          DisplayLabel: 'Känsliga uppgifter (Ja/Nej), versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_KANSLIGA_UPPGIFTER_VERDATUM: {
          AttributeName: 'PERS_KANSLIGA_UPPGIFTER_VERDATUM',
          DisplayLabel: 'Känsliga uppgifter, versiondatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_INHAMNTNING_REG_VERDATUM: {
          AttributeName: 'PERS_INHAMNTNING_REG_VERDATUM',
          DisplayLabel: 'Inhämtning från registrerad, versiondatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_INHAMNTNING_EJ_REG_VERDATUM: {
          AttributeName: 'PERS_INHAMNTNING_EJ_REG_VERDATUM',
          DisplayLabel: 'Inhämtning från allmänna källor, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_ANDAMAL_VERDATUM: {
          AttributeName: 'PERS_ANDAMAL_VERDATUM',
          DisplayLabel: 'Ändamål, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_EJ_ANDAMAL_VERDATUM: {
          AttributeName: 'PERS_EJ_ANDAMAL_VERDATUM',
          DisplayLabel: 'Ändamål saknas, versiondatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_LAGLIG_GRUND_VERDATUM: {
          AttributeName: 'PERS_LAGLIG_GRUND_VERDATUM',
          DisplayLabel: 'Laglig grund, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_EJ_LAGLIG_GRUND_VERDATUM: {
          AttributeName: 'PERS_EJ_LAGLIG_GRUND_VERDATUM',
          DisplayLabel: 'Laglig grund saknas, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_UTLAMNING_VERDATUM: {
          AttributeName: 'PERS_UTLAMNING_VERDATUM',
          DisplayLabel: 'Utlämning, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_UTLAMNING_PLANERING_VERDATUM: {
          AttributeName: 'PERS_UTLAMNING_PLANERING_VERDATUM',
          DisplayLabel: 'Utlämning planeras, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_FRITEXTFALT_VERDATUM: {
          AttributeName: 'PERS_FRITEXTFALT_VERDATUM',
          DisplayLabel: 'Fritextfält, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_FRITEXTFALT_SYFTE_VERDATUM: {
          AttributeName: 'PERS_FRITEXTFALT_SYFTE_VERDATUM',
          DisplayLabel: 'Fritextfält syfte, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_GALLRING_AUTOMATIK_VERDATUM: {
          AttributeName: 'PERS_GALLRING_AUTOMATIK_VERDATUM',
          DisplayLabel: 'Automatisk gallring, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTimeGeneral',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_GALLRING_MANUELLT_VERDATUM: {
          AttributeName: 'PERS_GALLRING_MANUELLT_VERDATUM',
          DisplayLabel: 'Manuell gallring, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PERS_GALLRING_BESLUT_VERDATUM: {
          AttributeName: 'PERS_GALLRING_BESLUT_VERDATUM',
          DisplayLabel: 'Gallring beslut, versionsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AktivKategoriInfo: {
          AttributeName: 'AktivKategoriInfo',
          DisplayLabel: 'Uppgifter för automatisk gallring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Aktiverad av',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Adressanvandningar: {
          AssociationName: 'Adressanvandningar',
          DisplayLabel: 'Behandlingar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdressanvandning',
          AssociatedComponentName: 'Adressanvandning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSTEDSYSAnvandarInstallningar: {
      CollectionName: 'SYSTEDSYSAnvandarInstallningar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'PersonligInstallning',
        Abstract: false,
        SOLabel: 'Personlig inställning',
        SOGLabel: 'Personlig inställning',
        SBLabel: 'Personlig inställningen',
        SBGLabel: 'Personlig inställningen',
        POLabel: 'Personliga inställningar',
        POGLabel: 'Personliga inställningar',
        PBLabel: 'Personliga inställningarna',
        PBGLabel: 'Personliga inställningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personlig inställningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personlig inställningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Personlig inställningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personlig inställningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR: {
          AttributeName: 'ORDNINGS_NR',
          DisplayLabel: 'Ordningsnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE_1: {
          AttributeName: 'VARDE_1',
          DisplayLabel: 'Värde 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_2: {
          AttributeName: 'VARDE_2',
          DisplayLabel: 'Värde 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_3: {
          AttributeName: 'VARDE_3',
          DisplayLabel: 'Värde 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_4: {
          AttributeName: 'VARDE_4',
          DisplayLabel: 'Värde 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        VARDE_5: {
          AttributeName: 'VARDE_5',
          DisplayLabel: 'Värde 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        INSTALLNING: {
          AttributeName: 'INSTALLNING',
          DisplayLabel: 'Inställning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSPersonlogg: {
      CollectionName: 'SYSPersonlogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Personlogg',
        Abstract: false,
        SOLabel: 'Personlogg',
        SOGLabel: 'Personloggs',
        SBLabel: 'Personloggen',
        SBGLabel: 'Personloggens',
        POLabel: 'Personloggar',
        POGLabel: 'Personloggars',
        PBLabel: 'Personloggarna',
        PBGLabel: 'Personloggarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personloggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personloggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personloggens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USERID: {
          AttributeName: 'USERID',
          DisplayLabel: 'Användare ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVENYSIGN: {
          AttributeName: 'AVENYSIGN',
          DisplayLabel: 'Avenysignatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        WINDOWSNAME: {
          AttributeName: 'WINDOWSNAME',
          DisplayLabel: 'Windowsanvändare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OPID: {
          AttributeName: 'OPID',
          DisplayLabel: 'OPID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PNR: {
          AttributeName: 'PNR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        INITDATE: {
          AttributeName: 'INITDATE',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REQUESTDATE: {
          AttributeName: 'REQUESTDATE',
          DisplayLabel: 'Fråga datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Visad/Skapad/Fråga',
          DataType: 'Enum',
          EnumValues: new Map([['VISAD', 'Visad'], ['SKAPAD', 'Skapad'], ['FRAGA', 'Fråga']]),
          EnumSortValues: new Map([['VISAD', 'V'], ['SKAPAD', 'S'], ['FRAGA', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VISAD=Visad;SKAPAD=Skapad;FRAGA=Fråga"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        TABELL: {
          AttributeName: 'TABELL',
          DisplayLabel: 'Tabell',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KEYFIELDS: {
          AttributeName: 'KEYFIELDS',
          DisplayLabel: 'Nyckelfält',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KEYVALUES: {
          AttributeName: 'KEYVALUES',
          DisplayLabel: 'Nyckelvärden',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 256,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UTSKRIVEN: {
          AttributeName: 'UTSKRIVEN',
          DisplayLabel: 'Utskriven',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        UTSKRIVEN_DATUM: {
          AttributeName: 'UTSKRIVEN_DATUM',
          DisplayLabel: 'Utskriftsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTSKRIVEN_SIGNATUR: {
          AttributeName: 'UTSKRIVEN_SIGNATUR',
          DisplayLabel: 'Utskrift signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVANDNING_ID: {
          AttributeName: 'ANVANDNING_ID',
          DisplayLabel: 'Adressanvändning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        READDATE: {
          AttributeName: 'READDATE',
          DisplayLabel: 'Visad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Datum: {
          AttributeName: 'Datum',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AnvandsAv: {
          AttributeName: 'AnvandsAv',
          DisplayLabel: 'Använd av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Anvandning: {
          AttributeName: 'Anvandning',
          DisplayLabel: 'Användning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Adressanvandning: {
          AssociationName: 'Adressanvandning',
          DisplayLabel: 'Adressanvändning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSAdressanvandning',
          AssociatedComponentName: 'Adressanvandning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKommunikatorPersonnummer: {
      CollectionName: 'SYSKommunikatorPersonnummer',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kommunikatorpersonnummer',
        Abstract: false,
        SOLabel: 'Personnummer',
        SOGLabel: 'Personnummers',
        SBLabel: 'Personnummret',
        SBGLabel: 'Personnumrets',
        POLabel: 'Personnummer',
        POGLabel: 'Personnummers',
        PBLabel: 'Personnummrena',
        PBGLabel: 'Personnumrenas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Personnumrets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Personnumrets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Personnumrets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LISTID: {
          AttributeName: 'LISTID',
          DisplayLabel: 'List id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt64',
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Persnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Tillägg/Borttag/Synkad',
          DataType: 'Enum',
          EnumValues: new Map([['TILLAGG', 'Tillägg'], ['BORTTAG', 'Borttag'], ['SYNKAD', 'Synkad']]),
          EnumSortValues: new Map([['TILLAGG', 'T'], ['BORTTAG', 'B'], ['SYNKAD', 'S']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLAGG=Tillägg;BORTTAG=Borttag;SYNKAD=Synkad"',
          InterfaceType: 'ifNone',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSPOSTNR: {
      CollectionName: 'SYSPOSTNR',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Postnr',
        Abstract: false,
        SOLabel: 'Postnummer',
        SOGLabel: 'Postnummer',
        SBLabel: 'Postnumret',
        SBGLabel: 'Postnumret',
        POLabel: 'Postnummer',
        POGLabel: 'Postnummer',
        PBLabel: 'Postnummren',
        PBGLabel: 'Postnummren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Postnumret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Postnumret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Postnumret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Postnumret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ADRESS: {
          AttributeName: 'ADRESS',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        POSTNR: {
          AttributeName: 'POSTNR',
          DisplayLabel: 'Postnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPostNr',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ORT: {
          AttributeName: 'ORT',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        LKF: {
          AttributeName: 'LKF',
          DisplayLabel: 'LKF-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        benStatus: {
          AttributeName: 'benStatus',
          DisplayLabel: 'LKF status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        benKod: {
          AttributeName: 'benKod',
          DisplayLabel: 'LKF benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Lanskod: {
          AttributeName: 'Lanskod',
          DisplayLabel: 'Länskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kommunkod: {
          AttributeName: 'Kommunkod',
          DisplayLabel: 'Kommunkod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kommun: {
          AttributeName: 'Kommun',
          DisplayLabel: 'Kommun',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Lan: {
          AttributeName: 'Lan',
          DisplayLabel: 'Län',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        LKF: {
          AssociationName: 'LKF',
          DisplayLabel: 'LKF',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSLKF',
          AssociatedComponentName: 'LKF',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kommun: {
          AssociationName: 'Kommun',
          DisplayLabel: 'Kommun',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLKF',
          AssociatedComponentName: 'LKF',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Lan: {
          AssociationName: 'Lan',
          DisplayLabel: 'Län',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLKF',
          AssociatedComponentName: 'LKF',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKommunikatorprenumeration: {
      CollectionName: 'SYSKommunikatorprenumeration',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kommunikatorprenumeration',
        Abstract: false,
        SOLabel: 'prenumeration',
        SOGLabel: 'prenumerations',
        SBLabel: 'prenumerationen',
        SBGLabel: 'prenumerationens',
        POLabel: 'prenumerationer',
        POGLabel: 'prenumerationers',
        PBLabel: 'prenumerationerna',
        PBGLabel: 'prenumerationernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'prenumerationens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'prenumerationens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'prenumerationens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBID: {
          AttributeName: 'SUBID',
          DisplayLabel: 'Prenumerationsid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval],
        },
        SENASTELOGG: {
          AttributeName: 'SENASTELOGG',
          DisplayLabel: 'Senaste Loggmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Tillägg/Borttag/Synkad',
          DataType: 'Enum',
          EnumValues: new Map([['TILLAGG', 'Tillägg'], ['BORTTAG', 'Borttag'], ['SYNKAD', 'Synkad']]),
          EnumSortValues: new Map([['TILLAGG', 'T'], ['BORTTAG', 'B'], ['SYNKAD', 'S']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLAGG=Tillägg;BORTTAG=Borttag;SYNKAD=Synkad"',
          InterfaceType: 'ifNone',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUM_STATUS: {
          AttributeName: 'DATUM_STATUS',
          DisplayLabel: 'Datum Status',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        SENASTEHAMTNING: {
          AttributeName: 'SENASTEHAMTNING',
          DisplayLabel: 'Senaste hämtning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSPrisbasbelopp: {
      CollectionName: 'SYSPrisbasbelopp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '2060,17001']]),
      RootType: {
        TypeValue: 'Prisbasbelopp',
        Abstract: false,
        SOLabel: 'Prisbasbelopp',
        SOGLabel: 'Prisbasbelopp',
        SBLabel: 'Prisbasbelopp',
        SBGLabel: 'Prisbasbelopp',
        POLabel: 'Prisbasbelopp',
        POGLabel: 'Prisbasbelopp',
        PBLabel: 'Prisbasbelopp',
        PBGLabel: 'Prisbasbelopp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Prisbasbelopp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Prisbasbelopp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Prisbasbelopp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_AR: {
          AttributeName: 'BOKF_AR',
          DisplayLabel: 'Bokföringsår',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BeloppStor: {
          AttributeName: 'BeloppStor',
          DisplayLabel: 'Belopp stor',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        BeloppLiten: {
          AttributeName: 'BeloppLiten',
          DisplayLabel: 'Belopp liten',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        BeloppEnhet: {
          AttributeName: 'BeloppEnhet',
          DisplayLabel: 'Belopp enhet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
      },
      Associations: {
      },
    },
    SYSTEDSYSProgramlog: {
      CollectionName: 'SYSTEDSYSProgramlog',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Programlog',
        Abstract: false,
        SOLabel: 'Programlogg',
        SOGLabel: 'Programloggs',
        SBLabel: 'Programloggen',
        SBGLabel: '',
        POLabel: 'Programloggar',
        POGLabel: 'Programloggars',
        PBLabel: 'Programloggarna',
        PBGLabel: 'Programloggarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Programloggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Programloggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Programloggens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOGTEXT: {
          AttributeName: 'LOGTEXT',
          DisplayLabel: 'Loggtext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        LOGDATE: {
          AttributeName: 'LOGDATE',
          DisplayLabel: 'Loggdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BATCHID: {
          AttributeName: 'BATCHID',
          DisplayLabel: 'Fil',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSReport: {
      CollectionName: 'SYSReport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Report',
        Abstract: false,
        SOLabel: 'Rapport',
        SOGLabel: 'Rapport',
        SBLabel: 'Rapporten',
        SBGLabel: 'Rapporten',
        POLabel: 'Rapporter',
        POGLabel: 'Rapporter',
        PBLabel: 'Rapporterna',
        PBGLabel: 'Rapporterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapporten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapporten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapporten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapporten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REPORT_TYPE: {
          AttributeName: 'REPORT_TYPE',
          DisplayLabel: 'Rapporttyp',
          Hint: 'Blankett/Word/Excel/Etikettmall',
          DataType: 'Enum',
          EnumValues: new Map([['BLANKETT', 'Blankett'], ['WORD', 'Word'], ['EXCEL', 'Excel'], ['ETIKETTMALL', 'Etikettmall']]),
          EnumSortValues: new Map([['BLANKETT', 'B'], ['WORD', 'W'], ['EXCEL', 'E'], ['ETIKETTMALL', 'M']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BLANKETT=Blankett;WORD=Word;EXCEL=Excel;ETIKETTMALL=Etikettmall"',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 80,
        },
        SECURITY_GROUP: {
          AttributeName: 'SECURITY_GROUP',
          DisplayLabel: 'SECURITY_GROUP',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användare ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEMCODE: {
          AttributeName: 'SUBSYSTEMCODE',
          DisplayLabel: 'Delsystem',
          Hint: 'Anläggningsregister/Bokning/Diarium/Ekonomi/Grav/Kremation/Kundreskontra/Leverantörsreskontra/Musik/Order/Fakturering/Program/Underhåll/Tidredovisning',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREGISTER', 'Anläggningsregister'], ['BOKNING', 'Bokning'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['KREMATION', 'Kremation'], ['KUNDRESKONTRA', 'Kundreskontra'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['MUSIK', 'Musik'], ['ORDER_FAKTURERING', 'Order/Fakturering'], ['PROGRAM_UNDERHALL', 'Program/Underhåll'], ['TIDREDOVISNING', 'Tidredovisning']]),
          EnumSortValues: new Map([['ANLAGGNINGSREGISTER', 'AR'], ['BOKNING', 'BO'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['KREMATION', 'KJ'], ['KUNDRESKONTRA', 'KR'], ['LEVERANTORSRESKONTRA', 'LR'], ['MUSIK', 'MU'], ['ORDER_FAKTURERING', 'OF'], ['PROGRAM_UNDERHALL', 'PU'], ['TIDREDOVISNING', 'TI']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREGISTER=Anläggningsregister;BOKNING=Bokning;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;KREMATION=Kremation;KUNDRESKONTRA=Kundreskontra;LEVERANTORSRESKONTRA=Leverantörsreskontra;MUSIK=Musik;ORDER_FAKTURERING=Order/Fakturering;PROGRAM_UNDERHALL=Program/Underhåll;TIDREDOVISNING=Tidredovisning"',
        },
        DM_TYPE: {
          AttributeName: 'DM_TYPE',
          DisplayLabel: 'DM_TYPE',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'SELECTION_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        COMP_NAME: {
          AttributeName: 'COMP_NAME',
          DisplayLabel: 'COMP_NAME',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OUT_COLL_NAME: {
          AttributeName: 'OUT_COLL_NAME',
          DisplayLabel: 'OUT_COLL_NAME',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
        },
        WORD_TEMPLATE: {
          AttributeName: 'WORD_TEMPLATE',
          DisplayLabel: 'WORD_TEMPLATE',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXCEL_ATTRIBUTES: {
          AttributeName: 'EXCEL_ATTRIBUTES',
          DisplayLabel: 'EXCEL_ATTRIBUTES',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REF_ID: {
          AttributeName: 'REF_ID',
          DisplayLabel: 'Ref id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USES_DEF_DMTYPE: {
          AttributeName: 'USES_DEF_DMTYPE',
          DisplayLabel: 'Använder standard dm',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REPORT_GROUP_ID: {
          AttributeName: 'REPORT_GROUP_ID',
          DisplayLabel: 'Rapportgruppens ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OUTPUTTYPE: {
          AttributeName: 'OUTPUTTYPE',
          DisplayLabel: 'Utskriftens layouttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BLOBSIZE: {
          AttributeName: 'BLOBSIZE',
          DisplayLabel: 'Blob size',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ACTIVE: {
          AttributeName: 'ACTIVE',
          DisplayLabel: 'Används',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        USES_LAYOUT: {
          AttributeName: 'USES_LAYOUT',
          DisplayLabel: 'Kräver layout',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        VERSION: {
          AttributeName: 'VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIDHUVUDVAL: {
          AttributeName: 'SIDHUVUDVAL',
          DisplayLabel: 'Sidhuvud, placering',
          Hint: 'Alla sidor/Första sidan/Ojämna sidor/Inget sidhuvud',
          DataType: 'Enum',
          EnumValues: new Map([['ALLA_SIDOR', 'Alla sidor'], ['FORSTA_SIDAN', 'Första sidan'], ['OJAMNA_SIDOR', 'Ojämna sidor'], ['INGET_SIDHUVUD', 'Inget sidhuvud']]),
          EnumSortValues: new Map([['ALLA_SIDOR', 'A'], ['FORSTA_SIDAN', 'F'], ['OJAMNA_SIDOR', 'O'], ['INGET_SIDHUVUD', 'I']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ALLA_SIDOR=Alla sidor;FORSTA_SIDAN=Första sidan;OJAMNA_SIDOR=Ojämna sidor;INGET_SIDHUVUD=Inget sidhuvud"',
          GUIEditable: true,
          Required: true,
        },
        SIDFOTVAL: {
          AttributeName: 'SIDFOTVAL',
          DisplayLabel: 'Sidfot, placering',
          Hint: 'Alla sidor/Första sidan/Ojämna sidor/Ingen sidfot',
          DataType: 'Enum',
          EnumValues: new Map([['ALLA_SIDOR', 'Alla sidor'], ['FORSTA_SIDAN', 'Första sidan'], ['OJAMNA_SIDOR', 'Ojämna sidor'], ['INGEN_SIDFOT', 'Ingen sidfot']]),
          EnumSortValues: new Map([['ALLA_SIDOR', 'A'], ['FORSTA_SIDAN', 'F'], ['OJAMNA_SIDOR', 'O'], ['INGEN_SIDFOT', 'I']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ALLA_SIDOR=Alla sidor;FORSTA_SIDAN=Första sidan;OJAMNA_SIDOR=Ojämna sidor;INGEN_SIDFOT=Ingen sidfot"',
          GUIEditable: true,
          Required: true,
        },
        SELECTION_ID: {
          AttributeName: 'SELECTION_ID',
          DisplayLabel: 'Urval ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FOR_ID: {
          AttributeName: 'FOR_ID',
          DisplayLabel: 'BlankettID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NameSign: {
          AttributeName: 'NameSign',
          DisplayLabel: 'Namn och signatur',
          Hint: 'Förnamn Efternamn Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Agare: {
          AssociationName: 'Agare',
          DisplayLabel: 'Ägare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSReportNew: {
      CollectionName: 'SYSReportNew',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '7042']]),
      RootType: {
        TypeValue: 'ReportNew',
        Abstract: true,
        SOLabel: 'Rapport',
        SOGLabel: 'Rapports',
        SBLabel: 'Rapporten',
        SBGLabel: 'Rapportens',
        POLabel: 'Rapporter',
        POGLabel: 'Rapporters',
        PBLabel: 'Rapporterna',
        PBGLabel: 'Rapporternas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'PDFReportNew',
            Abstract: false,
            SOLabel: 'PDF-rapport',
            SOGLabel: 'PDF-rapports',
            SBLabel: 'PDF-rapporten',
            SBGLabel: 'PDF-rapportens',
            POLabel: 'PDF-rapporter',
            POGLabel: 'PDF-rapporters',
            PBLabel: 'PDF-rapporterna',
            PBGLabel: 'PDF-rapporternas',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'ExcelReportNew',
            Abstract: false,
            SOLabel: 'Excel-rapport',
            SOGLabel: 'Excel-rapports',
            SBLabel: 'Excel-rapporten',
            SBGLabel: 'Excel-rapportens',
            POLabel: 'Excel-rapporter',
            POGLabel: 'Excel-rapporters',
            PBLabel: 'Excel-rapporterna',
            PBGLabel: 'Excel-rapporternas',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'WordReportNew',
            Abstract: false,
            SOLabel: 'Word-rapport',
            SOGLabel: 'Word-rapports',
            SBLabel: 'Word-rapporten',
            SBGLabel: 'Word-rapportens',
            POLabel: 'Word-rapporter',
            POGLabel: 'Word-rapporters',
            PBLabel: 'Word-rapporterna',
            PBGLabel: 'Word-rapporternas',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'EtikettNew',
            Abstract: false,
            SOLabel: 'Etikett',
            SOGLabel: 'Etiketts',
            SBLabel: 'Etiketten',
            SBGLabel: 'Etikettens',
            POLabel: 'Etiketter',
            POGLabel: 'Etiketters',
            PBLabel: 'Etiketterna',
            PBGLabel: 'Etiketternas',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Rapporttyp',
          DataType: 'Enum',
          EnumValues: new Map([['PDFREPORTNEW', 'PDF-rapport'], ['EXCELREPORTNEW', 'Excel-rapport'], ['WORDREPORTNEW', 'Word-rapport'], ['ETIKETTNEW', 'Etikett']]),
          EnumSortValues: new Map([['PDFREPORTNEW', 'P'], ['EXCELREPORTNEW', 'E'], ['WORDREPORTNEW', 'W'], ['ETIKETTNEW', 'T']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PDFREPORTNEW=PDF-rapport;EXCELREPORTNEW=Excel-rapport;WORDREPORTNEW=Word-rapport;ETIKETTNEW=Etikett"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Ägare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROGRAMVERSION: {
          AttributeName: 'PROGRAMVERSION',
          DisplayLabel: 'Programversion',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REPORTVERSION: {
          AttributeName: 'REPORTVERSION',
          DisplayLabel: 'Rapportversion',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SUBSYSTEMCODE: {
          AttributeName: 'SUBSYSTEMCODE',
          DisplayLabel: 'Delsystem kod',
          Hint: 'Anläggningsredovisning/Bokning/Diarium/Ekonomi/Grav/Kremationsjournal/Kundreskontra/Leverantörsreskontra/Musik/Order/Fakturering/Systemadministration/Tidredovisning',
          DataType: 'Enum',
          EnumValues: new Map([['ANLAGGNINGSREDOVISNING', 'Anläggningsredovisning'], ['BOKNING', 'Bokning'], ['DIARIUM', 'Diarium'], ['EKONOMI', 'Ekonomi'], ['GRAV', 'Grav'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['KUNDRESKONTRA', 'Kundreskontra'], ['LEVERANTORSRESKONTRA', 'Leverantörsreskontra'], ['MUSIK', 'Musik'], ['ORDER_FAKTURERING', 'Order/Fakturering'], ['SYSTEMADMINISTRATION', 'Systemadministration'], ['TIDREDOVISNING', 'Tidredovisning']]),
          EnumSortValues: new Map([['ANLAGGNINGSREDOVISNING', 'AR'], ['BOKNING', 'BO'], ['DIARIUM', 'DI'], ['EKONOMI', 'EK'], ['GRAV', 'GA'], ['KREMATIONSJOURNAL', 'KJ'], ['KUNDRESKONTRA', 'KR'], ['LEVERANTORSRESKONTRA', 'LR'], ['MUSIK', 'MU'], ['ORDER_FAKTURERING', 'OF'], ['SYSTEMADMINISTRATION', 'SYS'], ['TIDREDOVISNING', 'TI']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANLAGGNINGSREDOVISNING=Anläggningsredovisning;BOKNING=Bokning;DIARIUM=Diarium;EKONOMI=Ekonomi;GRAV=Grav;KREMATIONSJOURNAL=Kremationsjournal;KUNDRESKONTRA=Kundreskontra;LEVERANTORSRESKONTRA=Leverantörsreskontra;MUSIK=Musik;ORDER_FAKTURERING=Order/Fakturering;SYSTEMADMINISTRATION=Systemadministration;TIDREDOVISNING=Tidredovisning"',
          GUIEditable: true,
        },
        COLLECTION_NAME: {
          AttributeName: 'COLLECTION_NAME',
          DisplayLabel: 'Baseras på',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        REPORTNAME: {
          AttributeName: 'REPORTNAME',
          DisplayLabel: 'Rapportnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.contains],
          DefaultCondOperator: T.contains,
        },
        REPORTDEFXML: {
          AttributeName: 'REPORTDEFXML',
          DisplayLabel: 'Rapportdefinition',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WORD_TEMPLATE: {
          AttributeName: 'WORD_TEMPLATE',
          DisplayLabel: 'Wordmall',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VISIBILITY: {
          AttributeName: 'VISIBILITY',
          DisplayLabel: 'Synlighet',
          Hint: 'Min rapport/Gemensam rapport',
          DataType: 'Enum',
          EnumValues: new Map([['MIN_RAPPORT', 'Min rapport'], ['GEMENSAM_RAPPORT', 'Gemensam rapport']]),
          EnumSortValues: new Map([['MIN_RAPPORT', 'P'], ['GEMENSAM_RAPPORT', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MIN_RAPPORT=Min rapport;GEMENSAM_RAPPORT=Gemensam rapport"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        USES_LAYOUT: {
          AttributeName: 'USES_LAYOUT',
          DisplayLabel: 'Använder layout',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LAYOUT_OPTIONS: {
          AttributeName: 'LAYOUT_OPTIONS',
          DisplayLabel: 'Layoutval',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ShortCollectionName: {
          AttributeName: 'ShortCollectionName',
          DisplayLabel: 'Tabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['CustomWriter', 'Y']]),
        },
        SubsystemLabel: {
          AttributeName: 'SubsystemLabel',
          DisplayLabel: 'Delprogram',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        CollectionLabel: {
          AttributeName: 'CollectionLabel',
          DisplayLabel: 'Tabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NameSign: {
          AttributeName: 'NameSign',
          DisplayLabel: 'Namn och signatur',
          Hint: 'Förnamn Efternamn Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        KONV_FROM_ID: {
          AttributeName: 'KONV_FROM_ID',
          DisplayLabel: 'Konverterad från ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SynligFor: {
          AttributeName: 'SynligFor',
          DisplayLabel: 'Synlig för',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        IsArbgivarRapport: {
          AttributeName: 'IsArbgivarRapport',
          DisplayLabel: 'Arbetsgivar rapport',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BlankettID: {
          AttributeName: 'BlankettID',
          DisplayLabel: 'Blankett id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['CustomWriter', 'Y']]),
        },
        PageHeaderOption: {
          AttributeName: 'PageHeaderOption',
          DisplayLabel: 'Sidhuvud',
          Hint: 'Alla sidor/Första sidan/Eget sidhuvud/Inget sidhuvud',
          DataType: 'Enum',
          EnumValues: new Map([['ALLA_SIDOR', 'Alla sidor'], ['FORSTA_SIDAN', 'Första sidan'], ['EGET_SIDHUVUD', 'Eget sidhuvud'], ['INGET_SIDHUVUD', 'Inget sidhuvud']]),
          EnumSortValues: new Map([['ALLA_SIDOR', 'A'], ['FORSTA_SIDAN', 'F'], ['EGET_SIDHUVUD', 'E'], ['INGET_SIDHUVUD', 'I']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ALLA_SIDOR=Alla sidor;FORSTA_SIDAN=Första sidan;EGET_SIDHUVUD=Eget sidhuvud;INGET_SIDHUVUD=Inget sidhuvud"',
          GUIEditable: true,
          Properties: new Map([['CustomWriter', 'Y']]),
        },
        PageFooterOption: {
          AttributeName: 'PageFooterOption',
          DisplayLabel: 'Sidfot',
          Hint: 'Alla sidor/Första sidan/Egen sidfot/Ingen sidfot',
          DataType: 'Enum',
          EnumValues: new Map([['ALLA_SIDOR', 'Alla sidor'], ['FORSTA_SIDAN', 'Första sidan'], ['EGEN_SIDFOT', 'Egen sidfot'], ['INGEN_SIDFOT', 'Ingen sidfot']]),
          EnumSortValues: new Map([['ALLA_SIDOR', 'A'], ['FORSTA_SIDAN', 'F'], ['EGEN_SIDFOT', 'E'], ['INGEN_SIDFOT', 'I']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ALLA_SIDOR=Alla sidor;FORSTA_SIDAN=Första sidan;EGEN_SIDFOT=Egen sidfot;INGEN_SIDFOT=Ingen sidfot"',
          GUIEditable: true,
          Properties: new Map([['CustomWriter', 'Y']]),
        },
        DigitalSignering: {
          AttributeName: 'DigitalSignering',
          DisplayLabel: 'Digital signering',
          Hint: 'Nej/Ja/Flera',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja'], ['FLERA', 'Flera']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y'], ['FLERA', 'M']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja;FLERA=Flera"',
          GUIEditable: true,
          Properties: new Map([['CustomWriter', 'Y']]),
        },
        CanUtskick: {
          AttributeName: 'CanUtskick',
          DisplayLabel: 'Kan användas som utskick',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        USAGE_CODE: {
          AttributeName: 'USAGE_CODE',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PdfJson: {
          AttributeName: 'PdfJson',
          DisplayLabel: 'PDF-definition i JSON-format',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['CustomWriter', 'Y']]),
        },
        XmlDefinition: {
          AttributeName: 'XmlDefinition',
          DisplayLabel: 'Rapportattribut i XML-format',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['CustomWriter', 'Y']]),
        },
        LastJsonError: {
          AttributeName: 'LastJsonError',
          DisplayLabel: 'Senaste fel i PDF-definitio',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Urval: {
          AssociationName: 'Urval',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Agare: {
          AssociationName: 'Agare',
          DisplayLabel: 'Ägare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UtskickBevakningar: {
          AssociationName: 'UtskickBevakningar',
          DisplayLabel: 'Utskick, bevakning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSReportNewBevakning',
          AssociatedComponentName: 'ReportNewBevakning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Params: {
          AssociationName: 'Params',
          DisplayLabel: 'Parametrar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSReportNewParam',
          AssociatedComponentName: 'ReportNewParam',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSReportfields: {
      CollectionName: 'SYSReportfields',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Reportfields',
        Abstract: false,
        SOLabel: 'Rapportfält',
        SOGLabel: 'Rapportfält',
        SBLabel: 'Rapportfältet',
        SBGLabel: 'Rapportfältet',
        POLabel: 'Rapportfält',
        POGLabel: 'Rapportfält',
        PBLabel: 'Rapportfälten',
        PBGLabel: 'Rapportfälten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportfältet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportfältet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['REPORTFIELDS', 'Rapportfält']]),
          EnumSortValues: new Map([['REPORTFIELDS', 'A']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportfältet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportfältet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OLDCLASS: {
          AttributeName: 'OLDCLASS',
          DisplayLabel: 'Gammalt klassnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OLDASSOC: {
          AttributeName: 'OLDASSOC',
          DisplayLabel: 'Gammalt assocationsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        OLDATTR: {
          AttributeName: 'OLDATTR',
          DisplayLabel: 'Gammalt fältnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        NEWCLASS: {
          AttributeName: 'NEWCLASS',
          DisplayLabel: 'Nytt klassnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        NEWASSOC: {
          AttributeName: 'NEWASSOC',
          DisplayLabel: 'Nytt assocationsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        NEWATTR: {
          AttributeName: 'NEWATTR',
          DisplayLabel: 'Nytt fältnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        UPDATE_VERSION: {
          AttributeName: 'UPDATE_VERSION',
          DisplayLabel: 'Updaterad version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        UPDATE_DATE: {
          AttributeName: 'UPDATE_DATE',
          DisplayLabel: 'Uppdaterad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        USER_SIGN: {
          AttributeName: 'USER_SIGN',
          DisplayLabel: 'Användarens signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATA_VERSION: {
          AttributeName: 'DATA_VERSION',
          DisplayLabel: 'Database version',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        REMOVED: {
          AttributeName: 'REMOVED',
          DisplayLabel: 'Borttaget fält (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        REMOVETEXT: {
          AttributeName: 'REMOVETEXT',
          DisplayLabel: 'Borttagentext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSFakturalayout: {
      CollectionName: 'SYSFakturalayout',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '7042']]),
      RootType: {
        TypeValue: 'Rapportlayout',
        Abstract: true,
        SOLabel: 'Rapportlayout',
        SOGLabel: 'Rapportlayout',
        SBLabel: 'Rapportlayouten',
        SBGLabel: 'Rapportlayouten',
        POLabel: 'Rapportlayouter',
        POGLabel: 'Rapportlayouter',
        PBLabel: 'Rapportlayouterna',
        PBGLabel: 'Rapportlayouterna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Fakturalayout',
            Abstract: true,
            SOLabel: 'Fakturalayout',
            SOGLabel: 'Fakturalayout',
            SBLabel: 'Fakturalayouten',
            SBGLabel: 'Fakturalayouten',
            POLabel: 'Fakturalayouter',
            POGLabel: 'Fakturalayouter',
            PBLabel: 'Fakturalayouterna',
            PBGLabel: 'Fakturalayouterna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Laserutskrift',
                Abstract: false,
                SOLabel: 'Laserutskrift',
                SOGLabel: 'Laserutskrift',
                SBLabel: 'Laserutskriften',
                SBGLabel: 'Laserutskriften',
                POLabel: 'Laserutskrifter',
                POGLabel: 'Laserutskrifter',
                PBLabel: 'Laserutskrifterna',
                PBGLabel: 'Laserutskrifterna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Postgiro',
                Abstract: false,
                SOLabel: 'PlusGirots fakturaservice',
                SOGLabel: 'PlusGirots fakturaservice',
                SBLabel: 'PlusGirots fakturaservice',
                SBGLabel: 'PlusGirots fakturaservice',
                POLabel: 'PlusGirots fakturaservice',
                POGLabel: 'PlusGirots fakturaservice',
                PBLabel: 'PlusGirots fakturaservice',
                PBGLabel: 'PlusGirots fakturaservice',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Nassjo',
                Abstract: false,
                SOLabel: 'Nässjö Tryckeri',
                SOGLabel: 'Nässjö Tryckeri',
                SBLabel: 'Nässjö Tryckeri',
                SBGLabel: 'Nässjö Tryckeri',
                POLabel: 'Nässjö Tryckeri',
                POGLabel: 'Nässjö Tryckeri',
                PBLabel: 'Nässjö Tryckeri',
                PBGLabel: 'Nässjö Tryckeri',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Kravutskrift',
                Abstract: false,
                SOLabel: 'Kravutskrift',
                SOGLabel: 'Kravutskrift',
                SBLabel: 'Kravutskriften',
                SBGLabel: 'Kravutskriften',
                POLabel: 'Kravutskrifter',
                POGLabel: 'Kravutskrifter',
                PBLabel: 'Kravutskrifterna',
                PBGLabel: 'Kravutskrifterna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Brevlayout',
            Abstract: false,
            SOLabel: 'Brevlayout',
            SOGLabel: 'Brevlayout',
            SBLabel: 'Brevlayouten',
            SBGLabel: 'Brevlayouten',
            POLabel: 'Brevlayouter',
            POGLabel: 'Brevlayouter',
            PBLabel: 'Brevlayouterna',
            PBGLabel: 'Brevlayouterna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'KremBlankett',
            Abstract: false,
            SOLabel: 'Blankettlayout',
            SOGLabel: 'Blankettlayout',
            SBLabel: 'Blankettlayouten',
            SBGLabel: 'Blankettlayouten',
            POLabel: 'Blankettlayouter',
            POGLabel: 'Blankettlayouter',
            PBLabel: 'Blankettlayouterna',
            PBGLabel: 'Blankettlayouterna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportlayouten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportlayouten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ av utskrift',
          DataType: 'Enum',
          EnumValues: new Map([['LASERUTSKRIFT', 'Laserutskrift'], ['POSTGIRO', 'PlusGirots fakturaservice'], ['NASSJO', 'Nässjö Tryckeri'], ['KRAVUTSKRIFT', 'Kravutskrift'], ['BREVLAYOUT', 'Brevlayout'], ['KREMBLANKETT', 'Blankettlayout']]),
          EnumSortValues: new Map([['LASERUTSKRIFT', 'L'], ['POSTGIRO', 'P'], ['NASSJO', 'N'], ['KRAVUTSKRIFT', 'K'], ['BREVLAYOUT', 'B'], ['KREMBLANKETT', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LASERUTSKRIFT=Laserutskrift;POSTGIRO=PlusGirots fakturaservice;NASSJO=Nässjö Tryckeri;KRAVUTSKRIFT=Kravutskrift;BREVLAYOUT=Brevlayout;KREMBLANKETT=Blankettlayout"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportlayouten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportlayouten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        LOGOTYPE: {
          AttributeName: 'LOGOTYPE',
          DisplayLabel: 'Logotyp',
          Hint: 'Logotype/Ej logotype',
          DataType: 'Enum',
          EnumValues: new Map([['LOGOTYPE', 'Logotype'], ['EJ_LOGOTYPE', 'Ej logotype']]),
          EnumSortValues: new Map([['LOGOTYPE', 'Y'], ['EJ_LOGOTYPE', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LOGOTYPE=Logotype;EJ_LOGOTYPE=Ej logotype"',
          GUIEditable: true,
        },
        FIRMABET1: {
          AttributeName: 'FIRMABET1',
          DisplayLabel: 'Firmabeteckning 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 60,
        },
        FIRMABET2: {
          AttributeName: 'FIRMABET2',
          DisplayLabel: 'Firmabeteckning 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 60,
        },
        FIRMABET3: {
          AttributeName: 'FIRMABET3',
          DisplayLabel: 'Firmabeteckning 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 60,
        },
        FIRMABET4: {
          AttributeName: 'FIRMABET4',
          DisplayLabel: 'Firmabeteckning 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 60,
        },
        RUBRIK1: {
          AttributeName: 'RUBRIK1',
          DisplayLabel: 'Rubrik 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK2: {
          AttributeName: 'RUBRIK2',
          DisplayLabel: 'Rubrik 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK3: {
          AttributeName: 'RUBRIK3',
          DisplayLabel: 'Rubrik 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK4: {
          AttributeName: 'RUBRIK4',
          DisplayLabel: 'Rubrik 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK5: {
          AttributeName: 'RUBRIK5',
          DisplayLabel: 'Rubrik 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK6: {
          AttributeName: 'RUBRIK6',
          DisplayLabel: 'Rubrik 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT1RAD1: {
          AttributeName: 'TEXT1RAD1',
          DisplayLabel: 'Text 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT2RAD1: {
          AttributeName: 'TEXT2RAD1',
          DisplayLabel: 'Text 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT3RAD1: {
          AttributeName: 'TEXT3RAD1',
          DisplayLabel: 'Text 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT4RAD1: {
          AttributeName: 'TEXT4RAD1',
          DisplayLabel: 'Text 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT5RAD1: {
          AttributeName: 'TEXT5RAD1',
          DisplayLabel: 'Text 5',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT6RAD1: {
          AttributeName: 'TEXT6RAD1',
          DisplayLabel: 'Text 6',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT1RAD2: {
          AttributeName: 'TEXT1RAD2',
          DisplayLabel: 'Text 1 (2)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT2RAD2: {
          AttributeName: 'TEXT2RAD2',
          DisplayLabel: 'Text 2 (2)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT3RAD2: {
          AttributeName: 'TEXT3RAD2',
          DisplayLabel: 'Text 3 (3)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT4RAD2: {
          AttributeName: 'TEXT4RAD2',
          DisplayLabel: 'Text 4 (4)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT5RAD2: {
          AttributeName: 'TEXT5RAD2',
          DisplayLabel: 'Text 5 (2)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXT6RAD2: {
          AttributeName: 'TEXT6RAD2',
          DisplayLabel: 'Text 6 (2)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        VMARG1: {
          AttributeName: 'VMARG1',
          DisplayLabel: 'Vänstermarginal 1',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        VMARG2: {
          AttributeName: 'VMARG2',
          DisplayLabel: 'Vänstermarginal 2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        VMARG3: {
          AttributeName: 'VMARG3',
          DisplayLabel: 'Vänstermarginal 3',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        VMARG4: {
          AttributeName: 'VMARG4',
          DisplayLabel: 'Vänstermarginal 4',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        VMARG5: {
          AttributeName: 'VMARG5',
          DisplayLabel: 'Vänstermarginal 5',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        VMARG6: {
          AttributeName: 'VMARG6',
          DisplayLabel: 'Vänstermarginal 6',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        LOGOTYPE_IMAGE: {
          AttributeName: 'LOGOTYPE_IMAGE',
          DisplayLabel: 'Logotyp',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOGOTYPE_IMAGE_SIZE: {
          AttributeName: 'LOGOTYPE_IMAGE_SIZE',
          DisplayLabel: 'Logotyp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOGOTYPE_WIDTH_MM: {
          AttributeName: 'LOGOTYPE_WIDTH_MM',
          DisplayLabel: 'Logotyp bredd (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="210"',
        },
        LOGOTYPE_HEIGHT_MM: {
          AttributeName: 'LOGOTYPE_HEIGHT_MM',
          DisplayLabel: 'Logotyp höjd (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="210"',
        },
        INBETKORT: {
          AttributeName: 'INBETKORT',
          DisplayLabel: 'Inbetalningskort',
          Hint: 'PlusGiro/PlusGiro OCR/Bankgiro/Bankgiro OCR/Utan inbetalningskort',
          DataType: 'Enum',
          EnumValues: new Map([['PLUSGIRO', 'PlusGiro'], ['PLUSGIRO_OCR', 'PlusGiro OCR'], ['BANKGIRO', 'Bankgiro'], ['BANKGIRO_OCR', 'Bankgiro OCR'], ['UTAN_INBETALNINGSKORT', 'Utan inbetalningskort']]),
          EnumSortValues: new Map([['PLUSGIRO', 'P'], ['PLUSGIRO_OCR', 'O'], ['BANKGIRO', 'B'], ['BANKGIRO_OCR', 'C'], ['UTAN_INBETALNINGSKORT', 'U']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PLUSGIRO=PlusGiro;PLUSGIRO_OCR=PlusGiro OCR;BANKGIRO=Bankgiro;BANKGIRO_OCR=Bankgiro OCR;UTAN_INBETALNINGSKORT=Utan inbetalningskort"',
          GUIEditable: true,
          ValidInComps: ['Fakturalayout'],
        },
        FORTRYCKT: {
          AttributeName: 'FORTRYCKT',
          DisplayLabel: 'Förtryckt blankett',
          Hint: 'Förtryckt/Inbetalningskort förtryckt/Blank',
          DataType: 'Enum',
          EnumValues: new Map([['FORTRYCKT', 'Förtryckt'], ['INBETALNINGSKORT_FORTRYCKT', 'Inbetalningskort förtryckt'], ['BLANK', 'Blank']]),
          EnumSortValues: new Map([['FORTRYCKT', 'F'], ['INBETALNINGSKORT_FORTRYCKT', 'N'], ['BLANK', 'B']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORTRYCKT=Förtryckt;INBETALNINGSKORT_FORTRYCKT=Inbetalningskort förtryckt;BLANK=Blank"',
          GUIEditable: true,
          ValidInComps: ['Fakturalayout'],
        },
        BETVILLK1: {
          AttributeName: 'BETVILLK1',
          DisplayLabel: 'Betalningsvillkor rad 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 70,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        BETVILLK2: {
          AttributeName: 'BETVILLK2',
          DisplayLabel: 'Betalningsvillkor rad 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 70,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        PG_KLIENTNR: {
          AttributeName: 'PG_KLIENTNR',
          DisplayLabel: 'Klientnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 6,
          ValidInComps: ['Fakturalayout'],
        },
        PG_ORGNR: {
          AttributeName: 'PG_ORGNR',
          DisplayLabel: 'Organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 14,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        PG_KOPIOR: {
          AttributeName: 'PG_KOPIOR',
          DisplayLabel: 'Kopior',
          Hint: 'Inga/En/Två',
          DataType: 'Enum',
          EnumValues: new Map([['INGA', 'Inga'], ['EN', 'En'], ['TVA', 'Två']]),
          EnumSortValues: new Map([['INGA', '0'], ['EN', '1'], ['TVA', '2']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INGA=Inga;EN=En;TVA=Två"',
          GUIEditable: true,
          ValidInComps: ['Fakturalayout'],
        },
        PG_FICHE: {
          AttributeName: 'PG_FICHE',
          DisplayLabel: 'Fiche',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          ValidInComps: ['Fakturalayout'],
        },
        BANKGIRONR: {
          AttributeName: 'BANKGIRONR',
          DisplayLabel: 'Bankgironummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
          ValidInComps: ['Fakturalayout'],
        },
        PG_POSTGIROKONTO: {
          AttributeName: 'PG_POSTGIROKONTO',
          DisplayLabel: 'PlusGirokonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        PG_BETALNMOT1: {
          AttributeName: 'PG_BETALNMOT1',
          DisplayLabel: 'Betalningsmottagare 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 28,
          ValidInComps: ['Fakturalayout'],
        },
        PG_BETALNMOT2: {
          AttributeName: 'PG_BETALNMOT2',
          DisplayLabel: 'Betalningsmottagare 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 28,
          ValidInComps: ['Fakturalayout'],
        },
        PG_LOGOTYPENR: {
          AttributeName: 'PG_LOGOTYPENR',
          DisplayLabel: 'Logotypenummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 3,
          ValidInComps: ['Fakturalayout'],
        },
        PG_FIRMAADR1: {
          AttributeName: 'PG_FIRMAADR1',
          DisplayLabel: 'Firmaadress rad 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 61,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        PG_FIRMAADR2: {
          AttributeName: 'PG_FIRMAADR2',
          DisplayLabel: 'Firmaadress rad 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 61,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        PG_FIRMAADR3: {
          AttributeName: 'PG_FIRMAADR3',
          DisplayLabel: 'Firmaadress rad 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 61,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        PG_FIRMAADR4: {
          AttributeName: 'PG_FIRMAADR4',
          DisplayLabel: 'Firmaadress rad 4',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Fakturalayout'],
        },
        KRAVUTSKRIFTSNAMN: {
          AttributeName: 'KRAVUTSKRIFTSNAMN',
          DisplayLabel: 'Fakturanamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Fakturalayout'],
        },
        KODBREDD: {
          AttributeName: 'KODBREDD',
          DisplayLabel: 'Fakturakodens bredd',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Fakturalayout'],
        },
        BLANKETT_FINJUSTERING: {
          AttributeName: 'BLANKETT_FINJUSTERING',
          DisplayLabel: 'Finjustering av blankett',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          ValidInComps: ['Fakturalayout'],
        },
        OCR_FINJUSTERINGHOJD: {
          AttributeName: 'OCR_FINJUSTERINGHOJD',
          DisplayLabel: 'OCR finjustering topp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          ValidInComps: ['Fakturalayout'],
        },
        OCR_FINJUSTERINGVANSTER: {
          AttributeName: 'OCR_FINJUSTERINGVANSTER',
          DisplayLabel: 'OCR finjustering sidled',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          ValidInComps: ['Fakturalayout'],
        },
        HUVUDHOJD: {
          AttributeName: 'HUVUDHOJD',
          DisplayLabel: 'Höjd på sidhuvud',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="1000"',
          GUIEditable: true,
          ValidInComps: ['Brevlayout'],
        },
        RUBRIK_ASKKVITTO: {
          AttributeName: 'RUBRIK_ASKKVITTO',
          DisplayLabel: 'Rubrik Askkvitto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          ValidInComps: ['KremBlankett'],
        },
        RUBRIK_IDBEVIS: {
          AttributeName: 'RUBRIK_IDBEVIS',
          DisplayLabel: 'Rubrik ID-bevis',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          ValidInComps: ['KremBlankett'],
        },
        RUBRIK_HAMTAURNA: {
          AttributeName: 'RUBRIK_HAMTAURNA',
          DisplayLabel: 'Rubrik Hämta urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          ValidInComps: ['KremBlankett'],
        },
        RUBRIK_KREMJ: {
          AttributeName: 'RUBRIK_KREMJ',
          DisplayLabel: 'Rubrik Kremationsjournal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          ValidInComps: ['KremBlankett'],
        },
        LOGOTYPE_SIDFOT: {
          AttributeName: 'LOGOTYPE_SIDFOT',
          DisplayLabel: 'Logotype sidfot (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Brevlayout'],
        },
        LOGOTYPE_SIDFOT_IMAGE: {
          AttributeName: 'LOGOTYPE_SIDFOT_IMAGE',
          DisplayLabel: 'Logotyp sidfot',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Brevlayout'],
        },
        LOGOTYPE_SIDFOT_IMAGE_SIZE: {
          AttributeName: 'LOGOTYPE_SIDFOT_IMAGE_SIZE',
          DisplayLabel: 'Logotyp sidfot',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Brevlayout'],
        },
        LOGOTYPE_SIDFOT_WIDTH_MM: {
          AttributeName: 'LOGOTYPE_SIDFOT_WIDTH_MM',
          DisplayLabel: 'Logotyp sidfot bredd (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Brevlayout'],
        },
        LOGOTYPE_SIDFOT_HEIGHT_MM: {
          AttributeName: 'LOGOTYPE_SIDFOT_HEIGHT_MM',
          DisplayLabel: 'Logotyp sidfot höjd (mm)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Brevlayout'],
        },
        BOKNBEKR_RUBRIK: {
          AttributeName: 'BOKNBEKR_RUBRIK',
          DisplayLabel: 'Rubrik, bokn.bekräftelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKNBEKR_ENHETSNAMN: {
          AttributeName: 'BOKNBEKR_ENHETSNAMN',
          DisplayLabel: 'Enhetsnamn, bokn.bekräftelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DOLJ_ORDERNR: {
          AttributeName: 'DOLJ_ORDERNR',
          DisplayLabel: 'Dölj ordernr och datum',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EGENDEFINIERAD: {
          AttributeName: 'EGENDEFINIERAD',
          DisplayLabel: 'Egendefinierad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EGEN_RUBRIK: {
          AttributeName: 'EGEN_RUBRIK',
          DisplayLabel: 'Egen rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        EGEN_TEXT: {
          AttributeName: 'EGEN_TEXT',
          DisplayLabel: 'Egen text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        EGEN_RADRUBRIK: {
          AttributeName: 'EGEN_RADRUBRIK',
          DisplayLabel: 'Egen radrubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        FAKTURA_RUBRIK: {
          AttributeName: 'FAKTURA_RUBRIK',
          DisplayLabel: 'Fakturarubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KRAV_RUBRIK: {
          AttributeName: 'KRAV_RUBRIK',
          DisplayLabel: 'Kravrubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOGOTYPE_TYP: {
          AttributeName: 'LOGOTYPE_TYP',
          DisplayLabel: 'Typ av logotyp',
          Hint: 'Logotyp och namn enligt bolagsuppgifter/Logotyp enligt denna layout/Enbart firmabeteckning',
          DataType: 'Enum',
          EnumValues: new Map([['LOGOTYP_OCH_NAMN_ENLIGT_BOLAGSUPPGIFTER', 'Logotyp och namn enligt bolagsuppgifter'], ['LOGOTYP_ENLIGT_DENNA_LAYOUT', 'Logotyp enligt denna layout'], ['ENBART_FIRMABETECKNING', 'Enbart firmabeteckning']]),
          EnumSortValues: new Map([['LOGOTYP_OCH_NAMN_ENLIGT_BOLAGSUPPGIFTER', 'B'], ['LOGOTYP_ENLIGT_DENNA_LAYOUT', 'L'], ['ENBART_FIRMABETECKNING', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LOGOTYP_OCH_NAMN_ENLIGT_BOLAGSUPPGIFTER=Logotyp och namn enligt bolagsuppgifter;LOGOTYP_ENLIGT_DENNA_LAYOUT=Logotyp enligt denna layout;ENBART_FIRMABETECKNING=Enbart firmabeteckning"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturalayoutBlob',
          AssociatedComponentName: 'KremBlankettBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        FakturalayoutGrupp: {
          AssociationName: 'FakturalayoutGrupp',
          DisplayLabel: 'FakturalayoutGrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSFakturalayoutGrupp',
          AssociatedComponentName: 'FakturalayoutGrupp',
          JoinAssociation: false,
          ValidInComps: ['Fakturalayout'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSFakturalayoutBlob: {
      CollectionName: 'SYSFakturalayoutBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KremBlankettBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSFakturalayoutBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSFakturalayoutBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'SYSFakturalayoutBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSFakturalayoutBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FOOTER_ASKKVITTO: {
          AttributeName: 'FOOTER_ASKKVITTO',
          DisplayLabel: 'Sidfot Askkvitto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
          ValidInComps: ['KremBlankett'],
        },
        FOOTER_ASKKVITTO_SIZE: {
          AttributeName: 'FOOTER_ASKKVITTO_SIZE',
          DisplayLabel: 'Storlek Askkvitto',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          ValidInComps: ['KremBlankett'],
        },
        FOOTER_IDBEVIS: {
          AttributeName: 'FOOTER_IDBEVIS',
          DisplayLabel: 'Sidfot ID-bevis',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
          ValidInComps: ['KremBlankett'],
        },
        FOOTER_IDBEVIS_SIZE: {
          AttributeName: 'FOOTER_IDBEVIS_SIZE',
          DisplayLabel: 'Storlek ID-bevis',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          ValidInComps: ['KremBlankett'],
        },
        FOOTER_HAMTAURNA: {
          AttributeName: 'FOOTER_HAMTAURNA',
          DisplayLabel: 'Sidfot Hämta urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
          ValidInComps: ['KremBlankett'],
        },
        FOOTER_HAMTAURNA_SIZE: {
          AttributeName: 'FOOTER_HAMTAURNA_SIZE',
          DisplayLabel: 'Storlek Hämta urna',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          ValidInComps: ['KremBlankett'],
        },
        FOOTER_KREMJ: {
          AttributeName: 'FOOTER_KREMJ',
          DisplayLabel: 'Sidfot Kremationsjournal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
          ValidInComps: ['KremBlankett'],
        },
        FOOTER_KREMJ_SIZE: {
          AttributeName: 'FOOTER_KREMJ_SIZE',
          DisplayLabel: 'Storlek Kremationsjournal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          ValidInComps: ['KremBlankett'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSRoll: {
      CollectionName: 'SYSRoll',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '7002']]),
      RootType: {
        TypeValue: 'Roll',
        Abstract: false,
        SOLabel: 'Roll',
        SOGLabel: 'Roll',
        SBLabel: 'Rollen',
        SBGLabel: 'Rollen',
        POLabel: 'Roller',
        POGLabel: 'Roller',
        PBLabel: 'Rollerna',
        PBGLabel: 'Rollerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rollen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rollen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rollen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rollen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        FORDEFINIERAD: {
          AttributeName: 'FORDEFINIERAD',
          DisplayLabel: 'Fördefinierad roll',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PWD_CONSTR_ID: {
          AttributeName: 'PWD_CONSTR_ID',
          DisplayLabel: 'Lösenordskrav',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        IDKOD_AVENY: {
          AttributeName: 'IDKOD_AVENY',
          DisplayLabel: 'Intern kod aveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        STDROLL_SUBSYSTEMS: {
          AttributeName: 'STDROLL_SUBSYSTEMS',
          DisplayLabel: 'Avser delprogram',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRollBlob',
          AssociatedComponentName: 'RollBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Rutinbehorighet: {
          AssociationName: 'Rutinbehorighet',
          DisplayLabel: 'Behörighet till rutin',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRutinBehorighet',
          AssociatedComponentName: 'RutinBehorighet',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Losenordskrav: {
          AssociationName: 'Losenordskrav',
          DisplayLabel: 'Krav på lösenord',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSLosenordskrav',
          AssociatedComponentName: 'Losenordskrav',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AnvandarRoller: {
          AssociationName: 'AnvandarRoller',
          DisplayLabel: 'Användarroller',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSAnvandarRoll',
          AssociatedComponentName: 'AnvandarRoll',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSRollBlob: {
      CollectionName: 'SYSRollBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RollBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSRollBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSRollBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'SYSRollBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSRollBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSRutinBehorighet: {
      CollectionName: 'SYSRutinBehorighet',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RutinBehorighet',
        Abstract: false,
        SOLabel: 'Rutinbehörighet',
        SOGLabel: 'Rutinbehörighet',
        SBLabel: 'Rutinbehörigheten',
        SBGLabel: 'Rutinbehörigheten',
        POLabel: 'Rutinbehörigheter',
        POGLabel: 'Rutinbehörigheter',
        PBLabel: 'Rutinbehörigheterna',
        PBGLabel: 'Rutinbehörigheterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rutinbehörigheten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rutinbehörigheten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rutinbehörigheten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rutinbehörigheten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SECURITY_LEVEL: {
          AttributeName: 'SECURITY_LEVEL',
          DisplayLabel: 'Behörighetsnivå',
          Hint: 'Ej behörig/Läsbehörighet/Behörig',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_BEHORIG', 'Ej behörig'], ['LASBEHORIGHET', 'Läsbehörighet'], ['BEHORIG', 'Behörig']]),
          EnumSortValues: new Map([['EJ_BEHORIG', '1'], ['LASBEHORIGHET', '2'], ['BEHORIG', '3']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_BEHORIG=Ej behörig;LASBEHORIGHET=Läsbehörighet;BEHORIG=Behörig"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rutin: {
          AssociationName: 'Rutin',
          DisplayLabel: 'Rutin',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRutin',
          AssociatedComponentName: 'Rutin',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Roll: {
          AssociationName: 'Roll',
          DisplayLabel: 'Roll',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSRoll',
          AssociatedComponentName: 'Roll',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSRutin: {
      CollectionName: 'SYSRutin',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rutin',
        Abstract: false,
        SOLabel: 'Rutin',
        SOGLabel: 'Rutin',
        SBLabel: 'Rutinen',
        SBGLabel: 'Rutinen',
        POLabel: 'Rutiner',
        POGLabel: 'Rutiner',
        PBLabel: 'Rutinerna',
        PBGLabel: 'Rutinerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rutinen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rutinen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rutinen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rutinen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATAMODULE_TYPE: {
          AttributeName: 'DATAMODULE_TYPE',
          DisplayLabel: 'Datamodultyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION: {
          AttributeName: 'CAPTION',
          DisplayLabel: 'Caption',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PARENT_ROUTINE_ID: {
          AttributeName: 'PARENT_ROUTINE_ID',
          DisplayLabel: 'Parent routine',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SPARR_TYP: {
          AttributeName: 'SPARR_TYP',
          DisplayLabel: 'Spärr, typ',
          Hint: 'Tillgång till rutin spärrad/Skrivbehörighet spärrad/Ingen spärr',
          DataType: 'Enum',
          EnumValues: new Map([['TILLGANG_TILL_RUTIN_SPARRAD', 'Tillgång till rutin spärrad'], ['SKRIVBEHORIGHET_SPARRAD', 'Skrivbehörighet spärrad'], ['INGEN_SPARR', 'Ingen spärr']]),
          EnumSortValues: new Map([['TILLGANG_TILL_RUTIN_SPARRAD', 'T'], ['SKRIVBEHORIGHET_SPARRAD', 'S'], ['INGEN_SPARR', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLGANG_TILL_RUTIN_SPARRAD=Tillgång till rutin spärrad;SKRIVBEHORIGHET_SPARRAD=Skrivbehörighet spärrad;INGEN_SPARR=Ingen spärr"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SPARR_FRAN_DATUM: {
          AttributeName: 'SPARR_FRAN_DATUM',
          DisplayLabel: 'Spärr, från datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Subsystem: {
          AttributeName: 'Subsystem',
          DisplayLabel: 'Delprogram',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        GasUtSparrInfo: {
          AttributeName: 'GasUtSparrInfo',
          DisplayLabel: 'Extra behörighetsinfo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRutinBlob',
          AssociatedComponentName: 'RutinBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Delsystem: {
          AssociationName: 'Delsystem',
          DisplayLabel: 'Ingår i delsystem',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSDelsystemRutin',
          AssociatedComponentName: 'DelsystemRutin',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSDelsystemRutin: {
      CollectionName: 'SYSDelsystemRutin',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'DelsystemRutin',
        Abstract: false,
        SOLabel: 'Rutin per delsystem',
        SOGLabel: 'Rutin per delsystem',
        SBLabel: 'Rutinen per delsystem',
        SBGLabel: 'Rutinen per delsystem',
        POLabel: 'Rutiner per delsystem',
        POGLabel: 'Rutiner per delsystem',
        PBLabel: 'Rutinerna per delsystem',
        PBGLabel: 'Rutinerna per delsystem',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rutinen per delsystem primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rutinen per delsystem versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rutinen per delsystem id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rutinen per delsystem fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEMCODE: {
          AttributeName: 'SUBSYSTEMCODE',
          DisplayLabel: 'Delsystem',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        OPTIONS: {
          AttributeName: 'OPTIONS',
          DisplayLabel: 'Optioner',
          Hint: 'Rutin/Styrvärde/Annat',
          DataType: 'Enum',
          EnumValues: new Map([['RUTIN', 'Rutin'], ['STYRVARDE', 'Styrvärde'], ['ANNAT', 'Annat']]),
          EnumSortValues: new Map([['RUTIN', 'R'], ['STYRVARDE', 'O'], ['ANNAT', 'A']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="RUTIN=Rutin;STYRVARDE=Styrvärde;ANNAT=Annat"',
          InterfaceType: 'ifChecklist',
        },
        SORTORDER: {
          AttributeName: 'SORTORDER',
          DisplayLabel: 'Sortorder',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSRutinBlob: {
      CollectionName: 'SYSRutinBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'RutinBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSRutinBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSRutinBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'SYSRutinBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSRutinBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT: {
          AttributeName: 'HINT',
          DisplayLabel: 'Hint',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSRantesats: {
      CollectionName: 'SYSRantesats',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y']]),
      RootType: {
        TypeValue: 'Rantesats',
        Abstract: false,
        SOLabel: 'Räntesats',
        SOGLabel: 'Räntesats',
        SBLabel: 'Räntesatsen',
        SBGLabel: 'Räntesatsen',
        POLabel: 'Räntesatser',
        POGLabel: 'Räntesatser',
        PBLabel: 'Räntesatserna',
        PBGLabel: 'Räntesatserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Räntesatsen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Räntesatsen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Räntesatsen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Räntesatsen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Fråndatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RANTESATS: {
          AttributeName: 'RANTESATS',
          DisplayLabel: 'Räntesats',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rantetabell: {
          AssociationName: 'Rantetabell',
          DisplayLabel: 'Räntetabell',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRanteTabell',
          AssociatedComponentName: 'Rantetabell',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSRanteTabell: {
      CollectionName: 'SYSRanteTabell',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rantetabell',
        Abstract: true,
        SOLabel: 'Räntetabell',
        SOGLabel: 'Räntetabell',
        SBLabel: 'Räntetabellen',
        SBGLabel: 'Räntetabellen',
        POLabel: 'Räntetabeller',
        POGLabel: 'Räntetabeller',
        PBLabel: 'Räntetabellerna',
        PBGLabel: 'Räntetabellerna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Basrantetabell',
            Abstract: false,
            SOLabel: 'Basräntetabell',
            SOGLabel: 'Basräntetabell',
            SBLabel: 'Basräntetabellen',
            SBGLabel: 'Basräntetabellen',
            POLabel: 'Basräntetabeller',
            POGLabel: 'Basräntetabeller',
            PBLabel: 'Basräntetabellerna',
            PBGLabel: 'Basräntetabellerna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'RelativRantetabell',
            Abstract: false,
            SOLabel: 'Relativ räntetabell',
            SOGLabel: 'Relativ räntetabell',
            SBLabel: 'Relativa räntetabellen',
            SBGLabel: 'Relativa räntetabellen',
            POLabel: 'Relativa räntetabeller',
            POGLabel: 'Relativa räntetabeller',
            PBLabel: 'Relativa räntetabellerna',
            PBGLabel: 'Relativa räntetabellerna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Räntetabellen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Räntetabellen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Räntetabellstyp',
          DataType: 'Enum',
          EnumValues: new Map([['BASRANTETABELL', 'Basräntetabell'], ['RELATIVRANTETABELL', 'Relativ räntetabell']]),
          EnumSortValues: new Map([['BASRANTETABELL', 'B'], ['RELATIVRANTETABELL', 'R']]),
          Attribute: 'Normal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BASRANTETABELL=Basräntetabell;RELATIVRANTETABELL=Relativ räntetabell"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Räntetabellen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Räntetabellen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RANTETABELLKOD: {
          AttributeName: 'RANTETABELLKOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        ANVANDSFOR: {
          AttributeName: 'ANVANDSFOR',
          DisplayLabel: 'Används för',
          Hint: 'Dröjsmålsränta/Internränta/Skuldränta avräkn.avtal/Skulduppräkning fasttidsavtal/Tillgodoränta avräkn.avtal',
          DataType: 'Enum',
          EnumValues: new Map([['DROJSMALSRANTA', 'Dröjsmålsränta'], ['INTERNRANTA', 'Internränta'], ['SKULDRANTA_AVRAKN_AVTAL', 'Skuldränta avräkn.avtal'], ['SKULDUPPRAKNING_FASTTIDSAVTAL', 'Skulduppräkning fasttidsavtal'], ['TILLGODORANTA_AVRAKN_AVTAL', 'Tillgodoränta avräkn.avtal']]),
          EnumSortValues: new Map([['DROJSMALSRANTA', 'D'], ['INTERNRANTA', 'I'], ['SKULDRANTA_AVRAKN_AVTAL', 'S'], ['SKULDUPPRAKNING_FASTTIDSAVTAL', 'U'], ['TILLGODORANTA_AVRAKN_AVTAL', 'F']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DROJSMALSRANTA=Dröjsmålsränta;INTERNRANTA=Internränta;SKULDRANTA_AVRAKN_AVTAL=Skuldränta avräkn.avtal;SKULDUPPRAKNING_FASTTIDSAVTAL=Skulduppräkning fasttidsavtal;TILLGODORANTA_AVRAKN_AVTAL=Tillgodoränta avräkn.avtal"',
          InterfaceType: 'ifChecklist',
        },
        BASRANTA_ID: {
          AttributeName: 'BASRANTA_ID',
          DisplayLabel: 'Basräntetabell_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['RelativRantetabell'],
        },
        Basrantetabell: {
          AttributeName: 'Basrantetabell',
          DisplayLabel: 'Basräntetabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['RelativRantetabell'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        BasranteTabell: {
          AssociationName: 'BasranteTabell',
          DisplayLabel: 'Basräntetabell',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRanteTabell',
          AssociatedComponentName: 'Basrantetabell',
          JoinAssociation: true,
          ValidInComps: ['RelativRantetabell'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rantesats: {
          AssociationName: 'Rantesats',
          DisplayLabel: 'Räntesats',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRantesats',
          AssociatedComponentName: 'Rantesats',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        RelativRanteTabell: {
          AssociationName: 'RelativRanteTabell',
          DisplayLabel: 'Relativ räntetabell',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSRanteTabell',
          AssociatedComponentName: 'RelativRantetabell',
          JoinAssociation: false,
          ValidInComps: ['Basrantetabell'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSSchemaLoggSub: {
      CollectionName: 'SYSSchemaLoggSub',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SchemaLoggSub',
        Abstract: false,
        SOLabel: 'Schemalogg undertabell',
        SOGLabel: 'Schemaloggs undertabell',
        SBLabel: 'Schemaloggen undertabell',
        SBGLabel: 'Schemaloggens undertabell',
        POLabel: 'Schemaloggar undertabeller',
        POGLabel: 'Schemaloggars undertabeller',
        PBLabel: 'Schemaloggarna undertabeller',
        PBGLabel: 'Schemaloggarnas undertabeller',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Schemaloggens undertabell primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Schemaloggens undertabell versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Schemaloggens undertabell fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBID: {
          AttributeName: 'SUBID',
          DisplayLabel: 'SUBID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Batch: {
          AssociationName: 'Batch',
          DisplayLabel: 'Fil',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKommunikatorBatch',
          AssociatedComponentName: 'KommunikatorBatch',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSSchemalogg: {
      CollectionName: 'SYSSchemalogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Schemalogg',
        Abstract: false,
        SOLabel: 'Schemalogg',
        SOGLabel: 'Schemaloggs',
        SBLabel: 'Schemaloggen',
        SBGLabel: 'Schemaloggens',
        POLabel: 'Schemaloggar',
        POGLabel: 'Schemaloggars',
        PBLabel: 'Schemaloggarna',
        PBGLabel: 'Schemaloggarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Schemaloggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Schemaloggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Schemaloggens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Fråga - adressbok/Fråga - bevakning/Fråga - lokalt skydd/Hämta/Kommunikationstest/Odefinierad',
          DataType: 'Enum',
          EnumValues: new Map([['FRAGA___ADRESSBOK', 'Fråga - adressbok'], ['FRAGA___BEVAKNING', 'Fråga - bevakning'], ['FRAGA___LOKALT_SKYDD', 'Fråga - lokalt skydd'], ['HAMTA', 'Hämta'], ['KOMMUNIKATIONSTEST', 'Kommunikationstest'], ['ODEFINIERAD', 'Odefinierad']]),
          EnumSortValues: new Map([['FRAGA___ADRESSBOK', 'A'], ['FRAGA___BEVAKNING', 'B'], ['FRAGA___LOKALT_SKYDD', 'L'], ['HAMTA', 'H'], ['KOMMUNIKATIONSTEST', 'K'], ['ODEFINIERAD', 'O']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FRAGA___ADRESSBOK=Fråga - adressbok;FRAGA___BEVAKNING=Fråga - bevakning;FRAGA___LOKALT_SKYDD=Fråga - lokalt skydd;HAMTA=Hämta;KOMMUNIKATIONSTEST=Kommunikationstest;ODEFINIERAD=Odefinierad"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains],
          DefaultCondOperator: T.starts,
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        calcStatus: {
          AttributeName: 'calcStatus',
          DisplayLabel: 'Status',
          Hint: 'Visar feltext eller lyckad fråga/hämtning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ERRORTYPE: {
          AttributeName: 'ERRORTYPE',
          DisplayLabel: 'Fel',
          Hint: 'Fel i anrop - Fel/Fel vid uppdatering/Inget fel',
          DataType: 'Enum',
          EnumValues: new Map([['FEL', 'Fel'], ['FEL_VID_UPPDATERING', 'Fel vid uppdatering'], ['INGET_FEL', 'Inget fel']]),
          EnumSortValues: new Map([['FEL', 'F'], ['FEL_VID_UPPDATERING', 'U'], ['INGET_FEL', 'C']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FEL=Fel;FEL_VID_UPPDATERING=Fel vid uppdatering;INGET_FEL=Inget fel"',
        },
        ANTALATTHAMTA: {
          AttributeName: 'ANTALATTHAMTA',
          DisplayLabel: 'Antal att hämta',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Batches: {
          AssociationName: 'Batches',
          DisplayLabel: 'Filer',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSSchemaLoggSub',
          AssociatedComponentName: 'SchemaLoggSub',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSScheduler: {
      CollectionName: 'SYSScheduler',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Scheduler',
        Abstract: false,
        SOLabel: 'Schemaläggare',
        SOGLabel: 'Schemaläggares',
        SBLabel: 'Schemaläggaren',
        SBGLabel: 'Schemaläggarens',
        POLabel: 'Schemaläggare',
        POGLabel: 'Schemaläggares',
        PBLabel: 'Schemaläggarna',
        PBGLabel: 'Schemaläggarnas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Communicator',
            Abstract: false,
            SOLabel: 'Adressuppdatering',
            SOGLabel: 'Adressuppdaterings',
            SBLabel: 'Adressuppdateringen',
            SBGLabel: 'Adressuppdateringens',
            POLabel: 'Adressuppdateringar',
            POGLabel: 'Adressuppdateringars',
            PBLabel: 'Adressuppdateringarna',
            PBGLabel: 'Adressuppdateringarnas',
            Visible: false,
            ChildTypes: [
              {
                TypeValue: 'FetchPersoner',
                Abstract: false,
                SOLabel: 'Fråga',
                SOGLabel: 'Frågas',
                SBLabel: 'Frågan',
                SBGLabel: 'Frågans',
                POLabel: 'Frågor',
                POGLabel: 'Frågors',
                PBLabel: 'Frågorna',
                PBGLabel: 'Frågornas',
                Visible: false,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'FetchMedlemmar',
                Abstract: false,
                SOLabel: 'Fråga',
                SOGLabel: 'Frågas',
                SBLabel: 'Frågan',
                SBGLabel: 'Frågans',
                POLabel: 'Frågor',
                POGLabel: 'Frågors',
                PBLabel: 'Frågorna',
                PBGLabel: 'Frågornas',
                Visible: false,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'FetchBatch',
                Abstract: false,
                SOLabel: 'Hämta adresser',
                SOGLabel: 'Hämta adressers',
                SBLabel: 'Hämta adresserna',
                SBGLabel: 'Hämta adressernas',
                POLabel: 'Hämta adresser',
                POGLabel: 'Hämta adressers',
                PBLabel: 'Hämta adresserna',
                PBGLabel: 'Hämta adressernas',
                Visible: false,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Schemaläggarens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Schemaläggarens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Schemaläggarens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USAGECODE: {
          AttributeName: 'USAGECODE',
          DisplayLabel: 'Schematyp',
          Hint: 'Daglig, veckovis, månadsvis... - Dagligen/Veckovis/Månadsvis/Årsvis/Ett tillfälle',
          DataType: 'Enum',
          EnumValues: new Map([['COMMUNICATOR', 'Adressuppdatering'], ['FETCHPERSONER', 'Fråga'], ['FETCHMEDLEMMAR', 'Fråga'], ['FETCHBATCH', 'Hämta adresser']]),
          EnumSortValues: new Map([['COMMUNICATOR', 'A'], ['FETCHPERSONER', 'V'], ['FETCHMEDLEMMAR', 'X'], ['FETCHBATCH', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="COMMUNICATOR=Adressuppdatering;FETCHPERSONER=Fråga;FETCHMEDLEMMAR=Fråga;FETCHBATCH=Hämta adresser"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Aktivitet',
          Hint: 'Typ av aktivitet som körs - Fråga samtliga adresser/Fråga medlemmars adresser/Hämta beställda adresser',
          DataType: 'Enum',
          EnumValues: new Map([['COMMUNICATOR', 'Adressuppdatering'], ['FETCHPERSONER', 'Fråga'], ['FETCHMEDLEMMAR', 'Fråga'], ['FETCHBATCH', 'Hämta adresser']]),
          EnumSortValues: new Map([['COMMUNICATOR', 'A'], ['FETCHPERSONER', 'V'], ['FETCHMEDLEMMAR', 'X'], ['FETCHBATCH', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="COMMUNICATOR=Adressuppdatering;FETCHPERSONER=Fråga;FETCHMEDLEMMAR=Fråga;FETCHBATCH=Hämta adresser"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ACTIVE: {
          AttributeName: 'ACTIVE',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        RUNEXTERNAL: {
          AttributeName: 'RUNEXTERNAL',
          DisplayLabel: 'Kör i Windows Schemaläggare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        SCHEDULENAME: {
          AttributeName: 'SCHEDULENAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        STARTDATE: {
          AttributeName: 'STARTDATE',
          DisplayLabel: 'Starttid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENDDATE: {
          AttributeName: 'ENDDATE',
          DisplayLabel: 'Sluttid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INTERVAL: {
          AttributeName: 'INTERVAL',
          DisplayLabel: 'Intervall timmar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYPEBITMASK: {
          AttributeName: 'TYPEBITMASK',
          DisplayLabel: 'Valda veckodagar/ månader',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MISSING_ACTION: {
          AttributeName: 'MISSING_ACTION',
          DisplayLabel: 'Om tillfället missats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DAYOFMONTH: {
          AttributeName: 'DAYOFMONTH',
          DisplayLabel: 'Dag i månaden',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATEOFYEAR: {
          AttributeName: 'DATEOFYEAR',
          DisplayLabel: 'Datum varje år',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SysSekretessLogg: {
      CollectionName: 'SysSekretessLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SekretessLogg',
        Abstract: false,
        SOLabel: 'Sekretess logg',
        SOGLabel: 'Sekretess loggs',
        SBLabel: 'Sekretess loggen',
        SBGLabel: 'Sekretess loggens',
        POLabel: 'Sekretess loggar',
        POGLabel: 'Sekretess loggars',
        PBLabel: 'Sekretess loggars',
        PBGLabel: 'Sekretess loggarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Sekretess loggens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Sekretess loggens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Sekretess loggens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Sekretess loggens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDPUNKT: {
          AttributeName: 'TIDPUNKT',
          DisplayLabel: 'Tidpunkt',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        UTFORD_AV: {
          AttributeName: 'UTFORD_AV',
          DisplayLabel: 'Utförd av',
          Hint: 'Manuellt av användaren',
          DataType: 'Enum',
          EnumValues: new Map([['MANUELLT_AV_ANVANDAREN', 'Manuellt av användaren']]),
          EnumSortValues: new Map([['MANUELLT_AV_ANVANDAREN', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MANUELLT_AV_ANVANDAREN=Manuellt av användaren"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        HANDELSE: {
          AttributeName: 'HANDELSE',
          DisplayLabel: 'Händelse',
          Hint: 'Export av data/Visning av data/Sekretessmarkering/Avmarkering av sekretess',
          DataType: 'Enum',
          EnumValues: new Map([['EXPORT_AV_DATA', 'Export av data'], ['VISNING_AV_DATA', 'Visning av data'], ['SEKRETESSMARKERING', 'Sekretessmarkering'], ['AVMARKERING_AV_SEKRETESS', 'Avmarkering av sekretess']]),
          EnumSortValues: new Map([['EXPORT_AV_DATA', 'E'], ['VISNING_AV_DATA', 'V'], ['SEKRETESSMARKERING', 'S'], ['AVMARKERING_AV_SEKRETESS', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EXPORT_AV_DATA=Export av data;VISNING_AV_DATA=Visning av data;SEKRETESSMARKERING=Sekretessmarkering;AVMARKERING_AV_SEKRETESS=Avmarkering av sekretess"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        KALLA: {
          AttributeName: 'KALLA',
          DisplayLabel: 'Källa',
          Hint: 'Manuellt/Skatteverket',
          DataType: 'Enum',
          EnumValues: new Map([['MANUELLT', 'Manuellt'], ['SKATTEVERKET', 'Skatteverket']]),
          EnumSortValues: new Map([['MANUELLT', 'M'], ['SKATTEVERKET', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="MANUELLT=Manuellt;SKATTEVERKET=Skatteverket"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVANDARE_ID: {
          AttributeName: 'ANVANDARE_ID',
          DisplayLabel: 'Användare',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        OBJEKT_COLLECTIONNAME: {
          AttributeName: 'OBJEKT_COLLECTIONNAME',
          DisplayLabel: 'Objektets collectionname',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Interna loggvärden',
        },
        OBJEKT_ID: {
          AttributeName: 'OBJEKT_ID',
          DisplayLabel: 'Objekt id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Interna loggvärden',
        },
        IP: {
          AttributeName: 'IP',
          DisplayLabel: 'IP Nummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATORNAMN: {
          AttributeName: 'DATORNAMN',
          DisplayLabel: 'Datornamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OBJEKT_BENAMNING: {
          AttributeName: 'OBJEKT_BENAMNING',
          DisplayLabel: 'Loggad benämning',
          Hint: 'Benämning på objektet vid loggning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVANDARE_NAMN: {
          AttributeName: 'ANVANDARE_NAMN',
          DisplayLabel: 'Användarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANVANDARE_SIGNATUR: {
          AttributeName: 'ANVANDARE_SIGNATUR',
          DisplayLabel: 'Användarens signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ObjektTypBenamning: {
          AttributeName: 'ObjektTypBenamning',
          DisplayLabel: 'Typ av objekt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        OBJEKT_CLASSNAME: {
          AttributeName: 'OBJEKT_CLASSNAME',
          DisplayLabel: 'Objektets classname',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Interna loggvärden',
        },
        OBJEKT_CODE: {
          AttributeName: 'OBJEKT_CODE',
          DisplayLabel: 'Objektets code',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Interna loggvärden',
        },
        OBJEKT_GUID: {
          AttributeName: 'OBJEKT_GUID',
          DisplayLabel: 'Objektets GUID',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          AttributeGroup: 'Interna loggvärden',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Anledning för tillfällig spärr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 500,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        NOTERING2: {
          AttributeName: 'NOTERING2',
          DisplayLabel: 'Orsak till export av data',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSSessionToken: {
      CollectionName: 'SYSSessionToken',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SessionToken',
        Abstract: false,
        SOLabel: 'SessionToken',
        SOGLabel: 'SessionToken',
        SBLabel: 'SessionToken',
        SBGLabel: 'SessionToken',
        POLabel: 'SessionToken',
        POGLabel: 'SessionToken',
        PBLabel: 'SessionToken',
        PBGLabel: 'SessionToken',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SessionToken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SessionToken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'SessionToken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SessionToken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CONTENT: {
          AttributeName: 'CONTENT',
          DisplayLabel: 'Innehåll',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        EXPIRES: {
          AttributeName: 'EXPIRES',
          DisplayLabel: 'Giltig t.o.m.',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSSIEMottagningsvag: {
      CollectionName: 'SYSSIEMottagningsvag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SIEMottagningsvag',
        Abstract: false,
        SOLabel: 'SIE-mottagningsväg',
        SOGLabel: 'SIE-mottagningsvägs',
        SBLabel: 'SIE-mottagningsvägen',
        SBGLabel: 'SIE-mottagningsvägens',
        POLabel: 'SIE-mottagningsvägar',
        POGLabel: 'SIE-mottagningsvägars',
        PBLabel: 'SIE-mottagningsvägarna',
        PBGLabel: 'SIE-mottagningsvägarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SIE-mottagningsvägens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SIE-mottagningsvägens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'SIE-mottagningsvägens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SIE-mottagningsvägens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IMPORTTYP: {
          AttributeName: 'IMPORTTYP',
          DisplayLabel: 'Importtyp',
          Hint: 'SIE4',
          DataType: 'Enum',
          EnumValues: new Map([['SIE4', 'SIE4']]),
          EnumSortValues: new Map([['SIE4', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SIE4=SIE4"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IMPORTKATALOG: {
          AttributeName: 'IMPORTKATALOG',
          DisplayLabel: 'Importkatalog',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IMPORTFIL: {
          AttributeName: 'IMPORTFIL',
          DisplayLabel: 'Importfil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokföringsgrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Borttagen',
        },
        ANVAND_VERNR: {
          AttributeName: 'ANVAND_VERNR',
          DisplayLabel: 'Använd ver.nr i fil',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'ID-kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        FORSYSTEM_TYP: {
          AttributeName: 'FORSYSTEM_TYP',
          DisplayLabel: 'Försystem',
          Hint: 'Bokning/Grav/Kremationsjournal/Lön/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['BOKNING', 'Bokning'], ['GRAV', 'Grav'], ['KREMATIONSJOURNAL', 'Kremationsjournal'], ['LON', 'Lön'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['BOKNING', 'B'], ['GRAV', 'G'], ['KREMATIONSJOURNAL', 'K'], ['LON', 'L'], ['OVRIGT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BOKNING=Bokning;GRAV=Grav;KREMATIONSJOURNAL=Kremationsjournal;LON=Lön;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KalkImportkatalog: {
          AttributeName: 'KalkImportkatalog',
          DisplayLabel: 'Importkatalog',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokfgrupp: {
          AssociationName: 'Bokfgrupp',
          DisplayLabel: 'Bokföringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Bokfgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSKivraSignLogg: {
      CollectionName: 'SYSKivraSignLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KivraSignLogg',
        Abstract: false,
        SOLabel: 'Signering',
        SOGLabel: 'Signerings',
        SBLabel: 'Signeringen',
        SBGLabel: 'Signeringens',
        POLabel: 'Signeringar',
        POGLabel: 'Signeringars',
        PBLabel: 'Signeringarna',
        PBGLabel: 'Signeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Signeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Signeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Signeringens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Signeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tidpunkt',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FUNKTION: {
          AttributeName: 'FUNKTION',
          DisplayLabel: 'Funktion',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        URL: {
          AttributeName: 'URL',
          DisplayLabel: 'URL',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        REQUEST: {
          AttributeName: 'REQUEST',
          DisplayLabel: 'Anrop',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        RESPONSE: {
          AttributeName: 'RESPONSE',
          DisplayLabel: 'Svar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        FELTEXT: {
          AttributeName: 'FELTEXT',
          DisplayLabel: 'Feltext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSSprak: {
      CollectionName: 'SYSSprak',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Sprak',
        Abstract: false,
        SOLabel: 'Språk',
        SOGLabel: 'Språk',
        SBLabel: 'Språket',
        SBGLabel: 'Språket',
        POLabel: 'Språk',
        POGLabel: 'Språk',
        PBLabel: 'Språken',
        PBGLabel: 'Språken',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Språket primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Språket versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Språket id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Språket fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        ANDRASPRAK_ID: {
          AttributeName: 'ANDRASPRAK_ID',
          DisplayLabel: 'Andraspråk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SYSTEMSPRAK: {
          AttributeName: 'SYSTEMSPRAK',
          DisplayLabel: 'Systemspråk',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
        },
        AndraSprak: {
          AttributeName: 'AndraSprak',
          DisplayLabel: 'Andraspråk',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AndraSprak: {
          AssociationName: 'AndraSprak',
          DisplayLabel: 'Andraspråk',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSSprak',
          AssociatedComponentName: 'Sprak',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Land: {
          AssociationName: 'Land',
          DisplayLabel: 'Land',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSStandardtext: {
      CollectionName: 'SYSStandardtext',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'StandardText',
        Abstract: false,
        SOLabel: 'standardtext',
        SOGLabel: 'standardtext',
        SBLabel: 'standardtexten',
        SBGLabel: 'standardtexten',
        POLabel: 'standardtexter',
        POGLabel: 'standardtexter',
        PBLabel: 'standardtexterna',
        PBGLabel: 'standardtexterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'standardtexten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'standardtexten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'standardtexten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'standardtexten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TEXTTYP: {
          AttributeName: 'TEXTTYP',
          DisplayLabel: 'TEXTGRUPP',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSStatistikinstallningar: {
      CollectionName: 'SYSStatistikinstallningar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Statistikinstallningar',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSStatistikinstallningars primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSStatistikinstallningars versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'SYSStatistikinstallningars id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSStatistikinstallningars fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ENHETSID: {
          AttributeName: 'ENHETSID',
          DisplayLabel: 'EnhetsID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Forsamling: {
          AssociationName: 'Forsamling',
          DisplayLabel: 'Församling/Samfällighet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'SamfallighetForsamling',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSSyncedEntitiesLog: {
      CollectionName: 'SYSSyncedEntitiesLog',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SyncedEntitiesLog',
        Abstract: false,
        SOLabel: 'Synkat objekt',
        SOGLabel: 'Synkat objekts',
        SBLabel: 'Synkade objektet',
        SBGLabel: 'Synkade objektets',
        POLabel: 'Synkade objekt',
        POGLabel: 'Synkade objekts',
        PBLabel: 'Synkade objekten',
        PBGLabel: 'Synkade objektens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Synkade objektets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Synkade objektets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Synkade objektets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Synkade objektets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SYNCED_DATE: {
          AttributeName: 'SYNCED_DATE',
          DisplayLabel: 'Synkad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ENTITY_TYPE: {
          AttributeName: 'ENTITY_TYPE',
          DisplayLabel: 'Intern tabell',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ENTITY_KEY: {
          AttributeName: 'ENTITY_KEY',
          DisplayLabel: 'Internt ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CHANGE_CONTEXT: {
          AttributeName: 'CHANGE_CONTEXT',
          DisplayLabel: 'Typ av synkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CHANGE_TYPE: {
          AttributeName: 'CHANGE_TYPE',
          DisplayLabel: 'Typ av ändring',
          Hint: 'Tillägg/Ändring/Borttag/Kontroll',
          DataType: 'Enum',
          EnumValues: new Map([['TILLAGG', 'Tillägg'], ['ANDRING', 'Ändring'], ['BORTTAG', 'Borttag'], ['KONTROLL', 'Kontroll']]),
          EnumSortValues: new Map([['TILLAGG', 'A'], ['ANDRING', 'M'], ['BORTTAG', 'D'], ['KONTROLL', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TILLAGG=Tillägg;ANDRING=Ändring;BORTTAG=Borttag;KONTROLL=Kontroll"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OK: {
          AttributeName: 'OK',
          DisplayLabel: 'OK',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ERROR_MSG: {
          AttributeName: 'ERROR_MSG',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTERNAL_KEY: {
          AttributeName: 'EXTERNAL_KEY',
          DisplayLabel: 'Externt ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTERNAL_INFO: {
          AttributeName: 'EXTERNAL_INFO',
          DisplayLabel: 'Extern info',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        THREAD: {
          AttributeName: 'THREAD',
          DisplayLabel: 'Tråd-id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        URL: {
          AttributeName: 'URL',
          DisplayLabel: 'URL',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        REQUEST: {
          AttributeName: 'REQUEST',
          DisplayLabel: 'Anrop',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RESPONSE: {
          AttributeName: 'RESPONSE',
          DisplayLabel: 'Svar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    SYSOptions: {
      CollectionName: 'SYSOptions',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'Y'], ['AllowSelection', 'All']]),
      RootType: {
        TypeValue: 'Option',
        Abstract: false,
        SOLabel: 'Systeminställning',
        SOGLabel: 'Systeminställning',
        SBLabel: 'Systeminställningen',
        SBGLabel: 'Systeminställningen',
        POLabel: 'Systeminställningar',
        POGLabel: 'Systeminställningar',
        PBLabel: 'Systeminställningarna',
        PBGLabel: 'Systeminställningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Systeminställningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Systeminställningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Systeminställningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Systeminställningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEMCODE: {
          AttributeName: 'SUBSYSTEMCODE',
          DisplayLabel: 'SUBSYSTEMCODE',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        OptionKey: {
          AttributeName: 'OptionKey',
          DisplayLabel: 'OptionKey',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.contains,
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        OptionData: {
          AttributeName: 'OptionData',
          DisplayLabel: 'OptionData',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
      },
    },
    SYSOptionsBlob: {
      CollectionName: 'SYSOptionsBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OptionBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'SYSOptionsBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'SYSOptionsBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'SYSOptionsBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'SYSOptionsBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OptionMemo: {
          AttributeName: 'OptionMemo',
          DisplayLabel: 'OptionMemo',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OPTIONBLOB: {
          AttributeName: 'OPTIONBLOB',
          DisplayLabel: 'OptionBlob',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
      },
      Associations: {
      },
    },
    SYSPeriodTillfalle: {
      CollectionName: 'SYSPeriodTillfalle',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PeriodTillfalle',
        Abstract: false,
        SOLabel: 'Tillfälle',
        SOGLabel: 'Tillfälles',
        SBLabel: 'Tillfället',
        SBGLabel: 'Tillfällets',
        POLabel: 'Tillfällen',
        POGLabel: 'Tillfällens',
        PBLabel: 'Tillfällena',
        PBGLabel: 'Tillfällenas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Tillfällets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Tillfällets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Tillfällets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Tillfällets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERIOD_ID: {
          AttributeName: 'PERIOD_ID',
          DisplayLabel: 'Period',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE: {
          AttributeName: 'VARDE',
          DisplayLabel: 'Värde',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARDE2: {
          AttributeName: 'VARDE2',
          DisplayLabel: 'Värde 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    SYSTitel: {
      CollectionName: 'SYSTitel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Titel',
        Abstract: false,
        SOLabel: 'Titel',
        SOGLabel: 'Titel',
        SBLabel: 'Titeln',
        SBGLabel: 'Titeln',
        POLabel: 'Titlar',
        POGLabel: 'Titlar',
        PBLabel: 'Titlarna',
        PBGLabel: 'Titlarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Titeln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Titeln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Titeln id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Titeln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        KR_SORT: {
          AttributeName: 'KR_SORT',
          DisplayLabel: 'Kundreskontra sortering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        LR_SORT: {
          AttributeName: 'LR_SORT',
          DisplayLabel: 'Leverantörreskontra sortering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kontakttitlar: {
          AssociationName: 'Kontakttitlar',
          DisplayLabel: 'Kontakttitlar',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPKontaktTitel',
          AssociatedComponentName: 'KontaktTitel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    SYSProcUppgift: {
      CollectionName: 'SYSProcUppgift',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ProcUppgift',
        Abstract: false,
        SOLabel: 'Uppgift',
        SOGLabel: 'Uppgifts',
        SBLabel: 'Uppgiften',
        SBGLabel: '',
        POLabel: 'Uppgifter',
        POGLabel: 'Uppgifters',
        PBLabel: 'Uppgifterna',
        PBGLabel: 'Uppgifternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Uppgiftens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Uppgiftens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Uppgiftens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Uppgiftens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ av uppgift',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Senast uppdaterad klockslag',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        HUKI: {
          AttributeName: 'HUKI',
          DisplayLabel: 'Anledning',
          Hint: 'Huvudansvarig/Utförare/Konsulteras/Informeras',
          DataType: 'Enum',
          EnumValues: new Map([['HUVUDANSVARIG', 'Huvudansvarig'], ['UTFORARE', 'Utförare'], ['KONSULTERAS', 'Konsulteras'], ['INFORMERAS', 'Informeras']]),
          EnumSortValues: new Map([['HUVUDANSVARIG', 'H'], ['UTFORARE', 'U'], ['KONSULTERAS', 'K'], ['INFORMERAS', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="HUVUDANSVARIG=Huvudansvarig;UTFORARE=Utförare;KONSULTERAS=Konsulteras;INFORMERAS=Informeras"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        PAKT_ID: {
          AttributeName: 'PAKT_ID',
          DisplayLabel: 'Processaktivitet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DBNAME: {
          AttributeName: 'DBNAME',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ROLL_ID: {
          AttributeName: 'ROLL_ID',
          DisplayLabel: 'Utdelad till roll',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Utdelad till användare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEADLINE: {
          AttributeName: 'DEADLINE',
          DisplayLabel: 'Klar senast datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal att utföra',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ProcAktivitet: {
          AttributeName: 'ProcAktivitet',
          DisplayLabel: 'Processaktivitet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ProcAktivitetID: {
          AttributeName: 'ProcAktivitetID',
          DisplayLabel: 'Processaktivitets-ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        HUKIOrder: {
          AttributeName: 'HUKIOrder',
          DisplayLabel: 'HUKI Sorteringsordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Roll: {
          AssociationName: 'Roll',
          DisplayLabel: 'Utdelad till roll',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Utdelad till användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUrval: {
      CollectionName: 'SYSUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GRAPHQL_READONLY', 'Y'], ['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'Urval',
        Abstract: false,
        SOLabel: 'Urval',
        SOGLabel: 'Urval',
        SBLabel: 'Urvalet',
        SBGLabel: 'Urvalet',
        POLabel: 'Urval',
        POGLabel: 'Urval',
        PBLabel: 'Urvalen',
        PBGLabel: 'Urvalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Urvalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Urvalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Urvalet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Urvalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAME: {
          AttributeName: 'NAME',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        VISIBILITY: {
          AttributeName: 'VISIBILITY',
          DisplayLabel: 'Synlighet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SECURITY_GROUP: {
          AttributeName: 'SECURITY_GROUP',
          DisplayLabel: 'Grupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användarid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SUBSYSTEMCODE: {
          AttributeName: 'SUBSYSTEMCODE',
          DisplayLabel: 'Delsystemkod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        COLLECTION_NAME: {
          AttributeName: 'COLLECTION_NAME',
          DisplayLabel: 'Collectionname',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DESCRIPTION_EXISTS: {
          AttributeName: 'DESCRIPTION_EXISTS',
          DisplayLabel: 'Beskrivning finns',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PREDEF_SQL_EXISTS: {
          AttributeName: 'PREDEF_SQL_EXISTS',
          DisplayLabel: 'Fördef. sql finns',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PREDEF_SQL_PARAMS_EXISTS: {
          AttributeName: 'PREDEF_SQL_PARAMS_EXISTS',
          DisplayLabel: 'Fördef. sql parametrar finns',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USAGE_CODE: {
          AttributeName: 'USAGE_CODE',
          DisplayLabel: 'Kategori',
          Hint: 'Kodbegränsning/Kontourval/Inventeringsansvariga',
          DataType: 'Enum',
          EnumValues: new Map([['KODBEGRANSNING', 'Kodbegränsning'], ['KONTOURVAL', 'Kontourval'], ['INVENTERINGSANSVARIGA', 'Inventeringsansvariga']]),
          EnumSortValues: new Map([['KODBEGRANSNING', 'EKBEH'], ['KONTOURVAL', 'EKLOP'], ['INVENTERINGSANSVARIGA', 'ARANS']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KODBEGRANSNING=Kodbegränsning;KONTOURVAL=Kontourval;INVENTERINGSANSVARIGA=Inventeringsansvariga"',
        },
        Allman: {
          AttributeName: 'Allman',
          DisplayLabel: 'Allmänt',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        AnvandareNameSign: {
          AttributeName: 'AnvandareNameSign',
          DisplayLabel: 'Användare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Urval: {
          AttributeName: 'Urval',
          DisplayLabel: 'Urval',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SynligFor: {
          AttributeName: 'SynligFor',
          DisplayLabel: 'Synlig för',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PUBLISHED_TO: {
          AttributeName: 'PUBLISHED_TO',
          DisplayLabel: 'Synlighet',
          Hint: 'Privat urval/Gemensamt urval/Gruppurval/Standardurval',
          DataType: 'Enum',
          EnumValues: new Map([['PRIVAT_URVAL', 'Privat urval'], ['GEMENSAMT_URVAL', 'Gemensamt urval'], ['GRUPPURVAL', 'Gruppurval'], ['STANDARDURVAL', 'Standardurval']]),
          EnumSortValues: new Map([['PRIVAT_URVAL', '1'], ['GEMENSAMT_URVAL', '2'], ['GRUPPURVAL', '3'], ['STANDARDURVAL', '-1']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PRIVAT_URVAL=Privat urval;GEMENSAMT_URVAL=Gemensamt urval;GRUPPURVAL=Gruppurval;STANDARDURVAL=Standardurval"',
        },
        ROUTINE_ID: {
          AttributeName: 'ROUTINE_ID',
          DisplayLabel: 'RutinID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_KONV: {
          AttributeName: 'KPLAN_KONV',
          DisplayLabel: 'Åtgärdas kontoplanbyte',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        KPLAN_KONV_SELECTION_ID: {
          AttributeName: 'KPLAN_KONV_SELECTION_ID',
          DisplayLabel: 'Konv från id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PARAMS: {
          AttributeName: 'PARAMS',
          DisplayLabel: 'Parametrar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Grupp: {
          AttributeName: 'Grupp',
          DisplayLabel: 'Grupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KODBEH_ANVANDS_FOR: {
          AttributeName: 'KODBEH_ANVANDS_FOR',
          DisplayLabel: 'Kodbehörighet, används för',
          Hint: 'Balans/Resultat/Blandat/Hela huvudboken/Ej definierat',
          DataType: 'Enum',
          EnumValues: new Map([['BALANS', 'Balans'], ['RESULTAT', 'Resultat'], ['BLANDAT', 'Blandat'], ['HELA_HUVUDBOKEN', 'Hela huvudboken'], ['EJ_DEFINIERAT', 'Ej definierat']]),
          EnumSortValues: new Map([['BALANS', '1'], ['RESULTAT', '2'], ['BLANDAT', '3'], ['HELA_HUVUDBOKEN', '4'], ['EJ_DEFINIERAT', '9']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BALANS=Balans;RESULTAT=Resultat;BLANDAT=Blandat;HELA_HUVUDBOKEN=Hela huvudboken;EJ_DEFINIERAT=Ej definierat"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        SelectionGQID: {
          AttributeName: 'SelectionGQID',
          DisplayLabel: 'Urvalets definitions-ID',
          Hint: 'För inläsning av urvalets conditions och sortering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['GRAPHQL_TYPE', 'ID!;']]),
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'Idkod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RapportpaketU: {
          AssociationName: 'RapportpaketU',
          DisplayLabel: 'Utdelad rapport, grundurval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKUtdeladRapport',
          AssociatedComponentName: 'UtdeladRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        RapportpaketB: {
          AssociationName: 'RapportpaketB',
          DisplayLabel: 'Utdelad rapport, kodbegränsning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKUtdeladRapport',
          AssociatedComponentName: 'UtdeladRapport',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        AnvandareB: {
          AssociationName: 'AnvandareB',
          DisplayLabel: 'Kodbegränsning användare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAnvKontourval',
          AssociatedComponentName: 'AnvKontourval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        Arbetstalle: {
          AssociationName: 'Arbetstalle',
          DisplayLabel: 'Kodbegränsing arbetställe',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKStalleKontourval',
          AssociatedComponentName: 'StalleKontourval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        Attestomrade: {
          AssociationName: 'Attestomrade',
          DisplayLabel: 'Attestområde',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestomradeKontobegr',
          AssociatedComponentName: 'AttestOmradeKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        Attestratt: {
          AssociationName: 'Attestratt',
          DisplayLabel: 'Attesträtt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestrattKontobegr',
          AssociatedComponentName: 'AttestrattKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        Attestant: {
          AssociationName: 'Attestant',
          DisplayLabel: 'Attestant',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRAttestantKontobegr',
          AssociatedComponentName: 'AttestantKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        Analys: {
          AssociationName: 'Analys',
          DisplayLabel: 'Ekonomi analys',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAnalys',
          AssociatedComponentName: 'Analys',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        EkonomiRapportRad: {
          AssociationName: 'EkonomiRapportRad',
          DisplayLabel: 'Ekonomirapportrad',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKRapportradsspec',
          AssociatedComponentName: 'Rapportradsspec',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anlaggningsgrupp: {
          AssociationName: 'Anlaggningsgrupp',
          DisplayLabel: 'Anläggningsgrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARAnlGruppInvUrval',
          AssociatedComponentName: 'AnlGruppInvUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Rubrik: {
          AssociationName: 'Rubrik',
          DisplayLabel: 'Rubrik',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'ARRubrikInvUrval',
          AssociatedComponentName: 'RubrikInvUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gavogrupp: {
          AssociationName: 'Gavogrupp',
          DisplayLabel: 'Gåvogrupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKGavogruppUrval',
          AssociatedComponentName: 'GavogruppUrval',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AnvKontobegr: {
          AssociationName: 'AnvKontobegr',
          DisplayLabel: 'Kodbehörighet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKAnvKontobegr',
          AssociatedComponentName: 'AnvKontobegr',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['EKKontoUrval', 'På']]),
        },
        Inventeringsansvariga: {
          AssociationName: 'Inventeringsansvariga',
          DisplayLabel: 'Inventeringsansvariga',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'ARInvAnsvariga',
          AssociatedComponentName: 'InvAnsvariga',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUtbetalningssatt: {
      CollectionName: 'SYSUtbetalningssatt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Utbetalningssatt',
        Abstract: false,
        SOLabel: 'Utbetalningssätt',
        SOGLabel: 'Utbetalningssätt',
        SBLabel: 'Utbetalningssättet',
        SBGLabel: 'Utbetalningssättet',
        POLabel: 'Utbetalningssätt',
        POGLabel: 'Utbetalningssätt',
        PBLabel: 'Utbetalningssättena',
        PBGLabel: 'Utbetalningssättena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utbetalningssättet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utbetalningssättet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utbetalningssättet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utbetalningssättet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETSATTKOD: {
          AttributeName: 'BETSATTKOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BETSATT: {
          AttributeName: 'BETSATT',
          DisplayLabel: 'Betalningssättyp',
          Hint: 'PlusGiro - Girering till PlusGirokonto/PlusGiro - Kontoinsättning till bankkonto/PlusGiro - Utbetalning via utbetalningskort/Bankgiro - Girering till bankgirokonto/Bankgiro - Kontoinsättning med avisering/Bankgiro - Kontoinsättning utan avisering/Bankgiro - Kontantutbetalning/Bankgiro - Betalning till PlusGironummer/Manuell betalning/Utland, PlusGiro - SWIFT/Utland, PlusGiro - Check/Utland, bankgiro - SWIFT/Utland, bankgiro - Check/KOB/Bankgiro med OCR/Bankgiro med meddelande/Plusgiro med OCR/Plusgiro med meddelande/Kontant/Check/Kontoinsättning/ISO 20022 Utlandsbetalningar',
          DataType: 'Enum',
          EnumValues: new Map([['PLUSGIRO___GIRERING_TILL_PLUSGIROKONTO', 'PlusGiro - Girering till PlusGirokonto'], ['PLUSGIRO___KONTOINSATTNING_TILL_BANKKONTO', 'PlusGiro - Kontoinsättning till bankkonto'], ['PLUSGIRO___UTBETALNING_VIA_UTBETALNINGSKORT', 'PlusGiro - Utbetalning via utbetalningskort'], ['BANKGIRO___GIRERING_TILL_BANKGIROKONTO', 'Bankgiro - Girering till bankgirokonto'], ['BANKGIRO___KONTOINSATTNING_MED_AVISERING', 'Bankgiro - Kontoinsättning med avisering'], ['BANKGIRO___KONTOINSATTNING_UTAN_AVISERING', 'Bankgiro - Kontoinsättning utan avisering'], ['BANKGIRO___KONTANTUTBETALNING', 'Bankgiro - Kontantutbetalning'], ['BANKGIRO___BETALNING_TILL_PLUSGIRONUMMER', 'Bankgiro - Betalning till PlusGironummer'], ['MANUELL_BETALNING', 'Manuell betalning'], ['UTLAND__PLUSGIRO___SWIFT', 'Utland, PlusGiro - SWIFT'], ['UTLAND__PLUSGIRO___CHECK', 'Utland, PlusGiro - Check'], ['UTLAND__BANKGIRO___SWIFT', 'Utland, bankgiro - SWIFT'], ['UTLAND__BANKGIRO___CHECK', 'Utland, bankgiro - Check'], ['KOB', 'KOB'], ['BANKGIRO_MED_OCR', 'Bankgiro med OCR'], ['BANKGIRO_MED_MEDDELANDE', 'Bankgiro med meddelande'], ['PLUSGIRO_MED_OCR', 'Plusgiro med OCR'], ['PLUSGIRO_MED_MEDDELANDE', 'Plusgiro med meddelande'], ['KONTANT_CHECK', 'Kontant/Check'], ['KONTOINSATTNING', 'Kontoinsättning'], ['ISO_20022_UTLANDSBETALNINGAR', 'ISO 20022 Utlandsbetalningar']]),
          EnumSortValues: new Map([['PLUSGIRO___GIRERING_TILL_PLUSGIROKONTO', '21'], ['PLUSGIRO___KONTOINSATTNING_TILL_BANKKONTO', '22'], ['PLUSGIRO___UTBETALNING_VIA_UTBETALNINGSKORT', '23'], ['BANKGIRO___GIRERING_TILL_BANKGIROKONTO', '31'], ['BANKGIRO___KONTOINSATTNING_MED_AVISERING', '32'], ['BANKGIRO___KONTOINSATTNING_UTAN_AVISERING', '33'], ['BANKGIRO___KONTANTUTBETALNING', '34'], ['BANKGIRO___BETALNING_TILL_PLUSGIRONUMMER', '36'], ['MANUELL_BETALNING', '41'], ['UTLAND__PLUSGIRO___SWIFT', '01'], ['UTLAND__PLUSGIRO___CHECK', '04'], ['UTLAND__BANKGIRO___SWIFT', '11'], ['UTLAND__BANKGIRO___CHECK', '12'], ['KOB', '51'], ['BANKGIRO_MED_OCR', '61'], ['BANKGIRO_MED_MEDDELANDE', '62'], ['PLUSGIRO_MED_OCR', '63'], ['PLUSGIRO_MED_MEDDELANDE', '64'], ['KONTANT_CHECK', '65'], ['KONTOINSATTNING', '66'], ['ISO_20022_UTLANDSBETALNINGAR', '67']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PLUSGIRO___GIRERING_TILL_PLUSGIROKONTO=PlusGiro - Girering till PlusGirokonto;PLUSGIRO___KONTOINSATTNING_TILL_BANKKONTO=PlusGiro - Kontoinsättning till bankkonto;PLUSGIRO___UTBETALNING_VIA_UTBETALNINGSKORT=PlusGiro - Utbetalning via utbetalningskort;BANKGIRO___GIRERING_TILL_BANKGIROKONTO=Bankgiro - Girering till bankgirokonto;BANKGIRO___KONTOINSATTNING_MED_AVISERING=Bankgiro - Kontoinsättning med avisering;BANKGIRO___KONTOINSATTNING_UTAN_AVISERING=Bankgiro - Kontoinsättning utan avisering;BANKGIRO___KONTANTUTBETALNING=Bankgiro - Kontantutbetalning;BANKGIRO___BETALNING_TILL_PLUSGIRONUMMER=Bankgiro - Betalning till PlusGironummer;MANUELL_BETALNING=Manuell betalning;UTLAND__PLUSGIRO___SWIFT=Utland, PlusGiro - SWIFT;UTLAND__PLUSGIRO___CHECK=Utland, PlusGiro - Check;UTLAND__BANKGIRO___SWIFT=Utland, bankgiro - SWIFT;UTLAND__BANKGIRO___CHECK=Utland, bankgiro - Check;KOB=KOB;BANKGIRO_MED_OCR=Bankgiro med OCR;BANKGIRO_MED_MEDDELANDE=Bankgiro med meddelande;PLUSGIRO_MED_OCR=Plusgiro med OCR;PLUSGIRO_MED_MEDDELANDE=Plusgiro med meddelande;KONTANT_CHECK=Kontant/Check;KONTOINSATTNING=Kontoinsättning;ISO_20022_UTLANDSBETALNINGAR=ISO 20022 Utlandsbetalningar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        KONTONR: {
          AttributeName: 'KONTONR',
          DisplayLabel: 'Kontonummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        UTBETVAG_ID: {
          AttributeName: 'UTBETVAG_ID',
          DisplayLabel: 'Utbetalningsväg',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        REG_PA_LEV: {
          AttributeName: 'REG_PA_LEV',
          DisplayLabel: 'Registreras på leverantör',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KBLikvidkonto: {
          AttributeName: 'KBLikvidkonto',
          DisplayLabel: 'Likvidkonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Likvidkonto: {
          AttributeName: 'Likvidkonto',
          DisplayLabel: 'Likvidkonto',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BGBank: {
          AttributeName: 'BGBank',
          DisplayLabel: 'BGBank',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BETALNINGSVILLKOR_ID: {
          AttributeName: 'BETALNINGSVILLKOR_ID',
          DisplayLabel: 'Betalningsvillkor, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Utbetalningsvag: {
          AssociationName: 'Utbetalningsvag',
          DisplayLabel: 'Utbetalningsväg',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningsvag',
          AssociatedComponentName: 'Utbetalningsvag',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Likvidkonto: {
          AssociationName: 'Likvidkonto',
          DisplayLabel: 'Likvidkonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Betalningsvillkor: {
          AssociationName: 'Betalningsvillkor',
          DisplayLabel: 'Betalningsvillkor',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBetalningsvillkor',
          AssociatedComponentName: 'Betalningsvillkor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSUtbetalningsvag: {
      CollectionName: 'SYSUtbetalningsvag',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Utbetalningsvag',
        Abstract: false,
        SOLabel: 'Utbetalningsväg',
        SOGLabel: 'Utbetalningsväg',
        SBLabel: 'Utbetalningsvägen',
        SBGLabel: 'Utbetalningsvägen',
        POLabel: 'Utbetalningsvägar',
        POGLabel: 'Utbetalningsvägar',
        PBLabel: 'Utbetalningsvägarna',
        PBGLabel: 'Utbetalningsvägarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utbetalningsvägen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utbetalningsvägen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utbetalningsvägen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utbetalningsvägen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        MEDIATYP: {
          AttributeName: 'MEDIATYP',
          DisplayLabel: 'Typ',
          Hint: 'Fil till PlusGirot (inrikes)/Fil till Bankgirot (inrikes och utrikes)/Manuell betalning/Fil till KOB/Betalningar (ISO 20022)',
          DataType: 'Enum',
          EnumValues: new Map([['FIL_TILL_PLUSGIROT__INRIKES_', 'Fil till PlusGirot (inrikes)'], ['FIL_TILL_BANKGIROT__INRIKES_OCH_UTRIKES_', 'Fil till Bankgirot (inrikes och utrikes)'], ['MANUELL_BETALNING', 'Manuell betalning'], ['FIL_TILL_KOB', 'Fil till KOB'], ['BETALNINGAR__ISO_20022_', 'Betalningar (ISO 20022)']]),
          EnumSortValues: new Map([['FIL_TILL_PLUSGIROT__INRIKES_', 'PGI'], ['FIL_TILL_BANKGIROT__INRIKES_OCH_UTRIKES_', 'BGI'], ['MANUELL_BETALNING', 'MB'], ['FIL_TILL_KOB', 'KOB'], ['BETALNINGAR__ISO_20022_', 'BIS']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FIL_TILL_PLUSGIROT__INRIKES_=Fil till PlusGirot (inrikes);FIL_TILL_BANKGIROT__INRIKES_OCH_UTRIKES_=Fil till Bankgirot (inrikes och utrikes);MANUELL_BETALNING=Manuell betalning;FIL_TILL_KOB=Fil till KOB;BETALNINGAR__ISO_20022_=Betalningar (ISO 20022)"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        KUNDNR: {
          AttributeName: 'KUNDNR',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        PG_AVSANDARBETECKNING_1: {
          AttributeName: 'PG_AVSANDARBETECKNING_1',
          DisplayLabel: 'Rad 1 på girerings/utbetalningskort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 27,
        },
        PG_AVSANDARBETECKNING_2: {
          AttributeName: 'PG_AVSANDARBETECKNING_2',
          DisplayLabel: 'Rad 2 på girerings/utbetalningskort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 27,
        },
        BETALNING_AV_FAKTURA: {
          AttributeName: 'BETALNING_AV_FAKTURA',
          DisplayLabel: 'Betalning av faktura',
          Hint: 'Betala på förfallodag/Ange betalningsdag vid utbetalning',
          DataType: 'Enum',
          EnumValues: new Map([['BETALA_PA_FORFALLODAG', 'Betala på förfallodag'], ['ANGE_BETALNINGSDAG_VID_UTBETALNING', 'Ange betalningsdag vid utbetalning']]),
          EnumSortValues: new Map([['BETALA_PA_FORFALLODAG', 'F'], ['ANGE_BETALNINGSDAG_VID_UTBETALNING', 'M']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BETALA_PA_FORFALLODAG=Betala på förfallodag;ANGE_BETALNINGSDAG_VID_UTBETALNING=Ange betalningsdag vid utbetalning"',
          GUIEditable: true,
        },
        ANV_VALUTAFICKA: {
          AttributeName: 'ANV_VALUTAFICKA',
          DisplayLabel: 'Använd valutaficka',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        SAME_DAY_EXECUTION: {
          AttributeName: 'SAME_DAY_EXECUTION',
          DisplayLabel: 'Same day execution',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        PG_AVSANDARBETECKNING_3: {
          AttributeName: 'PG_AVSANDARBETECKNING_3',
          DisplayLabel: 'Rad 3 på girerings/utbetalningskort utland',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
        },
        PG_ORGNR: {
          AttributeName: 'PG_ORGNR',
          DisplayLabel: 'Avsändarens organisationsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 10,
        },
        BG_BANK: {
          AttributeName: 'BG_BANK',
          DisplayLabel: 'Bank',
          Hint: 'Swedbank/SEB',
          DataType: 'Enum',
          EnumValues: new Map([['SWEDBANK', 'Swedbank'], ['SEB', 'SEB']]),
          EnumSortValues: new Map([['SWEDBANK', 'Föreningssparbanken'], ['SEB', 'SEB']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SWEDBANK=Swedbank;SEB=SEB"',
          GUIEditable: true,
        },
        BG_AVS_NAMN: {
          AttributeName: 'BG_AVS_NAMN',
          DisplayLabel: 'Avsändarnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 22,
        },
        BG_AVS_ADRESS: {
          AttributeName: 'BG_AVS_ADRESS',
          DisplayLabel: 'Avsändaradress, bankgirot',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        NORMALUTBVAG: {
          AttributeName: 'NORMALUTBVAG',
          DisplayLabel: 'Normal utbetalningsväg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BETALNING_KATALOG: {
          AttributeName: 'BETALNING_KATALOG',
          DisplayLabel: 'Katalog för betalningsfil',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KVITTENS_KATALOG: {
          AttributeName: 'KVITTENS_KATALOG',
          DisplayLabel: 'Katalog för kvittens av betalning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        BETALNING_FRAN_KOB_KATALOG: {
          AttributeName: 'BETALNING_FRAN_KOB_KATALOG',
          DisplayLabel: 'Katalog för utförda betalningar från kob',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KalkBetalningKatalog: {
          AttributeName: 'KalkBetalningKatalog',
          DisplayLabel: 'Katalog för utbetalningsfil',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KalkKvittensKatalog: {
          AttributeName: 'KalkKvittensKatalog',
          DisplayLabel: 'Katalog för kvittens av betalning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KalkBetalningFranKobKatalog: {
          AttributeName: 'KalkBetalningFranKobKatalog',
          DisplayLabel: 'Katalog för utförda betalningar från Kob',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ATERREDOVISNING_KATALOG: {
          AttributeName: 'ATERREDOVISNING_KATALOG',
          DisplayLabel: 'Katalog för återredovisning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKF_GRUPP_ID: {
          AttributeName: 'BOKF_GRUPP_ID',
          DisplayLabel: 'Bokfgrupp id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATERRED: {
          AttributeName: 'ATERRED',
          DisplayLabel: 'Återredovisning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        IDKOD: {
          AttributeName: 'IDKOD',
          DisplayLabel: 'IDKOD',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KalkAterredovisnKatalog: {
          AttributeName: 'KalkAterredovisnKatalog',
          DisplayLabel: 'Katalog för återredovisning av betalningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TECKENKODNING: {
          AttributeName: 'TECKENKODNING',
          DisplayLabel: 'Teckenkodning',
          Hint: 'Enligt standard/UTF-8/Windows-1252 (ISO8859-1)/Codepage 850',
          DataType: 'Enum',
          EnumValues: new Map([['ENLIGT_STANDARD', 'Enligt standard'], ['UTF_8', 'UTF-8'], ['WINDOWS_1252__ISO8859_1_', 'Windows-1252 (ISO8859-1)'], ['CODEPAGE_850', 'Codepage 850']]),
          EnumSortValues: new Map([['ENLIGT_STANDARD', 'S'], ['UTF_8', 'U'], ['WINDOWS_1252__ISO8859_1_', 'I'], ['CODEPAGE_850', 'P']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENLIGT_STANDARD=Enligt standard;UTF_8=UTF-8;WINDOWS_1252__ISO8859_1_=Windows-1252 (ISO8859-1);CODEPAGE_850=Codepage 850"',
        },
        KONTONR: {
          AttributeName: 'KONTONR',
          DisplayLabel: 'Gironr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TypBen: {
          AttributeName: 'TypBen',
          DisplayLabel: 'Typ och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SamordnadKredithantering: {
          AttributeName: 'SamordnadKredithantering',
          DisplayLabel: 'Samordnad kredithantering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BIS_BANK: {
          AttributeName: 'BIS_BANK',
          DisplayLabel: 'Utbetalning skickas via',
          Hint: 'Danske Bank/Handelsbanken/Nordea/SEB/Swedbank',
          DataType: 'Enum',
          EnumValues: new Map([['DANSKE_BANK', 'Danske Bank'], ['HANDELSBANKEN', 'Handelsbanken'], ['NORDEA', 'Nordea'], ['SEB', 'SEB'], ['SWEDBANK', 'Swedbank']]),
          EnumSortValues: new Map([['DANSKE_BANK', 'DB'], ['HANDELSBANKEN', 'HB'], ['NORDEA', 'NO'], ['SEB', 'SB'], ['SWEDBANK', 'SW']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="DANSKE_BANK=Danske Bank;HANDELSBANKEN=Handelsbanken;NORDEA=Nordea;SEB=SEB;SWEDBANK=Swedbank"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BIS_AVTALSNR: {
          AttributeName: 'BIS_AVTALSNR',
          DisplayLabel: 'Avtalsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BIS_BBAN: {
          AttributeName: 'BIS_BBAN',
          DisplayLabel: 'Bban/bankkontonr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 35,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BIS_SIGNER_ID: {
          AttributeName: 'BIS_SIGNER_ID',
          DisplayLabel: 'Signer ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Utbetalningssatt: {
          AssociationName: 'Utbetalningssatt',
          DisplayLabel: 'Utbetalningssätt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUtbetalningssatt',
          AssociatedComponentName: 'Utbetalningssatt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    SYSValuta: {
      CollectionName: 'SYSValuta',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Valuta',
        Abstract: false,
        SOLabel: 'Valuta',
        SOGLabel: 'Valuta',
        SBLabel: 'Valutan',
        SBGLabel: 'Valutan',
        POLabel: 'Valutor',
        POGLabel: 'Valutor',
        PBLabel: 'Valutorna',
        PBGLabel: 'Valutorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Valutan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Valutan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Valutan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Valutan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VALUTAKOD: {
          AttributeName: 'VALUTAKOD',
          DisplayLabel: 'Valutakod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        FASTKURS: {
          AttributeName: 'FASTKURS',
          DisplayLabel: 'Fast kurs',
          Hint: 'Flytande/Fast',
          DataType: 'Enum',
          EnumValues: new Map([['FLYTANDE', 'Flytande'], ['FAST', 'Fast']]),
          EnumSortValues: new Map([['FLYTANDE', 'N'], ['FAST', 'Y']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FLYTANDE=Flytande;FAST=Fast"',
          GUIEditable: true,
        },
        KURSFAKTOR: {
          AttributeName: 'KURSFAKTOR',
          DisplayLabel: 'Kursfaktor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          Required: true,
        },
        FastFlytandeKurs: {
          AttributeName: 'FastFlytandeKurs',
          DisplayLabel: 'Fastkurs',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KBValutaDiffKonto: {
          AttributeName: 'KBValutaDiffKonto',
          DisplayLabel: 'KBValutaDiffKonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ValutaDiffKonto: {
          AttributeName: 'ValutaDiffKonto',
          DisplayLabel: 'Konto för valutadifferenser',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['NO_CONDITION', 'Y;']]),
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'KodBenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENAST_HAMTADE_KURSDATUM: {
          AttributeName: 'SENAST_HAMTADE_KURSDATUM',
          DisplayLabel: 'Kurser hämtade, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KanHamtasAutomatiskt: {
          AttributeName: 'KanHamtasAutomatiskt',
          DisplayLabel: 'Kurs kan hämtas hos Riksbanken',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
      },
      Associations: {
        ValutaDiffKonto: {
          AssociationName: 'ValutaDiffKonto',
          DisplayLabel: 'Konto för valutadifferenser',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kurs: {
          AssociationName: 'Kurs',
          DisplayLabel: 'Kurs',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSKurs',
          AssociatedComponentName: 'Kurs',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Land: {
          AssociationName: 'Land',
          DisplayLabel: 'Land',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSLand',
          AssociatedComponentName: 'Land',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Leverantor: {
          AssociationName: 'Leverantor',
          DisplayLabel: 'Leverantor',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default SYS;
